var Qa = Object.defineProperty, Za = Object.defineProperties;
var es = Object.getOwnPropertyDescriptors;
var vt = Object.getOwnPropertySymbols;
var Mn = Object.prototype.hasOwnProperty, kn = Object.prototype.propertyIsEnumerable;
var ir = (t, e, r) => e in t ? Qa(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, I = (t, e) => {
  for (var r in e || (e = {}))
    Mn.call(e, r) && ir(t, r, e[r]);
  if (vt)
    for (var r of vt(e))
      kn.call(e, r) && ir(t, r, e[r]);
  return t;
}, U = (t, e) => Za(t, es(e));
var or = (t, e) => {
  var r = {};
  for (var n in t)
    Mn.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && vt)
    for (var n of vt(t))
      e.indexOf(n) < 0 && kn.call(t, n) && (r[n] = t[n]);
  return r;
};
var S = (t, e, r) => ir(t, typeof e != "symbol" ? e + "" : e, r);
var z = (t, e, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(t, e)).next());
});
function ts(t, e, r) {
  try {
    if (!(e in t))
      return () => {
      };
    const n = t[e], i = r(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), t[e] = i, () => {
      t[e] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
function rs(t) {
  if (!t || !t.outerHTML)
    return "";
  let e = "";
  for (; t.parentElement; ) {
    let r = t.localName;
    if (!r)
      break;
    r = r.toLowerCase();
    let n = t.parentElement, i = [];
    if (n.children && n.children.length > 0)
      for (let o = 0; o < n.children.length; o++) {
        let a = n.children[o];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === r && i.push(a);
      }
    i.length > 1 && (r += ":eq(" + i.indexOf(t) + ")"), e = r + (e ? ">" + e : ""), t = n;
  }
  return e;
}
function Hr(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ro(t, e) {
  if (e === 0)
    return !0;
  const r = Object.keys(t);
  for (const n of r)
    if (Hr(t[n]) && ro(t[n], e - 1))
      return !0;
  return !1;
}
function ar(t, e) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, e);
  const n = [], i = [];
  return JSON.stringify(t, function(u, c) {
    if (n.length > 0) {
      const s = n.indexOf(this);
      ~s ? n.splice(s + 1) : n.push(this), ~s ? i.splice(s, 1 / 0, u) : i.push(u), ~n.indexOf(c) && (n[0] === c ? c = "[Circular ~]" : c = "[Circular ~." + i.slice(0, n.indexOf(c)).join(".") + "]");
    } else
      n.push(c);
    if (c == null)
      return c;
    if (o(c))
      return a(c);
    if (c instanceof Event) {
      const s = {};
      for (const l in c) {
        const f = c[l];
        Array.isArray(f) ? s[l] = rs(
          f.length ? f[0] : null
        ) : s[l] = f;
      }
      return s;
    } else {
      if (c instanceof Node)
        return c instanceof HTMLElement ? c ? c.outerHTML : "" : c.nodeName;
      if (c instanceof Error)
        return c.name + ": " + c.message;
    }
    return c;
  });
  function o(u) {
    return Hr(u) && Object.keys(u).length > r.numOfKeysLimit || typeof u == "function" ? !0 : u instanceof Event && u.isTrusted === !1 ? Object.keys(u).length === 1 : !!(Hr(u) && ro(u, r.depthOfLimit));
  }
  function a(u) {
    let c = u.toString();
    return r.stringLengthLimit && c.length > r.stringLengthLimit && (c = `${c.slice(0, r.stringLengthLimit)}...`), c;
  }
}
function ns() {
  var t = document.createElement("canvas");
  return t.getContext && t.getContext("2d") ? t.toDataURL("image/webp").indexOf("data:image/webp") == 0 : !1;
}
function mg() {
  return ns() ? {
    type: "image/webp",
    quality: 0.9
  } : {
    type: "image/jpeg",
    quality: 0.6
  };
}
var no = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function io(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var oo = { exports: {} }, sr = { exports: {} }, Dn;
function is() {
  return Dn || (Dn = 1, function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(no, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(p) {
        if (p)
          for (var y = 0; y < l.length; y++)
            p[l[y]] !== void 0 && this["set" + n(l[y])](p[l[y]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", y = this.getLineNumber() || "", g = this.getColumnNumber() || "", b = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + y + ":" + g + ")" : "[eval]:" + y + ":" + g : b ? b + " (" + p + ":" + y + ":" + g + ")" : p + ":" + y + ":" + g;
        }
      }, f.fromString = function(y) {
        var g = y.indexOf("("), b = y.lastIndexOf(")"), L = y.substring(0, g), C = y.substring(g + 1, b).split(","), B = y.substring(b + 1);
        if (B.indexOf("@") === 0)
          var G = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(B, ""), pt = G[1], Be = G[2], M = G[3];
        return new f({
          functionName: L,
          args: C || void 0,
          fileName: pt,
          lineNumber: Be || void 0,
          columnNumber: M || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(y) {
            this[p] = !!y;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + n(a[h])] = i(a[h]), f.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(y) {
            if (!r(y))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(y);
          };
        }(a[h]);
      for (var v = 0; v < u.length; v++)
        f.prototype["get" + n(u[v])] = i(u[v]), f.prototype["set" + n(u[v])] = /* @__PURE__ */ function(p) {
          return function(y) {
            this[p] = String(y);
          };
        }(u[v]);
      return f;
    });
  }(sr)), sr.exports;
}
(function(t, e) {
  (function(r, n) {
    t.exports = n(is());
  })(no, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), v = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, y = ["eval", "<anonymous>"].indexOf(v[0]) > -1 ? void 0 : v[0];
          return new n({
            functionName: p,
            fileName: y,
            lineNumber: v[1],
            columnNumber: v[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, v = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: h,
            fileName: v[0],
            lineNumber: v[1],
            columnNumber: v[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var v = s.exec(l[d]);
          v && f.push(new n({
            fileName: v[2],
            lineNumber: v[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var v = s.exec(l[d]);
          v && f.push(
            new n({
              functionName: v[3] || void 0,
              fileName: v[2],
              lineNumber: v[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", v = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var y = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: v,
            args: y,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(oo);
var os = oo.exports;
const Un = /* @__PURE__ */ io(os);
function Fr(t) {
  try {
    return Un.parse(t);
  } catch (e) {
    try {
      return Un.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: e,
        secondaryError: r
      }), [];
    }
  }
}
function as(t, e) {
  const r = e.logger;
  let n;
  n = window[r];
  const i = [];
  if (e.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = Fr(s));
      const f = [
        ar(c, e.stringifyOptions)
      ];
      t({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of e.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? ts(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        const l = Fr(new Error()), f = e.serializeConsoleAttributes ? s.map(
          (d) => typeof d == "object" ? ar(d, e.stringifyOptions) : d
        ) : s.filter((d) => typeof d != "object").map((d) => `${d}`);
        t({
          type: u,
          trace: l.slice(1),
          value: f,
          attributes: ar(
            s.filter((d) => typeof d == "object").reduce((d, h) => I(I({}, d), h), {}),
            e.stringifyOptions
          ),
          time: Date.now()
        });
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
var Gr = { exports: {} };
(function(t, e) {
  e = t.exports = r, e.getSerialize = n;
  function r(i, o, a, u) {
    return JSON.stringify(i, n(o, u), a);
  }
  function n(i, o) {
    var a = [], u = [];
    return o == null && (o = function(c, s) {
      return a[0] === s ? "[Circular ~]" : "[Circular ~." + u.slice(0, a.indexOf(s)).join(".") + "]";
    }), function(c, s) {
      if (a.length > 0) {
        var l = a.indexOf(this);
        ~l ? a.splice(l + 1) : a.push(this), ~l ? u.splice(l, 1 / 0, c) : u.push(c), ~a.indexOf(s) && (s = o.call(this, c, s));
      } else a.push(s);
      return i == null ? s : i.call(this, c, s);
    };
  }
})(Gr, Gr.exports);
var ss = Gr.exports;
const Dt = /* @__PURE__ */ io(ss);
function ur(t, e, r, n) {
  var u, c, s, l;
  let i = Fr(n != null ? n : e), o = {};
  e instanceof Error && (e = e.message, e.cause && (o = { "exception.cause": e.cause }));
  const a = cs(i);
  t({
    event: Dt(e),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (u = a[0]) != null && u.lineNumber ? (c = a[0]) == null ? void 0 : c.lineNumber : 0,
    columnNumber: (s = a[0]) != null && s.columnNumber ? (l = a[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: a,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: o ? Dt(o) : void 0
  });
}
const us = (t, { enablePromisePatch: e }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, l) => {
    ur(t, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? ur(
        t,
        a.reason,
        a.type,
        u.getStack()
      ) : ur(t, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      S(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return e && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, cs = (t) => {
  var r, n;
  if (t.length === 0)
    return t;
  const e = t[0];
  return (r = e.fileName) != null && r.includes("highlight.run") || (n = e.fileName) != null && n.includes("highlight.io") || e.functionName === "new highlightPromise" ? t.slice(1) : t;
}, Bn = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Hn = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var ls = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ye = "1.9.0", Fn = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function fs(t) {
  var e = /* @__PURE__ */ new Set([t]), r = /* @__PURE__ */ new Set(), n = t.match(Fn);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === t;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return e.add(u), !0;
  }
  return function(c) {
    if (e.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(Fn);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var ds = fs(ye), hs = ye.split(".")[0], rt = Symbol.for("opentelemetry.js.api." + hs), nt = ls;
function ct(t, e, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = nt[rt] = (i = nt[rt]) !== null && i !== void 0 ? i : {
    version: ye
  };
  if (!n && o[t]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + t);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== ye) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + t + " does not match previously registered API v" + ye);
    return r.error(a.stack || a.message), !1;
  }
  return o[t] = e, r.debug("@opentelemetry/api: Registered a global for " + t + " v" + ye + "."), !0;
}
function Ee(t) {
  var e, r, n = (e = nt[rt]) === null || e === void 0 ? void 0 : e.version;
  if (!(!n || !ds(n)))
    return (r = nt[rt]) === null || r === void 0 ? void 0 : r[t];
}
function lt(t, e) {
  e.debug("@opentelemetry/api: Unregistering a global for " + t + " v" + ye + ".");
  var r = nt[rt];
  r && delete r[t];
}
var ps = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _s = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, vs = (
  /** @class */
  function() {
    function t(e) {
      this._namespace = e.namespace || "DiagComponentLogger";
    }
    return t.prototype.debug = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return Fe("debug", this._namespace, e);
    }, t.prototype.error = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return Fe("error", this._namespace, e);
    }, t.prototype.info = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return Fe("info", this._namespace, e);
    }, t.prototype.warn = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return Fe("warn", this._namespace, e);
    }, t.prototype.verbose = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return Fe("verbose", this._namespace, e);
    }, t;
  }()
);
function Fe(t, e, r) {
  var n = Ee("diag");
  if (n)
    return r.unshift(e), n[t].apply(n, _s([], ps(r), !1));
}
var P;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.ERROR = 30] = "ERROR", t[t.WARN = 50] = "WARN", t[t.INFO = 60] = "INFO", t[t.DEBUG = 70] = "DEBUG", t[t.VERBOSE = 80] = "VERBOSE", t[t.ALL = 9999] = "ALL";
})(P || (P = {}));
function gs(t, e) {
  t < P.NONE ? t = P.NONE : t > P.ALL && (t = P.ALL), e = e || {};
  function r(n, i) {
    var o = e[n];
    return typeof o == "function" && t >= i ? o.bind(e) : function() {
    };
  }
  return {
    error: r("error", P.ERROR),
    warn: r("warn", P.WARN),
    info: r("info", P.INFO),
    debug: r("debug", P.DEBUG),
    verbose: r("verbose", P.VERBOSE)
  };
}
var ys = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ms = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Es = "diag", re = (
  /** @class */
  function() {
    function t() {
      function e(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Ee("diag");
          if (u)
            return u[i].apply(u, ms([], ys(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: P.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Ee("diag"), f = gs((u = o.logLevel) !== null && u !== void 0 ? u : P.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return ct("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        lt(Es, r);
      }, r.createComponentLogger = function(i) {
        return new vs(i);
      }, r.verbose = e("verbose"), r.debug = e("debug"), r.info = e("info"), r.warn = e("warn"), r.error = e("error");
    }
    return t.instance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t;
  }()
), Ts = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ss = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ws = (
  /** @class */
  function() {
    function t(e) {
      this._entries = e ? new Map(e) : /* @__PURE__ */ new Map();
    }
    return t.prototype.getEntry = function(e) {
      var r = this._entries.get(e);
      if (r)
        return Object.assign({}, r);
    }, t.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(e) {
        var r = Ts(e, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, t.prototype.setEntry = function(e, r) {
      var n = new t(this._entries);
      return n._entries.set(e, r), n;
    }, t.prototype.removeEntry = function(e) {
      var r = new t(this._entries);
      return r._entries.delete(e), r;
    }, t.prototype.removeEntries = function() {
      for (var e, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new t(this._entries);
      try {
        for (var a = Ss(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        e = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (e) throw e.error;
        }
      }
      return o;
    }, t.prototype.clear = function() {
      return new t();
    }, t;
  }()
), bs = Symbol("BaggageEntryMetadata"), Os = re.instance();
function As(t) {
  return t === void 0 && (t = {}), new ws(new Map(Object.entries(t)));
}
function Rs(t) {
  return typeof t != "string" && (Os.error("Cannot create baggage metadata from unknown type: " + typeof t), t = ""), {
    __TYPE__: bs,
    toString: function() {
      return t;
    }
  };
}
function pn(t) {
  return Symbol.for(t);
}
var Ns = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      var r = this;
      r._currentContext = e ? new Map(e) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new t(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new t(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return t;
  }()
), _e = new Ns(), Oe = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ls = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.createGauge = function(e, r) {
      return Bs;
    }, t.prototype.createHistogram = function(e, r) {
      return Hs;
    }, t.prototype.createCounter = function(e, r) {
      return Us;
    }, t.prototype.createUpDownCounter = function(e, r) {
      return Fs;
    }, t.prototype.createObservableGauge = function(e, r) {
      return js;
    }, t.prototype.createObservableCounter = function(e, r) {
      return Gs;
    }, t.prototype.createObservableUpDownCounter = function(e, r) {
      return Vs;
    }, t.prototype.addBatchObservableCallback = function(e, r) {
    }, t.prototype.removeBatchObservableCallback = function(e) {
    }, t;
  }()
), Xt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), Is = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n) {
    }, e;
  }(Xt)
), Ps = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n) {
    }, e;
  }(Xt)
), Cs = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n) {
    }, e;
  }(Xt)
), xs = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n) {
    }, e;
  }(Xt)
), _n = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.addCallback = function(e) {
    }, t.prototype.removeCallback = function(e) {
    }, t;
  }()
), Ms = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(_n)
), ks = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(_n)
), Ds = (
  /** @class */
  function(t) {
    Oe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(_n)
), ao = new Ls(), Us = new Is(), Bs = new Cs(), Hs = new xs(), Fs = new Ps(), Gs = new Ms(), js = new ks(), Vs = new Ds();
function $s() {
  return ao;
}
var de;
(function(t) {
  t[t.INT = 0] = "INT", t[t.DOUBLE = 1] = "DOUBLE";
})(de || (de = {}));
var zs = {
  get: function(t, e) {
    if (t != null)
      return t[e];
  },
  keys: function(t) {
    return t == null ? [] : Object.keys(t);
  }
}, Xs = {
  set: function(t, e, r) {
    t != null && (t[e] = r);
  }
}, qs = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ws = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Ys = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.active = function() {
      return _e;
    }, t.prototype.with = function(e, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, Ws([n], qs(i), !1));
    }, t.prototype.bind = function(e, r) {
      return r;
    }, t.prototype.enable = function() {
      return this;
    }, t.prototype.disable = function() {
      return this;
    }, t;
  }()
), Ks = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Js = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, cr = "context", Qs = new Ys(), qt = (
  /** @class */
  function() {
    function t() {
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalContextManager = function(e) {
      return ct(cr, e, re.instance());
    }, t.prototype.active = function() {
      return this._getContextManager().active();
    }, t.prototype.with = function(e, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Js([e, r, n], Ks(o), !1));
    }, t.prototype.bind = function(e, r) {
      return this._getContextManager().bind(e, r);
    }, t.prototype._getContextManager = function() {
      return Ee(cr) || Qs;
    }, t.prototype.disable = function() {
      this._getContextManager().disable(), lt(cr, re.instance());
    }, t;
  }()
), se;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.SAMPLED = 1] = "SAMPLED";
})(se || (se = {}));
var so = "0000000000000000", uo = "00000000000000000000000000000000", co = {
  traceId: uo,
  spanId: so,
  traceFlags: se.NONE
}, Je = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = co), this._spanContext = e;
    }
    return t.prototype.spanContext = function() {
      return this._spanContext;
    }, t.prototype.setAttribute = function(e, r) {
      return this;
    }, t.prototype.setAttributes = function(e) {
      return this;
    }, t.prototype.addEvent = function(e, r) {
      return this;
    }, t.prototype.addLink = function(e) {
      return this;
    }, t.prototype.addLinks = function(e) {
      return this;
    }, t.prototype.setStatus = function(e) {
      return this;
    }, t.prototype.updateName = function(e) {
      return this;
    }, t.prototype.end = function(e) {
    }, t.prototype.isRecording = function() {
      return !1;
    }, t.prototype.recordException = function(e, r) {
    }, t;
  }()
), vn = pn("OpenTelemetry Context Key SPAN");
function gn(t) {
  return t.getValue(vn) || void 0;
}
function Zs() {
  return gn(qt.getInstance().active());
}
function yn(t, e) {
  return t.setValue(vn, e);
}
function eu(t) {
  return t.deleteValue(vn);
}
function tu(t, e) {
  return yn(t, new Je(e));
}
function lo(t) {
  var e;
  return (e = gn(t)) === null || e === void 0 ? void 0 : e.spanContext();
}
var ru = /^([0-9a-f]{32})$/i, nu = /^[0-9a-f]{16}$/i;
function fo(t) {
  return ru.test(t) && t !== uo;
}
function iu(t) {
  return nu.test(t) && t !== so;
}
function Wt(t) {
  return fo(t.traceId) && iu(t.spanId);
}
function ou(t) {
  return new Je(t);
}
var lr = qt.getInstance(), ho = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.startSpan = function(e, r, n) {
      n === void 0 && (n = lr.active());
      var i = !!(r != null && r.root);
      if (i)
        return new Je();
      var o = n && lo(n);
      return au(o) && Wt(o) ? new Je(o) : new Je();
    }, t.prototype.startActiveSpan = function(e, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : lr.active(), s = this.startSpan(e, o, c), l = yn(c, s);
        return lr.with(l, u, void 0, s);
      }
    }, t;
  }()
);
function au(t) {
  return typeof t == "object" && typeof t.spanId == "string" && typeof t.traceId == "string" && typeof t.traceFlags == "number";
}
var su = new ho(), uu = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this._provider = e, this.name = r, this.version = n, this.options = i;
    }
    return t.prototype.startSpan = function(e, r, n) {
      return this._getTracer().startSpan(e, r, n);
    }, t.prototype.startActiveSpan = function(e, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, t.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : su;
    }, t;
  }()
), cu = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getTracer = function(e, r, n) {
      return new ho();
    }, t;
  }()
), lu = new cu(), Gn = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getTracer = function(e, r, n) {
      var i;
      return (i = this.getDelegateTracer(e, r, n)) !== null && i !== void 0 ? i : new uu(this, e, r, n);
    }, t.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : lu;
    }, t.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, t.prototype.getDelegateTracer = function(e, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(e, r, n);
    }, t;
  }()
), Ut;
(function(t) {
  t[t.NOT_RECORD = 0] = "NOT_RECORD", t[t.RECORD = 1] = "RECORD", t[t.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ut || (Ut = {}));
var it;
(function(t) {
  t[t.INTERNAL = 0] = "INTERNAL", t[t.SERVER = 1] = "SERVER", t[t.CLIENT = 2] = "CLIENT", t[t.PRODUCER = 3] = "PRODUCER", t[t.CONSUMER = 4] = "CONSUMER";
})(it || (it = {}));
var jr;
(function(t) {
  t[t.UNSET = 0] = "UNSET", t[t.OK = 1] = "OK", t[t.ERROR = 2] = "ERROR";
})(jr || (jr = {}));
var A = qt.getInstance(), m = re.instance(), fu = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMeter = function(e, r, n) {
      return ao;
    }, t;
  }()
), du = new fu(), fr = "metrics", hu = (
  /** @class */
  function() {
    function t() {
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalMeterProvider = function(e) {
      return ct(fr, e, re.instance());
    }, t.prototype.getMeterProvider = function() {
      return Ee(fr) || du;
    }, t.prototype.getMeter = function(e, r, n) {
      return this.getMeterProvider().getMeter(e, r, n);
    }, t.prototype.disable = function() {
      lt(fr, re.instance());
    }, t;
  }()
), ft = hu.getInstance(), pu = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r) {
    }, t.prototype.extract = function(e, r) {
      return e;
    }, t.prototype.fields = function() {
      return [];
    }, t;
  }()
), mn = pn("OpenTelemetry Baggage Key");
function po(t) {
  return t.getValue(mn) || void 0;
}
function _u() {
  return po(qt.getInstance().active());
}
function vu(t, e) {
  return t.setValue(mn, e);
}
function gu(t) {
  return t.deleteValue(mn);
}
var dr = "propagation", yu = new pu(), mu = (
  /** @class */
  function() {
    function t() {
      this.createBaggage = As, this.getBaggage = po, this.getActiveBaggage = _u, this.setBaggage = vu, this.deleteBaggage = gu;
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalPropagator = function(e) {
      return ct(dr, e, re.instance());
    }, t.prototype.inject = function(e, r, n) {
      return n === void 0 && (n = Xs), this._getGlobalPropagator().inject(e, r, n);
    }, t.prototype.extract = function(e, r, n) {
      return n === void 0 && (n = zs), this._getGlobalPropagator().extract(e, r, n);
    }, t.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, t.prototype.disable = function() {
      lt(dr, re.instance());
    }, t.prototype._getGlobalPropagator = function() {
      return Ee(dr) || yu;
    }, t;
  }()
), X = mu.getInstance(), hr = "trace", Eu = (
  /** @class */
  function() {
    function t() {
      this._proxyTracerProvider = new Gn(), this.wrapSpanContext = ou, this.isSpanContextValid = Wt, this.deleteSpan = eu, this.getSpan = gn, this.getActiveSpan = Zs, this.getSpanContext = lo, this.setSpan = yn, this.setSpanContext = tu;
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalTracerProvider = function(e) {
      var r = ct(hr, this._proxyTracerProvider, re.instance());
      return r && this._proxyTracerProvider.setDelegate(e), r;
    }, t.prototype.getTracerProvider = function() {
      return Ee(hr) || this._proxyTracerProvider;
    }, t.prototype.getTracer = function(e, r) {
      return this.getTracerProvider().getTracer(e, r);
    }, t.prototype.disable = function() {
      lt(hr, re.instance()), this._proxyTracerProvider = new Gn();
    }, t;
  }()
), R = Eu.getInstance(), _o = pn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function vo(t) {
  return t.setValue(_o, !0);
}
function En(t) {
  return t.getValue(_o) === !0;
}
var Tu = "=", Vr = ";", $r = ",", pr = "baggage", Su = 180, wu = 4096, bu = 8192, Ou = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Au(t) {
  return t.reduce(function(e, r) {
    var n = "" + e + (e !== "" ? $r : "") + r;
    return n.length > bu ? e : n;
  }, "");
}
function Ru(t) {
  return t.getAllEntries().map(function(e) {
    var r = Ou(e, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Vr + i.metadata.toString()), o;
  });
}
function Nu(t) {
  var e = t.split(Vr);
  if (!(e.length <= 0)) {
    var r = e.shift();
    if (r) {
      var n = r.indexOf(Tu);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return e.length > 0 && (a = Rs(e.join(Vr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var go = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r, n) {
      var i = X.getBaggage(e);
      if (!(!i || En(e))) {
        var o = Ru(i).filter(function(u) {
          return u.length <= wu;
        }).slice(0, Su), a = Au(o);
        a.length > 0 && n.set(r, pr, a);
      }
    }, t.prototype.extract = function(e, r, n) {
      var i = n.get(r, pr), o = Array.isArray(i) ? i.join($r) : i;
      if (!o)
        return e;
      var a = {};
      if (o.length === 0)
        return e;
      var u = o.split($r);
      return u.forEach(function(c) {
        var s = Nu(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? e : X.setBaggage(e, X.createBaggage(a));
    }, t.prototype.fields = function() {
      return [pr];
    }, t;
  }()
), yo = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Lu = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function It(t) {
  var e, r, n = {};
  if (typeof t != "object" || t == null)
    return n;
  try {
    for (var i = yo(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
      var a = Lu(o.value, 2), u = a[0], c = a[1];
      if (!Iu(u)) {
        m.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!mo(c)) {
        m.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    e = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function Iu(t) {
  return typeof t == "string" && t.length > 0;
}
function mo(t) {
  return t == null ? !0 : Array.isArray(t) ? Pu(t) : Eo(t);
}
function Pu(t) {
  var e, r, n;
  try {
    for (var i = yo(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Eo(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return !0;
}
function Eo(t) {
  switch (typeof t) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Cu() {
  return function(t) {
    m.error(xu(t));
  };
}
function xu(t) {
  return typeof t == "string" ? t : JSON.stringify(Mu(t));
}
function Mu(t) {
  for (var e = {}, r = t; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!e[n]) {
        var i = r[n];
        i && (e[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return e;
}
var ku = Cu();
function he(t) {
  try {
    ku(t);
  } catch (e) {
  }
}
var ee;
(function(t) {
  t.AlwaysOff = "always_off", t.AlwaysOn = "always_on", t.ParentBasedAlwaysOff = "parentbased_always_off", t.ParentBasedAlwaysOn = "parentbased_always_on", t.ParentBasedTraceIdRatio = "parentbased_traceidratio", t.TraceIdRatio = "traceidratio";
})(ee || (ee = {}));
var Du = ",", Uu = ["OTEL_SDK_DISABLED"];
function Bu(t) {
  return Uu.indexOf(t) > -1;
}
var Hu = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Fu(t) {
  return Hu.indexOf(t) > -1;
}
var Gu = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function ju(t) {
  return Gu.indexOf(t) > -1;
}
var Pt = 1 / 0, Ct = 128, Vu = 128, $u = 128, To = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: P.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Pt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Pt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Pt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Vu,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: $u,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: ee.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function zu(t, e, r) {
  if (typeof r[t] != "undefined") {
    var n = String(r[t]);
    e[t] = n.toLowerCase() === "true";
  }
}
function Xu(t, e, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[t] != "undefined") {
    var o = Number(r[t]);
    isNaN(o) || (o < n ? e[t] = n : o > i ? e[t] = i : e[t] = o);
  }
}
function qu(t, e, r, n) {
  n === void 0 && (n = Du);
  var i = r[t];
  typeof i == "string" && (e[t] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Wu = {
  ALL: P.ALL,
  VERBOSE: P.VERBOSE,
  DEBUG: P.DEBUG,
  INFO: P.INFO,
  WARN: P.WARN,
  ERROR: P.ERROR,
  NONE: P.NONE
};
function Yu(t, e, r) {
  var n = r[t];
  if (typeof n == "string") {
    var i = Wu[n.toUpperCase()];
    i != null && (e[t] = i);
  }
}
function So(t) {
  var e = {};
  for (var r in To) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Yu(n, e, t);
        break;
      default:
        if (Bu(n))
          zu(n, e, t);
        else if (Fu(n))
          Xu(n, e, t);
        else if (ju(n))
          qu(n, e, t);
        else {
          var i = t[n];
          typeof i != "undefined" && i !== null && (e[n] = String(i));
        }
    }
  }
  return e;
}
var Qe = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function xe() {
  var t = So(Qe);
  return Object.assign({}, To, t);
}
function Ku() {
  return So(Qe);
}
function jn(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 97 && t <= 102 ? t - 87 : t - 55;
}
function Tn(t) {
  for (var e = new Uint8Array(t.length / 2), r = 0, n = 0; n < t.length; n += 2) {
    var i = jn(t.charCodeAt(n)), o = jn(t.charCodeAt(n + 1));
    e[r++] = i << 4 | o;
  }
  return e;
}
var Y = performance, Ju = "1.30.1", Qu = "process.runtime.name", Zu = "telemetry.sdk.name", ec = "telemetry.sdk.language", tc = "telemetry.sdk.version", rc = Qu, nc = Zu, ic = ec, oc = tc, ac = "webjs", sc = ac, Le, _r = (Le = {}, Le[nc] = "opentelemetry", Le[rc] = "browser", Le[ic] = sc, Le[oc] = Ju, Le), uc = 9, cc = 6, lc = Math.pow(10, cc), Bt = Math.pow(10, uc);
function q(t) {
  var e = t / 1e3, r = Math.trunc(e), n = Math.round(t % 1e3 * lc);
  return [r, n];
}
function Sn() {
  var t = Y.timeOrigin;
  if (typeof t != "number") {
    var e = Y;
    t = e.timing && e.timing.fetchStart;
  }
  return t;
}
function Te(t) {
  var e = q(Sn()), r = q(typeof t == "number" ? t : Y.now());
  return wo(e, r);
}
function Ze(t) {
  if (wn(t))
    return t;
  if (typeof t == "number")
    return t < Sn() ? Te(t) : q(t);
  if (t instanceof Date)
    return q(t.getTime());
  throw TypeError("Invalid input type");
}
function fc(t, e) {
  var r = e[0] - t[0], n = e[1] - t[1];
  return n < 0 && (r -= 1, n += Bt), [r, n];
}
function ae(t) {
  return t[0] * Bt + t[1];
}
function gt(t) {
  return t[0] * 1e6 + t[1] / 1e3;
}
function wn(t) {
  return Array.isArray(t) && t.length === 2 && typeof t[0] == "number" && typeof t[1] == "number";
}
function Vn(t) {
  return wn(t) || typeof t == "number" || t instanceof Date;
}
function wo(t, e) {
  var r = [t[0] + e[0], t[1] + e[1]];
  return r[1] >= Bt && (r[1] -= Bt, r[0] += 1), r;
}
var $;
(function(t) {
  t[t.SUCCESS = 0] = "SUCCESS", t[t.FAILED = 1] = "FAILED";
})($ || ($ = {}));
var dc = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, bo = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {});
      var r;
      this._propagators = (r = e.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return t.prototype.inject = function(e, r, n) {
      var i, o;
      try {
        for (var a = dc(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(e, r, n);
          } catch (s) {
            m.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, t.prototype.extract = function(e, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          m.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, e);
    }, t.prototype.fields = function() {
      return this._fields.slice();
    }, t;
  }()
), zr = "[_0-9a-z-*/]", hc = "[a-z]" + zr + "{0,255}", pc = "[a-z0-9]" + zr + "{0,240}@[a-z]" + zr + "{0,13}", _c = new RegExp("^(?:" + hc + "|" + pc + ")$"), vc = /^[ -~]{0,255}[!-~]$/, gc = /,|=/;
function yc(t) {
  return _c.test(t);
}
function mc(t) {
  return vc.test(t) && !gc.test(t);
}
var $n = 32, Ec = 512, zn = ",", Xn = "=", Tc = (
  /** @class */
  function() {
    function t(e) {
      this._internalState = /* @__PURE__ */ new Map(), e && this._parse(e);
    }
    return t.prototype.set = function(e, r) {
      var n = this._clone();
      return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, r), n;
    }, t.prototype.unset = function(e) {
      var r = this._clone();
      return r._internalState.delete(e), r;
    }, t.prototype.get = function(e) {
      return this._internalState.get(e);
    }, t.prototype.serialize = function() {
      var e = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Xn + e.get(n)), r;
      }, []).join(zn);
    }, t.prototype._parse = function(e) {
      e.length > Ec || (this._internalState = e.split(zn).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Xn);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          yc(a) && mc(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > $n && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, $n))));
    }, t.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, t.prototype._clone = function() {
      var e = new t();
      return e._internalState = new Map(this._internalState), e;
    }, t;
  }()
), xt = "traceparent", vr = "tracestate", Sc = "00", wc = "(?!ff)[\\da-f]{2}", bc = "(?![0]{32})[\\da-f]{32}", Oc = "(?![0]{16})[\\da-f]{16}", Ac = "[\\da-f]{2}", Rc = new RegExp("^\\s?(" + wc + ")-(" + bc + ")-(" + Oc + ")-(" + Ac + ")(-.*)?\\s?$");
function Nc(t) {
  var e = Rc.exec(t);
  return !e || e[1] === "00" && e[5] ? null : {
    traceId: e[2],
    spanId: e[3],
    traceFlags: parseInt(e[4], 16)
  };
}
var Oo = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.inject = function(e, r, n) {
      var i = R.getSpanContext(e);
      if (!(!i || En(e) || !Wt(i))) {
        var o = Sc + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || se.NONE).toString(16);
        n.set(r, xt, o), i.traceState && n.set(r, vr, i.traceState.serialize());
      }
    }, t.prototype.extract = function(e, r, n) {
      var i = n.get(r, xt);
      if (!i)
        return e;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return e;
      var a = Nc(o);
      if (!a)
        return e;
      a.isRemote = !0;
      var u = n.get(r, vr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Tc(typeof c == "string" ? c : void 0);
      }
      return R.setSpanContext(e, a);
    }, t.prototype.fields = function() {
      return [xt, vr];
    }, t;
  }()
), Lc = "[object Object]", Ic = "[object Null]", Pc = "[object Undefined]", Cc = Function.prototype, Ao = Cc.toString, xc = Ao.call(Object), Mc = kc(Object.getPrototypeOf, Object), Ro = Object.prototype, No = Ro.hasOwnProperty, ve = Symbol ? Symbol.toStringTag : void 0, Lo = Ro.toString;
function kc(t, e) {
  return function(r) {
    return t(e(r));
  };
}
function qn(t) {
  if (!Dc(t) || Uc(t) !== Lc)
    return !1;
  var e = Mc(t);
  if (e === null)
    return !0;
  var r = No.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Ao.call(r) === xc;
}
function Dc(t) {
  return t != null && typeof t == "object";
}
function Uc(t) {
  return t == null ? t === void 0 ? Pc : Ic : ve && ve in Object(t) ? Bc(t) : Hc(t);
}
function Bc(t) {
  var e = No.call(t, ve), r = t[ve], n = !1;
  try {
    t[ve] = void 0, n = !0;
  } catch (o) {
  }
  var i = Lo.call(t);
  return n && (e ? t[ve] = r : delete t[ve]), i;
}
function Hc(t) {
  return Lo.call(t);
}
var Fc = 20;
function Gc() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var r = t.shift(), n = /* @__PURE__ */ new WeakMap(); t.length > 0; )
    r = Io(r, t.shift(), 0, n);
  return r;
}
function gr(t) {
  return Ht(t) ? t.slice() : t;
}
function Io(t, e, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Fc)) {
    if (r++, Mt(t) || Mt(e) || Po(e))
      i = gr(e);
    else if (Ht(t)) {
      if (i = t.slice(), Ht(e))
        for (var o = 0, a = e.length; o < a; o++)
          i.push(gr(e[o]));
      else if (Ge(e))
        for (var u = Object.keys(e), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = gr(e[c]);
        }
    } else if (Ge(t))
      if (Ge(e)) {
        if (!jc(t, e))
          return e;
        i = Object.assign({}, t);
        for (var u = Object.keys(e), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = e[c];
          if (Mt(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Wn(t, c, n) || Wn(e, c, n))
              delete i[c];
            else {
              if (Ge(l) && Ge(f)) {
                var d = n.get(l) || [], h = n.get(f) || [];
                d.push({ obj: t, key: c }), h.push({ obj: e, key: c }), n.set(l, d), n.set(f, h);
              }
              i[c] = Io(i[c], s, r, n);
            }
          }
        }
      } else
        i = e;
    return i;
  }
}
function Wn(t, e, r) {
  for (var n = r.get(t[e]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === e && a.obj === t)
      return !0;
  }
  return !1;
}
function Ht(t) {
  return Array.isArray(t);
}
function Po(t) {
  return typeof t == "function";
}
function Ge(t) {
  return !Mt(t) && !Ht(t) && !Po(t) && typeof t == "object";
}
function Mt(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "undefined" || t instanceof Date || t instanceof RegExp || t === null;
}
function jc(t, e) {
  return !(!qn(t) || !qn(e));
}
var Vc = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Co(t, e) {
  return typeof e == "string" ? t === e : !!t.match(e);
}
function xo(t, e) {
  var r, n;
  if (!e)
    return !1;
  try {
    for (var i = Vc(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Co(t, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var $c = (
  /** @class */
  function() {
    function t() {
      var e = this;
      this._promise = new Promise(function(r, n) {
        e._resolve = r, e._reject = n;
      });
    }
    return Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolve = function(e) {
      this._resolve(e);
    }, t.prototype.reject = function(e) {
      this._reject(e);
    }, t;
  }()
), zc = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Xc = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, qc = (
  /** @class */
  function() {
    function t(e, r) {
      this._callback = e, this._that = r, this._isCalled = !1, this._deferred = new $c();
    }
    return Object.defineProperty(t.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.call = function() {
      for (var e, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((e = this._callback).call.apply(e, Xc([this._that], zc(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, t;
  }()
);
function Wc(t, e) {
  return new Promise(function(r) {
    A.with(vo(A.active()), function() {
      t.export(e, function(n) {
        r(n);
      });
    });
  });
}
var Yc = {
  _export: Wc
}, Mo = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.emit = function(e) {
    }, t;
  }()
), Kc = new Mo(), Jc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      return new Mo();
    }, t;
  }()
), ko = new Jc(), Qc = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this._provider = e, this.name = r, this.version = n, this.options = i;
    }
    return t.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, t.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : Kc;
    }, t;
  }()
), Yn = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      var i;
      return (i = this.getDelegateLogger(e, r, n)) !== null && i !== void 0 ? i : new Qc(this, e, r, n);
    }, t.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : ko;
    }, t.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, t.prototype.getDelegateLogger = function(e, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, r, n);
    }, t;
  }()
), Zc = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, yt = Symbol.for("io.opentelemetry.js.api.logs"), je = Zc;
function el(t, e, r) {
  return function(n) {
    return n === t ? e : r;
  };
}
var Kn = 1, tl = (
  /** @class */
  function() {
    function t() {
      this._proxyLoggerProvider = new Yn();
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalLoggerProvider = function(e) {
      return je[yt] ? this.getLoggerProvider() : (je[yt] = el(Kn, e, ko), this._proxyLoggerProvider.setDelegate(e), e);
    }, t.prototype.getLoggerProvider = function() {
      var e, r;
      return (r = (e = je[yt]) === null || e === void 0 ? void 0 : e.call(je, Kn)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, t.prototype.getLogger = function(e, r, n) {
      return this.getLoggerProvider().getLogger(e, r, n);
    }, t.prototype.disable = function() {
      delete je[yt], this._proxyLoggerProvider = new Yn();
    }, t;
  }()
), Do = tl.getInstance();
function rl(t, e, r, n) {
  for (var i = 0, o = t.length; i < o; i++) {
    var a = t[i];
    e && a.setTracerProvider(e), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function nl(t) {
  t.forEach(function(e) {
    return e.disable();
  });
}
function il(t) {
  var e, r, n = t.tracerProvider || R.getTracerProvider(), i = t.meterProvider || ft.getMeterProvider(), o = t.loggerProvider || Do.getLoggerProvider(), a = (r = (e = t.instrumentations) === null || e === void 0 ? void 0 : e.flat()) !== null && r !== void 0 ? r : [];
  return rl(a, n, i, o), function() {
    nl(a);
  };
}
function Xr(t) {
  return typeof t == "function";
}
var F = console.error.bind(console);
function Ve(t, e, r) {
  var n = !!t[e] && t.propertyIsEnumerable(e);
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function dt(t) {
  t && t.logger && (Xr(t.logger) ? F = t.logger : F("new logger isn't a function, not replacing"));
}
function Uo(t, e, r) {
  if (!t || !t[e]) {
    F("no original function " + e + " to wrap");
    return;
  }
  if (!r) {
    F("no wrapper function"), F(new Error().stack);
    return;
  }
  if (!Xr(t[e]) || !Xr(r)) {
    F("original object and wrapper must be functions");
    return;
  }
  var n = t[e], i = r(n, e);
  return Ve(i, "__original", n), Ve(i, "__unwrap", function() {
    t[e] === i && Ve(t, e, n);
  }), Ve(i, "__wrapped", !0), Ve(t, e, i), i;
}
function ol(t, e, r) {
  if (t)
    Array.isArray(t) || (t = [t]);
  else {
    F("must provide one or more modules to patch"), F(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    F("must provide one or more functions to wrap on modules");
    return;
  }
  t.forEach(function(n) {
    e.forEach(function(i) {
      Uo(n, i, r);
    });
  });
}
function Bo(t, e) {
  if (!t || !t[e]) {
    F("no function to unwrap."), F(new Error().stack);
    return;
  }
  if (!t[e].__unwrap)
    F("no original to unwrap to -- has " + e + " already been unwrapped?");
  else
    return t[e].__unwrap();
}
function al(t, e) {
  if (t)
    Array.isArray(t) || (t = [t]);
  else {
    F("must provide one or more modules to patch"), F(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    F("must provide one or more functions to unwrap on modules");
    return;
  }
  t.forEach(function(r) {
    e.forEach(function(n) {
      Bo(r, n);
    });
  });
}
dt.wrap = Uo;
dt.massWrap = ol;
dt.unwrap = Bo;
dt.massUnwrap = al;
var W = dt, qr = function() {
  return qr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, qr.apply(this, arguments);
}, sl = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.instrumentationName = e, this.instrumentationVersion = r, this._config = {}, this._wrap = W.wrap, this._unwrap = W.unwrap, this._massWrap = W.massWrap, this._massUnwrap = W.massUnwrap, this.setConfig(n), this._diag = m.createComponentLogger({
        namespace: e
      }), this._tracer = R.getTracer(e, r), this._meter = ft.getMeter(e, r), this._logger = Do.getLogger(e, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(t.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(t.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, t.prototype.getModuleDefinitions = function() {
      var e, r = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(r) ? r : [r];
    }, t.prototype._updateMetricInstruments = function() {
    }, t.prototype.getConfig = function() {
      return this._config;
    }, t.prototype.setConfig = function(e) {
      this._config = qr({ enabled: !0 }, e);
    }, t.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(t.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._runSpanCustomizationHook = function(e, r, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, t;
  }()
), ul = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ho = (
  /** @class */
  function(t) {
    ul(e, t);
    function e(r, n, i) {
      var o = t.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return e;
  }(sl)
);
function Jn(t, e, r) {
  var n, i;
  try {
    i = t();
  } catch (o) {
    n = o;
  } finally {
    return e(n, i), i;
  }
}
function H(t) {
  return typeof t == "function" && typeof t.__original == "function" && typeof t.__unwrap == "function" && t.__wrapped === !0;
}
var cl = "exception.type", ll = "exception.message", fl = "exception.stacktrace", yr = cl, mr = ll, dl = fl, hl = "exception", Wr = function() {
  return Wr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Wr.apply(this, arguments);
}, pl = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qn = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _l = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, vl = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: jr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = Y.now(), this._performanceOffset = f - (this._performanceStartTime + Sn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = e.resource, this.instrumentationLibrary = e.instrumentationLibrary, this._spanLimits = e.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = e.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return t.prototype.spanContext = function() {
      return this._spanContext;
    }, t.prototype.setAttribute = function(e, r) {
      return r == null || this._isSpanEnded() ? this : e.length === 0 ? (m.warn("Invalid attribute key: " + e), this) : mo(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, e) ? (this._droppedAttributesCount++, this) : (this.attributes[e] = this._truncateToSize(r), this) : (m.warn("Invalid attribute value set for key: " + e), this);
    }, t.prototype.setAttributes = function(e) {
      var r, n;
      try {
        for (var i = pl(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
          var a = Qn(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, t.prototype.addEvent = function(e, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return m.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && m.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Vn(r) && (Vn(n) || (n = r), r = void 0);
      var i = It(r);
      return this.events.push({
        name: e,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, t.prototype.addLink = function(e) {
      return this.links.push(e), this;
    }, t.prototype.addLinks = function(e) {
      var r;
      return (r = this.links).push.apply(r, _l([], Qn(e), !1)), this;
    }, t.prototype.setStatus = function(e) {
      return this._isSpanEnded() ? this : (this.status = Wr({}, e), this.status.message != null && typeof e.message != "string" && (m.warn("Dropping invalid status.message of type '" + typeof e.message + "', expected 'string'"), delete this.status.message), this);
    }, t.prototype.updateName = function(e) {
      return this._isSpanEnded() ? this : (this.name = e, this);
    }, t.prototype.end = function(e) {
      if (this._isSpanEnded()) {
        m.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(e), this._duration = fc(this.startTime, this.endTime), this._duration[0] < 0 && (m.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && m.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, t.prototype._getTime = function(e) {
      if (typeof e == "number" && e <= Y.now())
        return Te(e + this._performanceOffset);
      if (typeof e == "number")
        return q(e);
      if (e instanceof Date)
        return q(e.getTime());
      if (wn(e))
        return e;
      if (this._startTimeProvided)
        return q(Date.now());
      var r = Y.now() - this._performanceStartTime;
      return wo(this.startTime, q(r));
    }, t.prototype.isRecording = function() {
      return this._ended === !1;
    }, t.prototype.recordException = function(e, r) {
      var n = {};
      typeof e == "string" ? n[mr] = e : e && (e.code ? n[yr] = e.code.toString() : e.name && (n[yr] = e.name), e.message && (n[mr] = e.message), e.stack && (n[dl] = e.stack)), n[yr] || n[mr] ? this.addEvent(hl, n, r) : m.warn("Failed to record an exception " + e);
    }, Object.defineProperty(t.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._isSpanEnded = function() {
      return this._ended && m.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, t.prototype._truncateToLimitUtil = function(e, r) {
      return e.length <= r ? e : e.substring(0, r);
    }, t.prototype._truncateToSize = function(e) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (m.warn("Attribute value limit must be positive, got " + n), e) : typeof e == "string" ? this._truncateToLimitUtil(e, n) : Array.isArray(e) ? e.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : e;
    }, t;
  }()
), Me;
(function(t) {
  t[t.NOT_RECORD = 0] = "NOT_RECORD", t[t.RECORD = 1] = "RECORD", t[t.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Me || (Me = {}));
var Ft = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: Me.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, t;
  }()
), Ce = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.shouldSample = function() {
      return {
        decision: Me.RECORD_AND_SAMPLED
      };
    }, t.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, t;
  }()
), Er = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o;
      this._root = e.root, this._root || (he(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Ce()), this._remoteParentSampled = (r = e.remoteParentSampled) !== null && r !== void 0 ? r : new Ce(), this._remoteParentNotSampled = (n = e.remoteParentNotSampled) !== null && n !== void 0 ? n : new Ft(), this._localParentSampled = (i = e.localParentSampled) !== null && i !== void 0 ? i : new Ce(), this._localParentNotSampled = (o = e.localParentNotSampled) !== null && o !== void 0 ? o : new Ft();
    }
    return t.prototype.shouldSample = function(e, r, n, i, o, a) {
      var u = R.getSpanContext(e);
      return !u || !Wt(u) ? this._root.shouldSample(e, r, n, i, o, a) : u.isRemote ? u.traceFlags & se.SAMPLED ? this._remoteParentSampled.shouldSample(e, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(e, r, n, i, o, a) : u.traceFlags & se.SAMPLED ? this._localParentSampled.shouldSample(e, r, n, i, o, a) : this._localParentNotSampled.shouldSample(e, r, n, i, o, a);
    }, t.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, t;
  }()
), Zn = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = 0), this._ratio = e, this._ratio = this._normalize(e), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return t.prototype.shouldSample = function(e, r) {
      return {
        decision: fo(r) && this._accumulate(r) < this._upperBound ? Me.RECORD_AND_SAMPLED : Me.NOT_RECORD
      };
    }, t.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, t.prototype._normalize = function(e) {
      return typeof e != "number" || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }, t.prototype._accumulate = function(e) {
      for (var r = 0, n = 0; n < e.length / 8; n++) {
        var i = n * 8, o = parseInt(e.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, t;
  }()
), gl = ee.AlwaysOn, Ie = 1;
function Fo() {
  var t = xe();
  return {
    sampler: Go(t),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: t.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: t.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: t.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: t.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: t.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: t.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: t.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: t.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function Go(t) {
  switch (t === void 0 && (t = xe()), t.OTEL_TRACES_SAMPLER) {
    case ee.AlwaysOn:
      return new Ce();
    case ee.AlwaysOff:
      return new Ft();
    case ee.ParentBasedAlwaysOn:
      return new Er({
        root: new Ce()
      });
    case ee.ParentBasedAlwaysOff:
      return new Er({
        root: new Ft()
      });
    case ee.TraceIdRatio:
      return new Zn(ei(t));
    case ee.ParentBasedTraceIdRatio:
      return new Er({
        root: new Zn(ei(t))
      });
    default:
      return m.error('OTEL_TRACES_SAMPLER value "' + t.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + gl + '".'), new Ce();
  }
}
function ei(t) {
  if (t.OTEL_TRACES_SAMPLER_ARG === void 0 || t.OTEL_TRACES_SAMPLER_ARG === "")
    return m.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Ie + "."), Ie;
  var e = Number(t.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(e) ? (m.error("OTEL_TRACES_SAMPLER_ARG=" + t.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Ie + "."), Ie) : e < 0 || e > 1 ? (m.error("OTEL_TRACES_SAMPLER_ARG=" + t.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Ie + "."), Ie) : e;
}
function yl(t) {
  var e = {
    sampler: Go()
  }, r = Fo(), n = Object.assign({}, r, e, t);
  return n.generalLimits = Object.assign({}, r.generalLimits, t.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, t.spanLimits || {}), n;
}
function ml(t) {
  var e, r, n, i, o, a, u, c, s, l, f, d, h = Object.assign({}, t.spanLimits), v = Ku();
  return h.attributeCountLimit = (a = (o = (i = (r = (e = t.spanLimits) === null || e === void 0 ? void 0 : e.attributeCountLimit) !== null && r !== void 0 ? r : (n = t.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : v.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : v.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Ct, h.attributeValueLengthLimit = (d = (f = (l = (c = (u = t.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = t.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : v.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : v.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : Pt, Object.assign({}, t, { spanLimits: h });
}
var El = (
  /** @class */
  function() {
    function t(e, r) {
      this._exporter = e, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = xe();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new qc(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (m.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return t.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, t.prototype.onStart = function(e, r) {
    }, t.prototype.onEnd = function(e) {
      this._shutdownOnce.isCalled || e.spanContext().traceFlags & se.SAMPLED && this._addToBuffer(e);
    }, t.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, t.prototype._shutdown = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.onShutdown();
      }).then(function() {
        return e._flushAll();
      }).then(function() {
        return e._exporter.shutdown();
      });
    }, t.prototype._addToBuffer = function(e) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && m.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (m.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(e), this._maybeStartTimer();
    }, t.prototype._flushAll = function() {
      var e = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(e._finishedSpans.length / e._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(e._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, t.prototype._flushOneBatch = function() {
      var e = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, e._exportTimeoutMillis);
        A.with(vo(A.active()), function() {
          var o;
          e._finishedSpans.length <= e._maxExportBatchSize ? (o = e._finishedSpans, e._finishedSpans = []) : o = e._finishedSpans.splice(0, e._maxExportBatchSize);
          for (var a = function() {
            return e._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === $.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            he(f), n(f);
          });
        });
      });
    }, t.prototype._maybeStartTimer = function() {
      var e = this;
      if (!this._isExporting) {
        var r = function() {
          e._isExporting = !0, e._flushOneBatch().finally(function() {
            e._isExporting = !1, e._finishedSpans.length > 0 && (e._clearTimer(), e._maybeStartTimer());
          }).catch(function(n) {
            e._isExporting = !1, he(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, t.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, t;
  }()
), Tl = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), jo = (
  /** @class */
  function(t) {
    Tl(e, t);
    function e(r, n) {
      var i = t.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return e.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          he(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          he(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, e.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, e;
  }(El)
), Sl = 8, wl = 16, bl = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.generateTraceId = ti(wl), this.generateSpanId = ti(Sl);
    }
    return t;
  }()
), mt = Array(32);
function ti(t) {
  return function() {
    for (var r = 0; r < t * 2; r++)
      mt[r] = Math.floor(Math.random() * 16) + 48, mt[r] >= 58 && (mt[r] += 39);
    return String.fromCharCode.apply(null, mt.slice(0, t * 2));
  };
}
var Ol = (
  /** @class */
  function() {
    function t(e, r, n) {
      this._tracerProvider = n;
      var i = yl(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new bl(), this.resource = n.resource, this.instrumentationLibrary = e;
    }
    return t.prototype.startSpan = function(e, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = A.active()), r.root && (n = R.deleteSpan(n));
      var u = R.getSpan(n);
      if (En(n)) {
        m.debug("Instrumentation suppressed, returning Noop Span");
        var c = R.wrapSpanContext(co);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !s || !R.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, h = s.spanId);
      var v = (i = r.kind) !== null && i !== void 0 ? i : it.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(G) {
        return {
          context: G.context,
          attributes: It(G.attributes)
        };
      }), y = It(r.attributes), g = this._sampler.shouldSample(n, f, e, v, y, p);
      d = (a = g.traceState) !== null && a !== void 0 ? a : d;
      var b = g.decision === Ut.RECORD_AND_SAMPLED ? se.SAMPLED : se.NONE, L = { traceId: f, spanId: l, traceFlags: b, traceState: d };
      if (g.decision === Ut.NOT_RECORD) {
        m.debug("Recording is off, propagating context in a non-recording span");
        var c = R.wrapSpanContext(L);
        return c;
      }
      var C = It(Object.assign(y, g.attributes)), B = new vl(this, n, e, L, v, h, p, r.startTime, void 0, C);
      return B;
    }, t.prototype.startActiveSpan = function(e, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : A.active(), s = this.startSpan(e, o, c), l = R.setSpan(c, s);
        return A.with(l, u, void 0, s);
      }
    }, t.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, t.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, t.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, t;
  }()
), Al = "service.name", Rl = "telemetry.sdk.name", Nl = "telemetry.sdk.language", Ll = "telemetry.sdk.version", Il = Al, ri = Rl, ni = Nl, ii = Ll;
function Pl() {
  return "unknown_service";
}
var le = function() {
  return le = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, le.apply(this, arguments);
}, Cl = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, xl = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ml = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ot = (
  /** @class */
  function() {
    function t(e, r) {
      var n = this, i;
      this._attributes = e, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return m.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return t.empty = function() {
      return t.EMPTY;
    }, t.default = function() {
      var e;
      return new t((e = {}, e[Il] = Pl(), e[ni] = _r[ni], e[ri] = _r[ri], e[ii] = _r[ii], e));
    }, Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var e;
        return this.asyncAttributesPending && m.error("Accessing resource attributes before async attributes settled"), (e = this._attributes) !== null && e !== void 0 ? e : {};
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.waitForAsyncAttributes = function() {
      return Cl(this, void 0, void 0, function() {
        return xl(this, function(e) {
          switch (e.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.merge = function(e) {
      var r = this, n;
      if (!e)
        return this;
      var i = le(le({}, this._syncAttributes), (n = e._syncAttributes) !== null && n !== void 0 ? n : e.attributes);
      if (!this._asyncAttributesPromise && !e._asyncAttributesPromise)
        return new t(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        e._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = Ml(a, 2), s = c[0], l = c[1];
        return le(le(le(le({}, r._syncAttributes), s), (u = e._syncAttributes) !== null && u !== void 0 ? u : e.attributes), l);
      });
      return new t(i, o);
    }, t.EMPTY = new t({}), t;
  }()
), Et = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, oi = (
  /** @class */
  function() {
    function t(e) {
      this._spanProcessors = e;
    }
    return t.prototype.forceFlush = function() {
      var e, r, n = [];
      try {
        for (var i = Et(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          he(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, t.prototype.onStart = function(e, r) {
      var n, i;
      try {
        for (var o = Et(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(e, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, t.prototype.onEnd = function(e) {
      var r, n;
      try {
        for (var i = Et(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(e);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.shutdown = function() {
      var e, r, n = [];
      try {
        for (var i = Et(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, t;
  }()
), kl = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.onStart = function(e, r) {
    }, t.prototype.onEnd = function(e) {
    }, t.prototype.shutdown = function() {
      return Promise.resolve();
    }, t.prototype.forceFlush = function() {
      return Promise.resolve();
    }, t;
  }()
), Dl = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ul = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, ge;
(function(t) {
  t[t.resolved = 0] = "resolved", t[t.timeout = 1] = "timeout", t[t.error = 2] = "error", t[t.unresolved = 3] = "unresolved";
})(ge || (ge = {}));
var Bl = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = Gc({}, Fo(), ml(e));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : ot.empty(), i.mergeResourceWithDefaults && (this.resource = ot.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = e.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = Ul([], Dl(e.spanProcessors), !1), this.activeSpanProcessor = new oi(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new jo(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new kl();
      }
    }
    return t.prototype.getTracer = function(e, r, n) {
      var i = e + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ol({ name: e, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, t.prototype.addSpanProcessor = function(e) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return m.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(e), this.activeSpanProcessor = new oi(this._registeredSpanProcessors);
    }, t.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, t.prototype.register = function(e) {
      e === void 0 && (e = {}), R.setGlobalTracerProvider(this), e.propagator === void 0 && (e.propagator = this._buildPropagatorFromEnv()), e.contextManager && A.setGlobalContextManager(e.contextManager), e.propagator && X.setGlobalPropagator(e.propagator);
    }, t.prototype.forceFlush = function() {
      var e = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + e + " ms")), o = ge.timeout;
          }, e);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== ge.timeout && (o = ge.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = ge.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== ge.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, t.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, t.prototype._getPropagator = function(e) {
      var r;
      return (r = this.constructor._registeredPropagators.get(e)) === null || r === void 0 ? void 0 : r();
    }, t.prototype._getSpanExporter = function(e) {
      var r;
      return (r = this.constructor._registeredExporters.get(e)) === null || r === void 0 ? void 0 : r();
    }, t.prototype._buildPropagatorFromEnv = function() {
      var e = this, r = Array.from(new Set(xe().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = e._getPropagator(o);
        return a || m.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new bo({
          propagators: i
        });
    }, t.prototype._buildExporterFromEnv = function() {
      var e = xe().OTEL_TRACES_EXPORTER;
      if (!(e === "none" || e === "")) {
        var r = this._getSpanExporter(e);
        return r || m.error('Exporter "' + e + '" requested through environment variable is unavailable.'), r;
      }
    }, t._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Oo();
      }],
      ["baggage", function() {
        return new go();
      }]
    ]), t._registeredExporters = /* @__PURE__ */ new Map(), t;
  }()
), Hl = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fl = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Vo = (
  /** @class */
  function() {
    function t() {
      this._enabled = !1, this._currentContext = _e;
    }
    return t.prototype._bindFunction = function(e, r) {
      e === void 0 && (e = _e);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(e, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, t.prototype.active = function() {
      return this._currentContext;
    }, t.prototype.bind = function(e, r) {
      return e === void 0 && (e = this.active()), typeof r == "function" ? this._bindFunction(e, r) : r;
    }, t.prototype.disable = function() {
      return this._currentContext = _e, this._enabled = !1, this;
    }, t.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = _e, this);
    }, t.prototype.with = function(e, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = e || _e;
      try {
        return r.call.apply(r, Fl([n], Hl(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, t;
  }()
), Gl = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), jl = (
  /** @class */
  function(t) {
    Gl(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return e.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new Vo()), r.contextManager && r.contextManager.enable(), t.prototype.register.call(this, r);
    }, e;
  }(Bl)
), T;
(function(t) {
  t.CONNECT_END = "connectEnd", t.CONNECT_START = "connectStart", t.DECODED_BODY_SIZE = "decodedBodySize", t.DOM_COMPLETE = "domComplete", t.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", t.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", t.DOM_INTERACTIVE = "domInteractive", t.DOMAIN_LOOKUP_END = "domainLookupEnd", t.DOMAIN_LOOKUP_START = "domainLookupStart", t.ENCODED_BODY_SIZE = "encodedBodySize", t.FETCH_START = "fetchStart", t.LOAD_EVENT_END = "loadEventEnd", t.LOAD_EVENT_START = "loadEventStart", t.NAVIGATION_START = "navigationStart", t.REDIRECT_END = "redirectEnd", t.REDIRECT_START = "redirectStart", t.REQUEST_START = "requestStart", t.RESPONSE_END = "responseEnd", t.RESPONSE_START = "responseStart", t.SECURE_CONNECTION_START = "secureConnectionStart", t.UNLOAD_EVENT_END = "unloadEventEnd", t.UNLOAD_EVENT_START = "unloadEventStart";
})(T || (T = {}));
var Vl = "http.response_content_length", $l = "http.response_content_length_uncompressed", zl = Vl, Xl = $l, Tr;
function ql() {
  return Tr || (Tr = document.createElement("a")), Tr;
}
function pe(t, e) {
  return e in t;
}
function k(t, e, r, n) {
  var i = void 0, o = void 0;
  pe(r, e) && typeof r[e] == "number" && (i = r[e]);
  var a = T.FETCH_START;
  if (pe(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return t.addEvent(e, i), t;
}
function ke(t, e, r) {
  r === void 0 && (r = !1), r || (k(t, T.FETCH_START, e), k(t, T.DOMAIN_LOOKUP_START, e), k(t, T.DOMAIN_LOOKUP_END, e), k(t, T.CONNECT_START, e), pe(e, "name") && e.name.startsWith("https:") && k(t, T.SECURE_CONNECTION_START, e), k(t, T.CONNECT_END, e), k(t, T.REQUEST_START, e), k(t, T.RESPONSE_START, e), k(t, T.RESPONSE_END, e));
  var n = e[T.ENCODED_BODY_SIZE];
  n !== void 0 && t.setAttribute(zl, n);
  var i = e[T.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && t.setAttribute(Xl, i);
}
function Wl(t) {
  return t.slice().sort(function(e, r) {
    var n = e[T.FETCH_START], i = r[T.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function $o() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function zo(t, e, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = oe(t);
  t = a.toString();
  var u = Kl(t, e, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Wl(u);
  if (a.origin !== $o() && c.length > 1) {
    var s = c[0], l = Yl(c, s[T.RESPONSE_END], r), f = s[T.RESPONSE_END], d = l[T.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Yl(t, e, r) {
  for (var n = ae(r), i = ae(Ze(e)), o = t[1], a, u = t.length, c = 1; c < u; c++) {
    var s = t[c], l = ae(Ze(s[T.FETCH_START])), f = ae(Ze(s[T.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Kl(t, e, r, n, i, o) {
  var a = ae(e), u = ae(r), c = n.filter(function(s) {
    var l = ae(Ze(s[T.FETCH_START])), f = ae(Ze(s[T.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === t && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function oe(t) {
  if (typeof URL == "function")
    return new URL(t, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var e = ql();
  return e.href = t, e;
}
function Xo(t, e) {
  if (t.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Ql(t, e);
  if (e && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return t.parentNode && (n += Xo(t.parentNode, !1)), n += r, n;
}
function Jl(t) {
  if (!t.parentNode)
    return 0;
  var e = [t.nodeType];
  t.nodeType === Node.CDATA_SECTION_NODE && e.push(Node.TEXT_NODE);
  var r = Array.from(t.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return e.indexOf(n.nodeType) >= 0 && i === t.localName;
  }), r.length >= 1 ? r.indexOf(t) + 1 : 0;
}
function Ql(t, e) {
  var r = t.nodeType, n = Jl(t), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = t.getAttribute("id");
    if (e && o)
      return '//*[@id="' + o + '"]';
    i = t.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function qo(t, e) {
  var r = e || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = oe(t);
  return n.origin === $o() ? !0 : r.some(function(i) {
    return Co(t, i);
  });
}
var et;
(function(t) {
  t.DOCUMENT_LOAD = "documentLoad", t.DOCUMENT_FETCH = "documentFetch", t.RESOURCE_FETCH = "resourceFetch";
})(et || (et = {}));
var Zl = "0.44.0", ef = "@opentelemetry/instrumentation-document-load", tf = "http.url", rf = "http.user_agent", Sr = tf, nf = rf, of = "deployment.environment", af = of, sf = "service.name", uf = "url.full", cf = "url.path", lf = "url.query", Gt;
(function(t) {
  t.FIRST_PAINT = "firstPaint", t.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(Gt || (Gt = {}));
var ff = function() {
  var t, e, r = {}, n = (e = (t = Y).getEntriesByType) === null || e === void 0 ? void 0 : e.call(t, "navigation")[0];
  if (n) {
    var i = Object.values(T);
    i.forEach(function(u) {
      if (pe(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = Y, a = o.timing;
    if (a) {
      var i = Object.values(T);
      i.forEach(function(c) {
        if (pe(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, ai = {
  "first-paint": Gt.FIRST_PAINT,
  "first-contentful-paint": Gt.FIRST_CONTENTFUL_PAINT
}, df = function(t) {
  var e, r, n = (r = (e = Y).getEntriesByType) === null || r === void 0 ? void 0 : r.call(e, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    pe(ai, o) && t.addEvent(ai[o], a);
  });
}, hf = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), pf = (
  /** @class */
  function(t) {
    hf(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, ef, Zl, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, e.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = Y).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, e.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === xt;
      }), i = ff(), o = n && n.content || "";
      A.with(X.extract(_e, { traceparent: o }), function() {
        var a, u = r._startSpan(et.DOCUMENT_LOAD, T.FETCH_START, i);
        u && (A.with(R.setSpan(A.active(), u), function() {
          var c = r._startSpan(et.DOCUMENT_FETCH, T.FETCH_START, i);
          c && (c.setAttribute(Sr, location.href), A.with(R.setSpan(A.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || ke(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, T.RESPONSE_END, i);
          }));
        }), u.setAttribute(Sr, location.href), u.setAttribute(nf, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (k(u, T.FETCH_START, i), k(u, T.UNLOAD_EVENT_START, i), k(u, T.UNLOAD_EVENT_END, i), k(u, T.DOM_INTERACTIVE, i), k(u, T.DOM_CONTENT_LOADED_EVENT_START, i), k(u, T.DOM_CONTENT_LOADED_EVENT_END, i), k(u, T.DOM_COMPLETE, i), k(u, T.LOAD_EVENT_START, i), k(u, T.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || df(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, T.LOAD_EVENT_END, i));
      });
    }, e.prototype._endSpan = function(r, n, i) {
      r && (pe(i, n) ? r.end(i[n]) : r.end());
    }, e.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(et.RESOURCE_FETCH, T.FETCH_START, r, n);
      o && (o.setAttribute(Sr, r.name), this.getConfig().ignoreNetworkEvents || ke(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, T.RESPONSE_END, r));
    }, e.prototype._startSpan = function(r, n, i, o) {
      if (pe(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? R.setSpan(A.active(), o) : void 0);
        return a;
      }
    }, e.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, e.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && Jn(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, e.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && Jn(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, e.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, e.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, e;
  }(Ho)
), Wo = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.emit = function(e) {
    }, t;
  }()
), _f = new Wo(), vf = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      return new Wo();
    }, t;
  }()
), Yo = new vf(), gf = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this._provider = e, this.name = r, this.version = n, this.options = i;
    }
    return t.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, t.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : _f;
    }, t;
  }()
), si = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      var i;
      return (i = this.getDelegateLogger(e, r, n)) !== null && i !== void 0 ? i : new gf(this, e, r, n);
    }, t.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : Yo;
    }, t.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, t.prototype.getDelegateLogger = function(e, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, r, n);
    }, t;
  }()
), yf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Tt = Symbol.for("io.opentelemetry.js.api.logs"), $e = yf;
function mf(t, e, r) {
  return function(n) {
    return n === t ? e : r;
  };
}
var ui = 1, Ef = (
  /** @class */
  function() {
    function t() {
      this._proxyLoggerProvider = new si();
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalLoggerProvider = function(e) {
      return $e[Tt] ? this.getLoggerProvider() : ($e[Tt] = mf(ui, e, Yo), this._proxyLoggerProvider.setDelegate(e), e);
    }, t.prototype.getLoggerProvider = function() {
      var e, r;
      return (r = (e = $e[Tt]) === null || e === void 0 ? void 0 : e.call($e, ui)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, t.prototype.getLogger = function(e, r, n) {
      return this.getLoggerProvider().getLogger(e, r, n);
    }, t.prototype.disable = function() {
      delete $e[Tt], this._proxyLoggerProvider = new si();
    }, t;
  }()
), Tf = Ef.getInstance(), Yr = function() {
  return Yr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Yr.apply(this, arguments);
}, Sf = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.instrumentationName = e, this.instrumentationVersion = r, this._config = {}, this._wrap = W.wrap, this._unwrap = W.unwrap, this._massWrap = W.massWrap, this._massUnwrap = W.massUnwrap, this.setConfig(n), this._diag = m.createComponentLogger({
        namespace: e
      }), this._tracer = R.getTracer(e, r), this._meter = ft.getMeter(e, r), this._logger = Tf.getLogger(e, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(t.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(t.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, t.prototype.getModuleDefinitions = function() {
      var e, r = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(r) ? r : [r];
    }, t.prototype._updateMetricInstruments = function() {
    }, t.prototype.getConfig = function() {
      return this._config;
    }, t.prototype.setConfig = function(e) {
      this._config = Yr({ enabled: !0 }, e);
    }, t.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(t.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._runSpanCustomizationHook = function(e, r, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, t;
  }()
), wf = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bf = (
  /** @class */
  function(t) {
    wf(e, t);
    function e(r, n, i) {
      var o = t.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return e;
  }(Sf)
);
function Of(t, e, r) {
  var n, i;
  try {
    i = t();
  } catch (o) {
    n = o;
  } finally {
    return e(n, i), i;
  }
}
function Af(t) {
  return typeof t == "function" && typeof t.__original == "function" && typeof t.__unwrap == "function" && t.__wrapped === !0;
}
var jt;
(function(t) {
  t.COMPONENT = "component", t.HTTP_ERROR_NAME = "http.error_name", t.HTTP_STATUS_TEXT = "http.status_text";
})(jt || (jt = {}));
var Rf = "http.method", Nf = "http.url", Lf = "http.host", If = "http.scheme", Pf = "http.status_code", Cf = "http.user_agent", xf = "http.request_content_length_uncompressed", Mf = Rf, kf = Nf, Df = Lf, Uf = If, Bf = Pf, Hf = Cf, Ff = xf, Gf = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, jf = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Vf = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $f = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ko = m.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function zf() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  if (t[0] instanceof URL || typeof t[0] == "string") {
    var r = t[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = Xf(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(qf(r.body));
  } else {
    var a = t[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return Kr(u);
    }) : Promise.resolve();
  }
}
function Xf(t) {
  if (!t.pipeThrough)
    return Ko.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: t,
      length: Promise.resolve(void 0)
    };
  var e = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return Gf(this, void 0, void 0, function() {
        var u;
        return jf(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), e += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(e);
    }
  });
  return {
    body: t.pipeThrough(i),
    length: n
  };
}
function qf(t) {
  if (typeof Document != "undefined" && t instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (t instanceof Blob)
    return t.size;
  if (t.byteLength !== void 0)
    return t.byteLength;
  if (t instanceof FormData)
    return Yf(t);
  if (t instanceof URLSearchParams)
    return Kr(t.toString());
  if (typeof t == "string")
    return Kr(t);
  Ko.warn("unknown body type");
}
var Wf = new TextEncoder();
function Kr(t) {
  return Wf.encode(t).byteLength;
}
function Yf(t) {
  var e, r, n = 0;
  try {
    for (var i = Vf(t.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = $f(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    e = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
var ci = "0.57.1", Kf = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Jf = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qf = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, wr, Zf = 300, li = typeof process == "object" && ((wr = process.release) === null || wr === void 0 ? void 0 : wr.name) === "node", ed = (
  /** @class */
  function(t) {
    Kf(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, "@opentelemetry/instrumentation-fetch", ci, r) || this;
      return n.component = "fetch", n.version = ci, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[T.FETCH_START]
      }, R.setSpan(A.active(), r));
      ke(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[T.RESPONSE_END]);
    }, e.prototype._addFinalSpanAttributes = function(r, n) {
      var i = oe(n.url);
      r.setAttribute(Bf, n.status), n.statusText != null && r.setAttribute(jt.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Df, i.host), r.setAttribute(Uf, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(Hf, navigator.userAgent);
    }, e.prototype._addHeaders = function(r, n) {
      if (!qo(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        X.inject(A.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        X.inject(A.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        X.inject(A.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        X.inject(A.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        X.inject(A.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), xo(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: it.CLIENT,
        attributes: (i = {}, i[jt.COMPONENT] = this.moduleName, i[Mf] = o, i[kf] = r, i)
      });
    }, e.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = zo(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), ke(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, e.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, e.prototype._endSpan = function(r, n, i) {
      var o = this, a = q(Date.now()), u = Te();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, Zf);
    }, e.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = oe(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && zf.apply(void 0, Qf([], Jf(a), !1)).then(function(g) {
            g && f.setAttribute(Ff, g);
          }).catch(function(g) {
            i._diag.warn("getFetchBodyLength", g);
          });
          function h(g, b) {
            i._applyAttributesAfterFetch(g, l, b), i._endSpan(g, d, {
              status: b.status || 0,
              statusText: b.message,
              url: s
            });
          }
          function v(g, b) {
            i._applyAttributesAfterFetch(g, l, b), b.status >= 200 && b.status < 400 ? i._endSpan(g, d, b) : i._endSpan(g, d, {
              status: b.status,
              statusText: b.statusText,
              url: s
            });
          }
          function p(g, b, L) {
            try {
              var C = L.clone(), B = L.clone(), G = C.body;
              if (G) {
                var pt = G.getReader(), Be = function() {
                  pt.read().then(function(M) {
                    var ne = M.done;
                    ne ? v(g, B) : Be();
                  }, function(M) {
                    h(g, M);
                  });
                };
                Be();
              } else
                v(g, L);
            } finally {
              b(L);
            }
          }
          function y(g, b, L) {
            try {
              h(g, L);
            } finally {
              b(L);
            }
          }
          return new Promise(function(g, b) {
            return A.with(R.setSpan(A.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(p.bind(c, f, g), y.bind(c, f, b));
            });
          });
        };
      };
    }, e.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && Of(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, e.prototype._prepareSpanData = function(r) {
      var n = Te(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, e.prototype.enable = function() {
      if (li) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      Af(fetch) && (this._unwrap(Qe, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Qe, "fetch", this._patchConstructor());
    }, e.prototype.disable = function() {
      li || (this._unwrap(Qe, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e;
  }(bf)
), Jo = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.emit = function(e) {
    }, t;
  }()
), td = new Jo(), rd = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      return new Jo();
    }, t;
  }()
), Qo = new rd(), nd = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this._provider = e, this.name = r, this.version = n, this.options = i;
    }
    return t.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, t.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : td;
    }, t;
  }()
), fi = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLogger = function(e, r, n) {
      var i;
      return (i = this.getDelegateLogger(e, r, n)) !== null && i !== void 0 ? i : new nd(this, e, r, n);
    }, t.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : Qo;
    }, t.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, t.prototype.getDelegateLogger = function(e, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, r, n);
    }, t;
  }()
), id = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, St = Symbol.for("io.opentelemetry.js.api.logs"), ze = id;
function od(t, e, r) {
  return function(n) {
    return n === t ? e : r;
  };
}
var di = 1, ad = (
  /** @class */
  function() {
    function t() {
      this._proxyLoggerProvider = new fi();
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalLoggerProvider = function(e) {
      return ze[St] ? this.getLoggerProvider() : (ze[St] = od(di, e, Qo), this._proxyLoggerProvider.setDelegate(e), e);
    }, t.prototype.getLoggerProvider = function() {
      var e, r;
      return (r = (e = ze[St]) === null || e === void 0 ? void 0 : e.call(ze, di)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, t.prototype.getLogger = function(e, r, n) {
      return this.getLoggerProvider().getLogger(e, r, n);
    }, t.prototype.disable = function() {
      delete ze[St], this._proxyLoggerProvider = new fi();
    }, t;
  }()
), sd = ad.getInstance(), Jr = function() {
  return Jr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Jr.apply(this, arguments);
}, ud = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.instrumentationName = e, this.instrumentationVersion = r, this._config = {}, this._wrap = W.wrap, this._unwrap = W.unwrap, this._massWrap = W.massWrap, this._massUnwrap = W.massUnwrap, this.setConfig(n), this._diag = m.createComponentLogger({
        namespace: e
      }), this._tracer = R.getTracer(e, r), this._meter = ft.getMeter(e, r), this._logger = sd.getLogger(e, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(t.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(t.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, t.prototype.getModuleDefinitions = function() {
      var e, r = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(r) ? r : [r];
    }, t.prototype._updateMetricInstruments = function() {
    }, t.prototype.getConfig = function() {
      return this._config;
    }, t.prototype.setConfig = function(e) {
      this._config = Jr({ enabled: !0 }, e);
    }, t.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(t.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._runSpanCustomizationHook = function(e, r, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, t;
  }()
), cd = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ld = (
  /** @class */
  function(t) {
    cd(e, t);
    function e(r, n, i) {
      var o = t.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return e;
  }(ud)
);
function fd(t, e, r) {
  var n, i;
  try {
    i = t();
  } catch (o) {
    n = o;
  } finally {
    return e(n, i), i;
  }
}
function hi(t) {
  return typeof t == "function" && typeof t.__original == "function" && typeof t.__unwrap == "function" && t.__wrapped === !0;
}
var dd = "http.method", hd = "http.url", pd = "http.host", _d = "http.scheme", vd = "http.status_code", gd = "http.user_agent", yd = "http.request_content_length_uncompressed", md = dd, Ed = hd, Td = pd, Sd = _d, wd = vd, bd = gd, Od = yd, ie;
(function(t) {
  t.METHOD_OPEN = "open", t.METHOD_SEND = "send", t.EVENT_ABORT = "abort", t.EVENT_ERROR = "error", t.EVENT_LOAD = "loaded", t.EVENT_TIMEOUT = "timeout";
})(ie || (ie = {}));
var Ad = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rd = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Nd = m.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Ld(t) {
  if (typeof Document != "undefined" && t instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (t instanceof Blob)
    return t.size;
  if (t.byteLength !== void 0)
    return t.byteLength;
  if (t instanceof FormData)
    return Pd(t);
  if (t instanceof URLSearchParams)
    return pi(t.toString());
  if (typeof t == "string")
    return pi(t);
  Nd.warn("unknown body type");
}
var Id = new TextEncoder();
function pi(t) {
  return Id.encode(t).byteLength;
}
function Pd(t) {
  var e, r, n = 0;
  try {
    for (var i = Ad(t.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Rd(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    e = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
var _i = "0.57.1", Qr;
(function(t) {
  t.HTTP_STATUS_TEXT = "http.status_text";
})(Qr || (Qr = {}));
var Cd = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xd = 300, Md = (
  /** @class */
  function(t) {
    Cd(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var n = t.call(this, "@opentelemetry/instrumentation-xml-http-request", _i, r) || this;
      return n.component = "xml-http-request", n.version = _i, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addHeaders = function(r, n) {
      var i = oe(n).href;
      if (!qo(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        X.inject(A.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      X.inject(A.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, e.prototype._addChildSpan = function(r, n) {
      var i = this;
      A.with(R.setSpan(A.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[T.FETCH_START]
        });
        ke(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[T.RESPONSE_END]);
      });
    }, e.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = oe(i);
        n.status !== void 0 && r.setAttribute(wd, n.status), n.statusText !== void 0 && r.setAttribute(Qr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Td, o.host), r.setAttribute(Sd, o.protocol.replace(":", "")), r.setAttribute(bd, navigator.userAgent);
      }
    }, e.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && fd(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, e.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = oe(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Y.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = Y.getEntriesByType("resource"));
        var c = zo(oe(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), ke(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, e.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, e.prototype._createSpan = function(r, n, i) {
      var o;
      if (xo(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: it.CLIENT,
        attributes: (o = {}, o[md] = i, o[Ed] = oe(n).toString(), o)
      });
      return u.addEvent(ie.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, e.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, e.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, e.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, h) {
        var v = f.callbackToRemoveEvents;
        typeof v == "function" && v();
        var p = f.span, y = f.spanUrl, g = f.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(f, p, y, g, d), p.addEvent(l, h), r._addFinalSpanAttributes(p, f, y), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var h = Te(), v = Date.now();
          setTimeout(function() {
            n(l, d, h, v);
          }, xd);
        }
      }
      function o() {
        i(ie.EVENT_ERROR, this);
      }
      function a() {
        i(ie.EVENT_ABORT, this);
      }
      function u() {
        i(ie.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(ie.EVENT_LOAD, this) : i(ie.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], v = 0; v < arguments.length; v++)
            h[v] = arguments[v];
          var p = r._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var y = p.span, g = p.spanUrl;
          if (y && g) {
            if (r.getConfig().measureRequestSize && (h != null && h[0])) {
              var b = h[0], L = Ld(b);
              L !== void 0 && y.setAttribute(Od, L);
            }
            A.with(R.setSpan(A.active(), y), function() {
              r._tasksCount++, p.sendStartTime = Te(), y.addEvent(ie.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, r._addHeaders(d, g), r._addResourceObserver(d, g);
            });
          }
          return l.apply(this, h);
        };
      };
    }, e.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), hi(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), hi(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, e.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, e;
  }(ld)
);
function br(t, e) {
  if (!!!t)
    throw new Error(e);
}
function kd(t) {
  return typeof t == "object" && t !== null;
}
function Dd(t, e) {
  if (!!!t)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Ud = /\r\n|[\n\r]/g;
function Zr(t, e) {
  let r = 0, n = 1;
  for (const i of t.body.matchAll(Ud)) {
    if (typeof i.index == "number" || Dd(!1), i.index >= e)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: e + 1 - r
  };
}
function Bd(t) {
  return Zo(
    t.source,
    Zr(t.source, t.start)
  );
}
function Zo(t, e) {
  const r = t.locationOffset.column - 1, n = "".padStart(r) + t.body, i = e.line - 1, o = t.locationOffset.line - 1, a = e.line + o, u = e.line === 1 ? r : 0, c = e.column + u, s = `${t.name}:${a}:${c}
`, l = n.split(/\r\n|[\n\r]/g), f = l[i];
  if (f.length > 120) {
    const d = Math.floor(c / 80), h = c % 80, v = [];
    for (let p = 0; p < f.length; p += 80)
      v.push(f.slice(p, p + 80));
    return s + vi([
      [`${a} |`, v[0]],
      ...v.slice(1, d + 1).map((p) => ["|", p]),
      ["|", "^".padStart(h)],
      ["|", v[d + 1]]
    ]);
  }
  return s + vi([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, l[i - 1]],
    [`${a} |`, f],
    ["|", "^".padStart(c)],
    [`${a + 1} |`, l[i + 1]]
  ]);
}
function vi(t) {
  const e = t.filter(([n, i]) => i !== void 0), r = Math.max(...e.map(([n]) => n.length));
  return e.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function Hd(t) {
  const e = t[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: t[1],
    positions: t[2],
    path: t[3],
    originalError: t[4],
    extensions: t[5]
  } : e;
}
class bn extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...r) {
    var n, i, o;
    const { nodes: a, source: u, positions: c, path: s, originalError: l, extensions: f } = Hd(r);
    super(e), this.name = "GraphQLError", this.path = s != null ? s : void 0, this.originalError = l != null ? l : void 0, this.nodes = gi(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const d = gi(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((v) => v.loc).filter((v) => v != null)
    );
    this.source = u != null ? u : d == null || (i = d[0]) === null || i === void 0 ? void 0 : i.source, this.positions = c != null ? c : d == null ? void 0 : d.map((v) => v.start), this.locations = c && u ? c.map((v) => Zr(u, v)) : d == null ? void 0 : d.map((v) => Zr(v.source, v.start));
    const h = kd(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (o = f != null ? f : h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, bn) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (e += `

` + Bd(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        e += `

` + Zo(this.source, r);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function gi(t) {
  return t === void 0 || t.length === 0 ? void 0 : t;
}
function D(t, e, r) {
  return new bn(`Syntax Error: ${r}`, {
    source: t,
    positions: [e]
  });
}
class Fd {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, r, n) {
    this.start = e.start, this.end = r.end, this.startToken = e, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ea {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, r, n, i, o, a) {
    this.kind = e, this.start = r, this.end = n, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Gd = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, jd = new Set(Object.keys(Gd));
function Tg(t) {
  const e = t == null ? void 0 : t.kind;
  return typeof e == "string" && jd.has(e);
}
var Pe;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(Pe || (Pe = {}));
var en;
(function(t) {
  t.QUERY = "QUERY", t.MUTATION = "MUTATION", t.SUBSCRIPTION = "SUBSCRIPTION", t.FIELD = "FIELD", t.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", t.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", t.INLINE_FRAGMENT = "INLINE_FRAGMENT", t.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", t.SCHEMA = "SCHEMA", t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.FIELD_DEFINITION = "FIELD_DEFINITION", t.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.ENUM_VALUE = "ENUM_VALUE", t.INPUT_OBJECT = "INPUT_OBJECT", t.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(en || (en = {}));
var E;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(E || (E = {}));
function tn(t) {
  return t === 9 || t === 32;
}
function at(t) {
  return t >= 48 && t <= 57;
}
function ta(t) {
  return t >= 97 && t <= 122 || // A-Z
  t >= 65 && t <= 90;
}
function ra(t) {
  return ta(t) || t === 95;
}
function Vd(t) {
  return ta(t) || at(t) || t === 95;
}
function $d(t) {
  var e;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let a = 0; a < t.length; ++a) {
    var o;
    const u = t[a], c = zd(u);
    c !== u.length && (n = (o = n) !== null && o !== void 0 ? o : a, i = a, a !== 0 && c < r && (r = c));
  }
  return t.map((a, u) => u === 0 ? a : a.slice(r)).slice(
    (e = n) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function zd(t) {
  let e = 0;
  for (; e < t.length && tn(t.charCodeAt(e)); )
    ++e;
  return e;
}
function Sg(t, e) {
  const r = t.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((h) => h.length === 0 || tn(h.charCodeAt(0))), a = r.endsWith('\\"""'), u = t.endsWith('"') && !a, c = t.endsWith("\\"), s = u || c, l = (
    // add leading and trailing new lines only if it improves readability
    !i || t.length > 70 || s || o || a
  );
  let f = "";
  const d = i && tn(t.charCodeAt(0));
  return (l && !d || o) && (f += `
`), f += r, (l || s) && (f += `
`), '"""' + f + '"""';
}
var _;
(function(t) {
  t.SOF = "<SOF>", t.EOF = "<EOF>", t.BANG = "!", t.DOLLAR = "$", t.AMP = "&", t.PAREN_L = "(", t.PAREN_R = ")", t.SPREAD = "...", t.COLON = ":", t.EQUALS = "=", t.AT = "@", t.BRACKET_L = "[", t.BRACKET_R = "]", t.BRACE_L = "{", t.PIPE = "|", t.BRACE_R = "}", t.NAME = "Name", t.INT = "Int", t.FLOAT = "Float", t.STRING = "String", t.BLOCK_STRING = "BlockString", t.COMMENT = "Comment";
})(_ || (_ = {}));
class Xd {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const r = new ea(_.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== _.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const r = Wd(this, e.end);
          e.next = r, r.prev = e, e = r;
        }
      while (e.kind === _.COMMENT);
    return e;
  }
}
function qd(t) {
  return t === _.BANG || t === _.DOLLAR || t === _.AMP || t === _.PAREN_L || t === _.PAREN_R || t === _.SPREAD || t === _.COLON || t === _.EQUALS || t === _.AT || t === _.BRACKET_L || t === _.BRACKET_R || t === _.BRACE_L || t === _.PIPE || t === _.BRACE_R;
}
function Ue(t) {
  return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
}
function Yt(t, e) {
  return na(t.charCodeAt(e)) && ia(t.charCodeAt(e + 1));
}
function na(t) {
  return t >= 55296 && t <= 56319;
}
function ia(t) {
  return t >= 56320 && t <= 57343;
}
function Se(t, e) {
  const r = t.source.body.codePointAt(e);
  if (r === void 0)
    return _.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function x(t, e, r, n, i) {
  const o = t.line, a = 1 + r - t.lineStart;
  return new ea(e, r, n, o, a, i);
}
function Wd(t, e) {
  const r = t.source.body, n = r.length;
  let i = e;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++t.line, t.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++t.line, t.lineStart = i;
        continue;
      case 35:
        return Yd(t, i);
      case 33:
        return x(t, _.BANG, i, i + 1);
      case 36:
        return x(t, _.DOLLAR, i, i + 1);
      case 38:
        return x(t, _.AMP, i, i + 1);
      case 40:
        return x(t, _.PAREN_L, i, i + 1);
      case 41:
        return x(t, _.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return x(t, _.SPREAD, i, i + 3);
        break;
      case 58:
        return x(t, _.COLON, i, i + 1);
      case 61:
        return x(t, _.EQUALS, i, i + 1);
      case 64:
        return x(t, _.AT, i, i + 1);
      case 91:
        return x(t, _.BRACKET_L, i, i + 1);
      case 93:
        return x(t, _.BRACKET_R, i, i + 1);
      case 123:
        return x(t, _.BRACE_L, i, i + 1);
      case 124:
        return x(t, _.PIPE, i, i + 1);
      case 125:
        return x(t, _.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? th(t, i) : Jd(t, i);
    }
    if (at(o) || o === 45)
      return Kd(t, i, o);
    if (ra(o))
      return rh(t, i);
    throw D(
      t.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ue(o) || Yt(r, i) ? `Unexpected character: ${Se(t, i)}.` : `Invalid character: ${Se(t, i)}.`
    );
  }
  return x(t, _.EOF, n, n);
}
function Yd(t, e) {
  const r = t.source.body, n = r.length;
  let i = e + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (Ue(o))
      ++i;
    else if (Yt(r, i))
      i += 2;
    else
      break;
  }
  return x(
    t,
    _.COMMENT,
    e,
    i,
    r.slice(e + 1, i)
  );
}
function Kd(t, e, r) {
  const n = t.source.body;
  let i = e, o = r, a = !1;
  if (o === 45 && (o = n.charCodeAt(++i)), o === 48) {
    if (o = n.charCodeAt(++i), at(o))
      throw D(
        t.source,
        i,
        `Invalid number, unexpected digit after 0: ${Se(
          t,
          i
        )}.`
      );
  } else
    i = Or(t, i, o), o = n.charCodeAt(i);
  if (o === 46 && (a = !0, o = n.charCodeAt(++i), i = Or(t, i, o), o = n.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = n.charCodeAt(++i), (o === 43 || o === 45) && (o = n.charCodeAt(++i)), i = Or(t, i, o), o = n.charCodeAt(i)), o === 46 || ra(o))
    throw D(
      t.source,
      i,
      `Invalid number, expected digit but got: ${Se(
        t,
        i
      )}.`
    );
  return x(
    t,
    a ? _.FLOAT : _.INT,
    e,
    i,
    n.slice(e, i)
  );
}
function Or(t, e, r) {
  if (!at(r))
    throw D(
      t.source,
      e,
      `Invalid number, expected digit but got: ${Se(
        t,
        e
      )}.`
    );
  const n = t.source.body;
  let i = e + 1;
  for (; at(n.charCodeAt(i)); )
    ++i;
  return i;
}
function Jd(t, e) {
  const r = t.source.body, n = r.length;
  let i = e + 1, o = i, a = "";
  for (; i < n; ) {
    const u = r.charCodeAt(i);
    if (u === 34)
      return a += r.slice(o, i), x(t, _.STRING, e, i + 1, a);
    if (u === 92) {
      a += r.slice(o, i);
      const c = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? Qd(t, i) : Zd(t, i) : eh(t, i);
      a += c.value, i += c.size, o = i;
      continue;
    }
    if (u === 10 || u === 13)
      break;
    if (Ue(u))
      ++i;
    else if (Yt(r, i))
      i += 2;
    else
      throw D(
        t.source,
        i,
        `Invalid character within String: ${Se(
          t,
          i
        )}.`
      );
  }
  throw D(t.source, i, "Unterminated string.");
}
function Qd(t, e) {
  const r = t.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const o = r.charCodeAt(e + i++);
    if (o === 125) {
      if (i < 5 || !Ue(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | We(o), n < 0)
      break;
  }
  throw D(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${r.slice(
      e,
      e + i
    )}".`
  );
}
function Zd(t, e) {
  const r = t.source.body, n = yi(r, e + 2);
  if (Ue(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (na(n) && r.charCodeAt(e + 6) === 92 && r.charCodeAt(e + 7) === 117) {
    const i = yi(r, e + 8);
    if (ia(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw D(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${r.slice(e, e + 6)}".`
  );
}
function yi(t, e) {
  return We(t.charCodeAt(e)) << 12 | We(t.charCodeAt(e + 1)) << 8 | We(t.charCodeAt(e + 2)) << 4 | We(t.charCodeAt(e + 3));
}
function We(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}
function eh(t, e) {
  const r = t.source.body;
  switch (r.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw D(
    t.source,
    e,
    `Invalid character escape sequence: "${r.slice(
      e,
      e + 2
    )}".`
  );
}
function th(t, e) {
  const r = t.source.body, n = r.length;
  let i = t.lineStart, o = e + 3, a = o, u = "";
  const c = [];
  for (; o < n; ) {
    const s = r.charCodeAt(o);
    if (s === 34 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34) {
      u += r.slice(a, o), c.push(u);
      const l = x(
        t,
        _.BLOCK_STRING,
        e,
        o + 3,
        // Return a string of the lines joined with U+000A.
        $d(c).join(`
`)
      );
      return t.line += c.length - 1, t.lineStart = i, l;
    }
    if (s === 92 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 && r.charCodeAt(o + 3) === 34) {
      u += r.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (s === 10 || s === 13) {
      u += r.slice(a, o), c.push(u), s === 13 && r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, u = "", a = o, i = o;
      continue;
    }
    if (Ue(s))
      ++o;
    else if (Yt(r, o))
      o += 2;
    else
      throw D(
        t.source,
        o,
        `Invalid character within String: ${Se(
          t,
          o
        )}.`
      );
  }
  throw D(t.source, o, "Unterminated string.");
}
function rh(t, e) {
  const r = t.source.body, n = r.length;
  let i = e + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (Vd(o))
      ++i;
    else
      break;
  }
  return x(
    t,
    _.NAME,
    e,
    i,
    r.slice(e, i)
  );
}
const nh = 10, oa = 2;
function aa(t) {
  return Kt(t, []);
}
function Kt(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return ih(t, e);
    default:
      return String(t);
  }
}
function ih(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const r = [...e, t];
  if (oh(t)) {
    const n = t.toJSON();
    if (n !== t)
      return typeof n == "string" ? n : Kt(n, r);
  } else if (Array.isArray(t))
    return sh(t, r);
  return ah(t, r);
}
function oh(t) {
  return typeof t.toJSON == "function";
}
function ah(t, e) {
  const r = Object.entries(t);
  return r.length === 0 ? "{}" : e.length > oa ? "[" + uh(t) + "]" : "{ " + r.map(
    ([i, o]) => i + ": " + Kt(o, e)
  ).join(", ") + " }";
}
function sh(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > oa)
    return "[Array]";
  const r = Math.min(nh, t.length), n = t.length - r, i = [];
  for (let o = 0; o < r; ++o)
    i.push(Kt(t[o], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function uh(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const r = t.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return e;
}
const ch = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(e, r) {
    return e instanceof r;
  } : function(e, r) {
    if (e instanceof r)
      return !0;
    if (typeof e == "object" && e !== null) {
      var n;
      const i = r.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (n = e.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === o) {
        const a = aa(e);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class sa {
  constructor(e, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || br(!1, `Body must be a string. Received: ${aa(e)}.`), this.body = e, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || br(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || br(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function lh(t) {
  return ch(t, sa);
}
function fh(t, e) {
  return new dh(t, e).parseDocument();
}
class dh {
  constructor(e, r = {}) {
    const n = lh(e) ? e : new sa(e);
    this._lexer = new Xd(n), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(_.NAME);
    return this.node(e, {
      kind: E.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: E.DOCUMENT,
      definitions: this.many(
        _.SOF,
        this.parseDefinition,
        _.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(_.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), r = e ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === _.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw D(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(_.BRACE_L))
      return this.node(e, {
        kind: E.OPERATION_DEFINITION,
        operation: Pe.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(_.NAME) && (n = this.parseName()), this.node(e, {
      kind: E.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(_.NAME);
    switch (e.value) {
      case "query":
        return Pe.QUERY;
      case "mutation":
        return Pe.MUTATION;
      case "subscription":
        return Pe.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      _.PAREN_L,
      this.parseVariableDefinition,
      _.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: E.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(_.DOLLAR), this.node(e, {
      kind: E.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: E.SELECTION_SET,
      selections: this.many(
        _.BRACE_L,
        this.parseSelection,
        _.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(_.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(_.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(e, {
      kind: E.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(_.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const r = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_.PAREN_L, r, _.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(_.COLON), this.node(r, {
      kind: E.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(_.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(_.NAME) ? this.node(e, {
      kind: E.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: E.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: E.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: E.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const r = this._lexer.token;
    switch (r.kind) {
      case _.BRACKET_L:
        return this.parseList(e);
      case _.BRACE_L:
        return this.parseObject(e);
      case _.INT:
        return this.advanceLexer(), this.node(r, {
          kind: E.INT,
          value: r.value
        });
      case _.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: E.FLOAT,
          value: r.value
        });
      case _.STRING:
      case _.BLOCK_STRING:
        return this.parseStringLiteral();
      case _.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: E.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: E.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: E.NULL
            });
          default:
            return this.node(r, {
              kind: E.ENUM,
              value: r.value
            });
        }
      case _.DOLLAR:
        if (e)
          if (this.expectToken(_.DOLLAR), this._lexer.token.kind === _.NAME) {
            const n = this._lexer.token.value;
            throw D(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: E.STRING,
      value: e.value,
      block: e.kind === _.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const r = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: E.LIST,
      values: this.any(_.BRACKET_L, r, _.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const r = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: E.OBJECT,
      fields: this.any(_.BRACE_L, r, _.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(_.COLON), this.node(r, {
      kind: E.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const r = [];
    for (; this.peek(_.AT); )
      r.push(this.parseDirective(e));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const r = this._lexer.token;
    return this.expectToken(_.AT), this.node(r, {
      kind: E.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let r;
    if (this.expectOptionalToken(_.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(_.BRACKET_R), r = this.node(e, {
        kind: E.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(_.BANG) ? this.node(e, {
      kind: E.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: E.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(_.STRING) || this.peek(_.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      _.BRACE_L,
      this.parseOperationTypeDefinition,
      _.BRACE_R
    );
    return this.node(e, {
      kind: E.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, r = this.parseOperationType();
    this.expectToken(_.COLON);
    const n = this.parseNamedType();
    return this.node(e, {
      kind: E.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: E.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: E.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(_.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseFieldDefinition,
      _.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(_.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(e, {
      kind: E.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      _.PAREN_L,
      this.parseInputValueDef,
      _.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(_.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(_.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(e, {
      kind: E.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: E.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: E.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(_.EQUALS) ? this.delimitedMany(_.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: E.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseEnumValueDefinition,
      _.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: E.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw D(
        this._lexer.source,
        this._lexer.token.start,
        `${wt(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: E.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      _.BRACE_L,
      this.parseInputValueDef,
      _.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === _.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      _.BRACE_L,
      this.parseOperationTypeDefinition,
      _.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: E.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(_.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(e, {
      kind: E.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(_.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(en, r.value))
      return r;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, r) {
    return this._options.noLocation !== !0 && (r.loc = new Fd(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const r = this._lexer.token;
    if (r.kind === e)
      return this.advanceLexer(), r;
    throw D(
      this._lexer.source,
      r.start,
      `Expected ${ua(e)}, found ${wt(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const r = this._lexer.token;
    if (r.kind === _.NAME && r.value === e)
      this.advanceLexer();
    else
      throw D(
        this._lexer.source,
        r.start,
        `Expected "${e}", found ${wt(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const r = this._lexer.token;
    return r.kind === _.NAME && r.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const r = e != null ? e : this._lexer.token;
    return D(
      this._lexer.source,
      r.start,
      `Unexpected ${wt(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, r, n) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, r, n) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, r, n) {
    this.expectToken(e);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, r) {
    this.expectOptionalToken(e);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(e));
    return n;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, r = this._lexer.advance();
    if (e !== void 0 && r.kind !== _.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw D(
        this._lexer.source,
        r.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function wt(t) {
  const e = t.value;
  return ua(t.kind) + (e != null ? ` "${e}"` : "");
}
function ua(t) {
  return qd(t) ? `"${t}"` : t;
}
const wg = 1e3, bg = 1e3 * 2, Og = 4 * 60 * 60 * 1e3, ca = 15 * 60 * 1e3, Ag = {
  normal: {
    bytes: 1e7,
    time: 4 * 60 * 1e3
  },
  canvas: {
    bytes: 16e6,
    time: 5e3
  }
}, Rg = 100, hh = "app.highlight.io";
/*! js-cookie v3.0.5 | MIT */
function bt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      t[n] = r[n];
  }
  return t;
}
var ph = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function rn(t, e) {
  function r(i, o, a) {
    if (typeof document != "undefined") {
      a = bt({}, e, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var c in a)
        a[c] && (u += "; " + c, a[c] !== !0 && (u += "=" + a[c].split(";")[0]));
      return document.cookie = i + "=" + t.write(o, i) + u;
    }
  }
  function n(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, u = 0; u < o.length; u++) {
        var c = o[u].split("="), s = c.slice(1).join("=");
        try {
          var l = decodeURIComponent(c[0]);
          if (a[l] = t.read(s, l), i === l)
            break;
        } catch (f) {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(i, o) {
        r(
          i,
          "",
          bt({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return rn(this.converter, bt({}, this.attributes, i));
      },
      withConverter: function(i) {
        return rn(bt({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var Ar = rn(ph, { path: "/" });
let On = "localStorage", nn = !0;
class _h {
  constructor() {
    S(this, "storage", {});
  }
  getItem(e) {
    var r;
    return (r = this.storage[e]) != null ? r : "";
  }
  setItem(e, r) {
    this.storage[e] = r;
  }
  removeItem(e) {
    delete this.storage[e];
  }
}
class vh {
  getItem(e) {
    var r;
    return (r = Ar.get(e)) != null ? r : "";
  }
  setItem(e, r) {
    if (!nn)
      return;
    const n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + ca), Ar.set(e, r, { expires: n });
  }
  removeItem(e) {
    nn && Ar.remove(e);
  }
}
let gh = new _h();
const Vt = new vh(), An = () => {
  try {
    switch (On) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (t) {
    return gh;
  }
}, Ng = (t) => {
  On = t;
}, yh = (t) => {
  nn = t;
}, la = (t) => An().getItem(t), fa = (t, e) => (Vt.setItem(t, e), An().setItem(t, e)), mh = (t) => (Vt.removeItem(t), An().removeItem(t)), Lg = (t) => {
  if (On === "sessionStorage") {
    console.warn(
      "highlight.io cannot use local storage; segment integration will not work"
    );
    return;
  }
  const e = window.localStorage.setItem;
  window.localStorage.setItem = function() {
    const [r, n] = arguments;
    t({ keyName: r, keyValue: n }), e.apply(this, [r, n]);
  };
};
var ht = /* @__PURE__ */ ((t) => (t.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", t.SESSION_ID = "sessionID", t.SESSION_DATA = "sessionData", t.USER_IDENTIFIER = "highlightIdentifier", t.USER_OBJECT = "highlightUserObject", t))(ht || {});
const Jt = (t) => `${ht.SESSION_DATA}_${t}`;
let da = "";
const Eh = () => da, Th = (t) => {
  t && (da = t);
}, Sh = () => {
  var t;
  return (t = la(ht.SESSION_ID)) != null ? t : "";
}, wh = (t) => {
  fa(ht.SESSION_ID, t);
}, bh = (t) => {
  const e = Jt(t);
  return JSON.parse(la(e) || "{}");
}, Rr = (t) => {
  t || (t = Sh());
  let e = bh(t);
  if (e && e.lastPushTime && Date.now() - e.lastPushTime < ca)
    return e;
  mh(Jt(t));
}, Oh = function(t) {
  if (!(t != null && t.sessionSecureID)) return;
  const e = t.sessionSecureID;
  Th(e), fa(Jt(e), JSON.stringify(t));
}, Ah = function() {
  const t = Vt.getItem(
    ht.SESSION_ID
  );
  wh(t);
  const e = Jt(t), r = Vt.getItem(e);
  try {
    Oh(JSON.parse(r));
  } catch (n) {
  }
}, mi = (t, e, r) => {
  const n = ha(
    e,
    t.headers,
    r
  );
  return U(I({}, t), {
    headers: n
  });
}, ha = (t, e, r) => {
  var i, o;
  const n = I({}, e);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...Rh, ...t].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, Rh = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], pa = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], _a = "X-Highlight-Request", Ei = (t) => {
  let e = t;
  return !t.startsWith("https://") && !t.startsWith("http://") && (e = `${window.location.origin}${e}`), e.replace(/\/+$/, "");
}, Nh = (t, {
  headersToRedact: e,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = t;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = or(l, ["request", "response"]);
  return I({
    request: mi(o, e, r),
    response: mi(a, e, r)
  }, u);
}, Ti = (t, e, r, n) => {
  t.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = t.reduce((c, s) => {
    const l = Ei(s.name);
    return s.initiatorType === r ? c[r][l] = [
      ...c[r][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = e.reduce(
    (c, s) => {
      const l = Ei(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = Nh(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, Lh = (t, e) => e.some(
  (r) => t.toLocaleLowerCase().includes(r)
), Qt = (t, e, r) => !Lh(t, e), Rn = (t, e, r) => {
  var o;
  if (r.some(
    (a) => t.toLowerCase().includes(a)
  ))
    return !1;
  let n = [];
  e === !0 ? (n = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && n.push(window.location.host)) : e instanceof Array && (n = e);
  let i = !1;
  return n.forEach((a) => {
    t.match(a) && (i = !0);
  }), i;
};
function Ih(t) {
  for (var e = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < t; i++)
    e += r.charAt(
      Math.floor(Math.random() * n)
    );
  return e;
}
const Nn = () => {
  const t = Ih(10), e = qv(), r = e == null ? void 0 : e.spanContext().traceId;
  return [Eh(), r != null ? r : t];
}, va = (t, e) => t + "/" + e, Ph = (t, e, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!Qt(
      this._url,
      e
    ))
      return c.apply(this, arguments);
    const [f, d] = Nn();
    Rn(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      _a,
      va(f, d)
    );
    const h = this._shouldRecordHeaderAndBody, v = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && l) {
      const p = Si(l, v.url);
      p && (this._body = p, v.body = fe(
        p,
        i,
        o,
        v.headers
      ));
    }
    return this.addEventListener("load", function() {
      return z(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const b = this.getAllResponseHeaders().trim().split(/[\r\n]+/), L = {};
          if (b.forEach(function(C) {
            const B = C.split(": "), G = B.shift();
            L[G] = B.join(": ");
          }), p.headers = L, l) {
            const C = Si(l, v.url);
            C && (v.body = fe(
              C,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = fe(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const C = yield this.response.text();
                p.body = fe(
                  C,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (C) {
              }
          } else
            try {
              p.body = fe(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (C) {
            }
        }
        t({
          request: v,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return z(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        t({
          request: v,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, Si = (t, e) => {
  if (typeof t == "string") {
    if (!((e != null && e.includes("localhost") || e != null && e.includes("highlight.run")) && t.includes("pushPayload")))
      return t;
  } else if (typeof t == "object" || typeof t == "number" || typeof t == "boolean")
    return Dt(t);
  return null;
}, wi = 64 * 1024, Ch = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, fe = (t, e, r, n) => {
  var o, a, u;
  let i = wi;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = Ch[c]) != null ? u : wi;
  }
  if (t) {
    if (e)
      try {
        const c = JSON.parse(t);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            e.includes(
              l.toLocaleLowerCase()
            ) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          e.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), t = JSON.stringify(c);
      } catch (c) {
      }
    if (r)
      try {
        const c = JSON.parse(t);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), t = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    t = t.slice(0, i);
  } catch (c) {
  }
  return t;
}, xh = (t, e, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = Mh(u, c);
    if (!Qt(
      l,
      e
    ))
      return a.call(this, u, c);
    const [f, d] = Nn();
    if (Rn(l, r, n)) {
      c = c || {};
      let y = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([g, b]) => y.set(g, b)
      ), y.set(
        _a,
        va(f, d)
      ), c.headers = Object.fromEntries(y.entries());
    }
    const h = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, v = !n.some(
      (y) => l.toLowerCase().includes(y)
    );
    v && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = fe(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return kh(
      p,
      h,
      t,
      v,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, Mh = (t, e) => {
  const r = e && e.method || typeof t == "object" && "method" in t && t.method || "GET";
  let n;
  return typeof t == "object" ? "url" in t && t.url ? n = t.url : n = t.toString() : n = t, {
    method: r,
    url: n
  };
}, kh = (t, e, r, n, i, o) => {
  const a = (u) => z(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = U(I({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = U(I({}, c), {
      status: u.status
    }), n && (c.body = yield ga(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = U(I({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: e,
      response: c,
      urlBlocked: l
    });
  });
  t.then(a).catch(() => {
  });
}, ga = (t, e, r) => z(void 0, null, function* () {
  let n;
  try {
    const o = t.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let l = c.value;
        s += u.decode(l);
      }
      n = s, n = fe(
        n,
        r,
        e,
        t.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var ya = (
  /** @class */
  function() {
    function t(e) {
      this._delegate = e;
    }
    return t.prototype.export = function(e, r) {
      this._delegate.export(e, r);
    }, t.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, t.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, t;
  }()
), Dh = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bi = (
  /** @class */
  function(t) {
    Dh(e, t);
    function e(r, n, i) {
      var o = t.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return e;
  }(Error)
);
function Uh(t) {
  if (!Number.isNaN(t) && Number.isFinite(t) && t > 0)
    return t;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + t + "')");
}
function Bh(t) {
  if (t != null)
    return function() {
      return t;
    };
}
function Hh(t, e, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: Uh((i = (n = t.timeoutMillis) !== null && n !== void 0 ? n : e.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = t.concurrencyLimit) !== null && o !== void 0 ? o : e.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = t.compression) !== null && u !== void 0 ? u : e.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function Fh() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Gh = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, jh = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Vh = (
  /** @class */
  function() {
    function t(e) {
      this._sendingPromises = [], this._concurrencyLimit = e;
    }
    return t.prototype.pushPromise = function(e) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(e);
      var n = function() {
        var i = r._sendingPromises.indexOf(e);
        r._sendingPromises.splice(i, 1);
      };
      e.then(n, n);
    }, t.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, t.prototype.awaitAll = function() {
      return Gh(this, void 0, void 0, function() {
        return jh(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
function $h(t) {
  return new Vh(t.concurrencyLimit);
}
function zh(t) {
  return Object.prototype.hasOwnProperty.call(t, "partialSuccess");
}
function Xh() {
  return {
    handleResponse: function(t) {
      t == null || !zh(t) || t.partialSuccess == null || Object.keys(t.partialSuccess).length === 0 || m.warn("Received Partial Success response:", JSON.stringify(t.partialSuccess));
    }
  };
}
var qh = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Wh = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Yh = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this._transport = e, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = m.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return t.prototype.export = function(e, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", e), this._promiseQueue.hasReachedLimit()) {
        r({
          code: $.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(e);
      if (i == null) {
        r({
          code: $.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: $.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: $.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: $.FAILED,
          error: new bi("Export failed with retryable status")
        }) : r({
          code: $.FAILED,
          error: new bi("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: $.FAILED,
          error: o
        });
      }));
    }, t.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, t.prototype.shutdown = function() {
      return qh(this, void 0, void 0, function() {
        return Wh(this, function(e) {
          switch (e.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return e.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
function Kh(t, e) {
  return new Yh(t.transport, t.serializer, Xh(), t.promiseHandler, e.timeout);
}
function ma(t, e, r) {
  return Kh({
    transport: r,
    serializer: e,
    promiseHandler: $h(t)
  }, { timeout: t.timeoutMillis });
}
function Ea(t) {
  var e = BigInt(1e9);
  return BigInt(t[0]) * e + BigInt(t[1]);
}
function Jh(t) {
  var e = Number(BigInt.asUintN(32, t)), r = Number(BigInt.asUintN(32, t >> BigInt(32)));
  return { low: e, high: r };
}
function Ta(t) {
  var e = Ea(t);
  return Jh(e);
}
function Qh(t) {
  var e = Ea(t);
  return e.toString();
}
var Zh = typeof BigInt != "undefined" ? Qh : ae;
function Oi(t) {
  return t;
}
function Sa(t) {
  if (t !== void 0)
    return Tn(t);
}
var ep = {
  encodeHrTime: Ta,
  encodeSpanContext: Tn,
  encodeOptionalSpanContext: Sa
};
function wa(t) {
  var e, r;
  if (t === void 0)
    return ep;
  var n = (e = t.useLongBits) !== null && e !== void 0 ? e : !0, i = (r = t.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Ta : Zh,
    encodeSpanContext: i ? Oi : Tn,
    encodeOptionalSpanContext: i ? Oi : Sa
  };
}
var tp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ba(t) {
  return {
    attributes: Ae(t.attributes),
    droppedAttributesCount: 0
  };
}
function Oa(t) {
  return {
    name: t.name,
    version: t.version
  };
}
function Ae(t) {
  return Object.keys(t).map(function(e) {
    return Aa(e, t[e]);
  });
}
function Aa(t, e) {
  return {
    key: t,
    value: Ra(e)
  };
}
function Ra(t) {
  var e = typeof t;
  return e === "string" ? { stringValue: t } : e === "number" ? Number.isInteger(t) ? { intValue: t } : { doubleValue: t } : e === "boolean" ? { boolValue: t } : t instanceof Uint8Array ? { bytesValue: t } : Array.isArray(t) ? { arrayValue: { values: t.map(Ra) } } : e === "object" && t != null ? {
    kvlistValue: {
      values: Object.entries(t).map(function(r) {
        var n = tp(r, 2), i = n[0], o = n[1];
        return Aa(i, o);
      })
    }
  } : {};
}
var Q;
(function(t) {
  t[t.DELTA = 0] = "DELTA", t[t.CUMULATIVE = 1] = "CUMULATIVE";
})(Q || (Q = {}));
var te;
(function(t) {
  t[t.HISTOGRAM = 0] = "HISTOGRAM", t[t.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", t[t.GAUGE = 2] = "GAUGE", t[t.SUM = 3] = "SUM";
})(te || (te = {}));
var rp = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ai = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Ri = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, np = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ip = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, op = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ap(t) {
  return t != null;
}
function Na(t) {
  var e = Object.keys(t);
  return e.length === 0 ? "" : (e = e.sort(), JSON.stringify(e.map(function(r) {
    return [r, t[r]];
  })));
}
function sp(t) {
  var e, r;
  return t.name + ":" + ((e = t.version) !== null && e !== void 0 ? e : "") + ":" + ((r = t.schemaUrl) !== null && r !== void 0 ? r : "");
}
var La = (
  /** @class */
  function(t) {
    rp(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return Object.setPrototypeOf(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function st(t, e) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new La("Operation timed out."));
    }, e);
  });
  return Promise.race([t, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function up(t) {
  return Ai(this, void 0, void 0, function() {
    var e = this;
    return Ri(this, function(r) {
      return [2, Promise.all(t.map(function(n) {
        return Ai(e, void 0, void 0, function() {
          var i, o;
          return Ri(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function cp(t) {
  return t.status === "rejected";
}
function Ni(t, e) {
  var r = [];
  return t.forEach(function(n) {
    r.push.apply(r, ip([], np(e(n)), !1));
  }), r;
}
function lp(t, e) {
  var r, n;
  if (t.size !== e.size)
    return !1;
  try {
    for (var i = op(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!e.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function fp(t, e) {
  for (var r = 0, n = t.length - 1, i = t.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    t[o] < e ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function dp(t, e) {
  return t.toLowerCase() === e.toLowerCase();
}
var we;
(function(t) {
  t[t.DROP = 0] = "DROP", t[t.SUM = 1] = "SUM", t[t.LAST_VALUE = 2] = "LAST_VALUE", t[t.HISTOGRAM = 3] = "HISTOGRAM", t[t.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(we || (we = {}));
var hp = (
  /** @class */
  function() {
    function t() {
      this.kind = we.DROP;
    }
    return t.prototype.createAccumulation = function() {
    }, t.prototype.merge = function(e, r) {
    }, t.prototype.diff = function(e, r) {
    }, t.prototype.toMetricData = function(e, r, n, i) {
    }, t;
  }()
), w;
(function(t) {
  t.COUNTER = "COUNTER", t.GAUGE = "GAUGE", t.HISTOGRAM = "HISTOGRAM", t.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", t.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", t.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", t.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(w || (w = {}));
function ce(t, e, r) {
  var n, i, o, a;
  return gp(t) || m.warn('Invalid metric name: "' + t + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: t,
    type: e,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : de.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function pp(t, e) {
  var r, n;
  return {
    name: (r = t.name) !== null && r !== void 0 ? r : e.name,
    description: (n = t.description) !== null && n !== void 0 ? n : e.description,
    type: e.type,
    unit: e.unit,
    valueType: e.valueType,
    advice: e.advice
  };
}
function _p(t, e) {
  return dp(t.name, e.name) && t.unit === e.unit && t.type === e.type && t.valueType === e.valueType;
}
var vp = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function gp(t) {
  return t.match(vp) != null;
}
var yp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function mp(t) {
  var e = t.map(function() {
    return 0;
  });
  return e.push(0), {
    buckets: {
      boundaries: t,
      counts: e
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var Nr = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = mp(r)), this.startTime = e, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return t.prototype.record = function(e) {
      if (!Number.isNaN(e)) {
        this._current.count += 1, this._current.sum += e, this._recordMinMax && (this._current.min = Math.min(e, this._current.min), this._current.max = Math.max(e, this._current.max), this._current.hasMinMax = !0);
        var r = fp(this._boundaries, e);
        this._current.buckets.counts[r] += 1;
      }
    }, t.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, t.prototype.toPointValue = function() {
      return this._current;
    }, t;
  }()
), Ia = (
  /** @class */
  function() {
    function t(e, r) {
      this._boundaries = e, this._recordMinMax = r, this.kind = we.HISTOGRAM;
    }
    return t.prototype.createAccumulation = function(e) {
      return new Nr(e, this._boundaries, this._recordMinMax);
    }, t.prototype.merge = function(e, r) {
      for (var n = e.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new Nr(e.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, t.prototype.diff = function(e, r) {
      for (var n = e.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new Nr(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, t.prototype.toMetricData = function(e, r, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: r,
        dataPointType: te.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = yp(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = e.type === w.GAUGE || e.type === w.UP_DOWN_COUNTER || e.type === w.OBSERVABLE_GAUGE || e.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, t;
  }()
), Lr = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ir = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Li = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      e === void 0 && (e = new Ep()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = e, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(t.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.counts = function() {
      var e = this;
      return Array.from({ length: this.length }, function(r, n) {
        return e.at(n);
      });
    }, t.prototype.at = function(e) {
      var r = this.indexBase - this.indexStart;
      return e < r && (e += this.backing.length), e -= r, this.backing.countAt(e);
    }, t.prototype.incrementBucket = function(e, r) {
      this.backing.increment(e, r);
    }, t.prototype.decrementBucket = function(e, r) {
      this.backing.decrement(e, r);
    }, t.prototype.trim = function() {
      for (var e = 0; e < this.length; e++)
        if (this.at(e) !== 0) {
          this.indexStart += e;
          break;
        } else if (e === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var e = this.length - 1; e >= 0; e--)
        if (this.at(e) !== 0) {
          this.indexEnd -= this.length - e - 1;
          break;
        }
      this._rotate();
    }, t.prototype.downscale = function(e) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << e, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= e, this.indexEnd >>= e, this.indexBase = this.indexStart;
    }, t.prototype.clone = function() {
      return new t(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, t.prototype._rotate = function() {
      var e = this.indexBase - this.indexStart;
      e !== 0 && (e > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, e), this.backing.reverse(e, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + e)), this.indexBase = this.indexStart);
    }, t.prototype._relocateBucket = function(e, r) {
      e !== r && this.incrementBucket(e, this.backing.emptyBucket(r));
    }, t;
  }()
), Ep = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = [0]), this._counts = e;
    }
    return Object.defineProperty(t.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.countAt = function(e) {
      return this._counts[e];
    }, t.prototype.growTo = function(e, r, n) {
      var i = new Array(e).fill(0);
      i.splice.apply(i, Ir([
        n,
        this._counts.length - r
      ], Lr(this._counts.slice(r)), !1)), i.splice.apply(i, Ir([0, r], Lr(this._counts.slice(0, r)), !1)), this._counts = i;
    }, t.prototype.reverse = function(e, r) {
      for (var n = Math.floor((e + r) / 2) - e, i = 0; i < n; i++) {
        var o = this._counts[e + i];
        this._counts[e + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, t.prototype.emptyBucket = function(e) {
      var r = this._counts[e];
      return this._counts[e] = 0, r;
    }, t.prototype.increment = function(e, r) {
      this._counts[e] += r;
    }, t.prototype.decrement = function(e, r) {
      this._counts[e] >= r ? this._counts[e] -= r : this._counts[e] = 0;
    }, t.prototype.clone = function() {
      return new t(Ir([], Lr(this._counts), !1));
    }, t;
  }()
), Tp = 52, Sp = 2146435072, wp = 1048575, Pa = 1023, Ca = -1022, xa = Pa, on = Math.pow(2, -1022);
function Ma(t) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, t);
  var r = e.getUint32(0), n = (r & Sp) >> 20;
  return n - Pa;
}
function ka(t) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, t);
  var r = e.getUint32(0), n = e.getUint32(4), i = (r & wp) * Math.pow(2, 32);
  return i + n;
}
function an(t, e) {
  return t === 0 || t === Number.POSITIVE_INFINITY || t === Number.NEGATIVE_INFINITY || Number.isNaN(t) ? t : t * Math.pow(2, e);
}
function bp(t) {
  return t--, t |= t >> 1, t |= t >> 2, t |= t >> 4, t |= t >> 8, t |= t >> 16, t++, t;
}
var Op = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ut = (
  /** @class */
  function(t) {
    Op(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(Error)
), Ap = (
  /** @class */
  function() {
    function t(e) {
      this._shift = -e;
    }
    return t.prototype.mapToIndex = function(e) {
      if (e < on)
        return this._minNormalLowerBoundaryIndex();
      var r = Ma(e), n = this._rightShift(ka(e) - 1, Tp);
      return r + n >> this._shift;
    }, t.prototype.lowerBoundary = function(e) {
      var r = this._minNormalLowerBoundaryIndex();
      if (e < r)
        throw new ut("underflow: " + e + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (e > n)
        throw new ut("overflow: " + e + " is > maximum lower boundary: " + n);
      return an(1, e << this._shift);
    }, Object.defineProperty(t.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._minNormalLowerBoundaryIndex = function() {
      var e = Ca >> this._shift;
      return this._shift < 2 && e--, e;
    }, t.prototype._maxNormalLowerBoundaryIndex = function() {
      return xa >> this._shift;
    }, t.prototype._rightShift = function(e, r) {
      return Math.floor(e * Math.pow(2, -r));
    }, t;
  }()
), Rp = (
  /** @class */
  function() {
    function t(e) {
      this._scale = e, this._scaleFactor = an(Math.LOG2E, e), this._inverseFactor = an(Math.LN2, -e);
    }
    return t.prototype.mapToIndex = function(e) {
      if (e <= on)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (ka(e) === 0) {
        var r = Ma(e);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(e) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, t.prototype.lowerBoundary = function(e) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (e >= r) {
        if (e === r)
          return 2 * Math.exp((e - (1 << this._scale)) / this._scaleFactor);
        throw new ut("overflow: " + e + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (e <= n) {
        if (e === n)
          return on;
        if (e === n - 1)
          return Math.exp((e + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new ut("overflow: " + e + " is < minimum lower boundary: " + n);
      }
      return Math.exp(e * this._inverseFactor);
    }, Object.defineProperty(t.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._minNormalLowerBoundaryIndex = function() {
      return Ca << this._scale;
    }, t.prototype._maxNormalLowerBoundaryIndex = function() {
      return (xa + 1 << this._scale) - 1;
    }, t;
  }()
), Ii = -10, Pi = 20, Np = Array.from({ length: 31 }, function(t, e) {
  return e > 10 ? new Rp(e - 10) : new Ap(e - 10);
});
function Ci(t) {
  if (t > Pi || t < Ii)
    throw new ut("expected scale >= " + Ii + " && <= " + Pi + ", got: " + t);
  return Np[t + 10];
}
var Lp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ot = (
  /** @class */
  function() {
    function t(e, r) {
      this.low = e, this.high = r;
    }
    return t.combine = function(e, r) {
      return new t(Math.min(e.low, r.low), Math.max(e.high, r.high));
    }, t;
  }()
), Ip = 20, Pp = 160, Pr = 2, Cp = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, u, c, s, l, f) {
      e === void 0 && (e = e), r === void 0 && (r = Pp), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Li()), l === void 0 && (l = new Li()), f === void 0 && (f = Ci(Ip)), this.startTime = e, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < Pr && (m.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Pr), this._maxSize = Pr);
    }
    return t.prototype.record = function(e) {
      this.updateByIncrement(e, 1);
    }, t.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, t.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(t.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateByIncrement = function(e, r) {
      if (!Number.isNaN(e)) {
        if (e > this._max && (this._max = e), e < this._min && (this._min = e), this._count += r, e === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += e * r, e > 0 ? this._updateBuckets(this._positive, e, r) : this._updateBuckets(this._negative, -e, r);
      }
    }, t.prototype.merge = function(e) {
      this._count === 0 ? (this._min = e.min, this._max = e.max) : e.count !== 0 && (e.min < this.min && (this._min = e.min), e.max > this.max && (this._max = e.max)), this.startTime = e.startTime, this._sum += e.sum, this._count += e.count, this._zeroCount += e.zeroCount;
      var r = this._minScale(e);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, e, e.positive, r), this._mergeBuckets(this.negative, e, e.negative, r);
    }, t.prototype.diff = function(e) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= e.sum, this._count -= e.count, this._zeroCount -= e.zeroCount;
      var r = this._minScale(e);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, e, e.positive, r), this._diffBuckets(this.negative, e, e.negative, r);
    }, t.prototype.clone = function() {
      return new t(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, t.prototype._updateBuckets = function(e, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (e.length === 0 ? (e.indexStart = i, e.indexEnd = e.indexStart, e.indexBase = e.indexStart) : i < e.indexStart && e.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = e.indexEnd) : i > e.indexEnd && i - e.indexStart >= this._maxSize && (o = !0, u = e.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(e, i, n);
    }, t.prototype._incrementIndexBy = function(e, r, n) {
      if (n !== 0) {
        if (e.length === 0 && (e.indexStart = e.indexEnd = e.indexBase = r), r < e.indexStart) {
          var i = e.indexEnd - r;
          i >= e.backing.length && this._grow(e, i + 1), e.indexStart = r;
        } else if (r > e.indexEnd) {
          var i = r - e.indexStart;
          i >= e.backing.length && this._grow(e, i + 1), e.indexEnd = r;
        }
        var o = r - e.indexBase;
        o < 0 && (o += e.backing.length), e.incrementBucket(o, n);
      }
    }, t.prototype._grow = function(e, r) {
      var n = e.backing.length, i = e.indexBase - e.indexStart, o = n - i, a = bp(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      e.backing.growTo(a, o, u);
    }, t.prototype._changeScale = function(e, r) {
      for (var n = 0; e - r >= this._maxSize; )
        e >>= 1, r >>= 1, n++;
      return n;
    }, t.prototype._downscale = function(e) {
      if (e !== 0) {
        if (e < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - e;
        this._positive.downscale(e), this._negative.downscale(e), this._mapping = Ci(r);
      }
    }, t.prototype._minScale = function(e) {
      var r = Math.min(this.scale, e.scale), n = Ot.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(e.positive, e.scale, r)), i = Ot.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(e.negative, e.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, t.prototype._highLowAtScale = function(e, r, n) {
      if (e.length === 0)
        return new Ot(0, -1);
      var i = r - n;
      return new Ot(e.indexStart >> i, e.indexEnd >> i);
    }, t.prototype._mergeBuckets = function(e, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(e, o + u >> a, n.at(u));
    }, t.prototype._diffBuckets = function(e, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - e.indexBase;
        s < 0 && (s += e.backing.length), e.decrementBucket(s, n.at(u));
      }
      e.trim();
    }, t;
  }()
), xp = (
  /** @class */
  function() {
    function t(e, r) {
      this._maxSize = e, this._recordMinMax = r, this.kind = we.EXPONENTIAL_HISTOGRAM;
    }
    return t.prototype.createAccumulation = function(e) {
      return new Cp(e, this._maxSize, this._recordMinMax);
    }, t.prototype.merge = function(e, r) {
      var n = r.clone();
      return n.merge(e), n;
    }, t.prototype.diff = function(e, r) {
      var n = r.clone();
      return n.diff(e), n;
    }, t.prototype.toMetricData = function(e, r, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: r,
        dataPointType: te.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Lp(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = e.type === w.GAUGE || e.type === w.UP_DOWN_COUNTER || e.type === w.OBSERVABLE_GAUGE || e.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, t;
  }()
), Mp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Cr = (
  /** @class */
  function() {
    function t(e, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = e, this._current = r, this.sampleTime = n;
    }
    return t.prototype.record = function(e) {
      this._current = e, this.sampleTime = q(Date.now());
    }, t.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, t.prototype.toPointValue = function() {
      return this._current;
    }, t;
  }()
), kp = (
  /** @class */
  function() {
    function t() {
      this.kind = we.LAST_VALUE;
    }
    return t.prototype.createAccumulation = function(e) {
      return new Cr(e);
    }, t.prototype.merge = function(e, r) {
      var n = gt(r.sampleTime) >= gt(e.sampleTime) ? r : e;
      return new Cr(e.startTime, n.toPointValue(), n.sampleTime);
    }, t.prototype.diff = function(e, r) {
      var n = gt(r.sampleTime) >= gt(e.sampleTime) ? r : e;
      return new Cr(r.startTime, n.toPointValue(), n.sampleTime);
    }, t.prototype.toMetricData = function(e, r, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: r,
        dataPointType: te.GAUGE,
        dataPoints: n.map(function(o) {
          var a = Mp(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, t;
  }()
), Dp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Xe = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = e, this.monotonic = r, this._current = n, this.reset = i;
    }
    return t.prototype.record = function(e) {
      this.monotonic && e < 0 || (this._current += e);
    }, t.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, t.prototype.toPointValue = function() {
      return this._current;
    }, t;
  }()
), xi = (
  /** @class */
  function() {
    function t(e) {
      this.monotonic = e, this.kind = we.SUM;
    }
    return t.prototype.createAccumulation = function(e) {
      return new Xe(e, this.monotonic);
    }, t.prototype.merge = function(e, r) {
      var n = e.toPointValue(), i = r.toPointValue();
      return r.reset ? new Xe(r.startTime, this.monotonic, i, r.reset) : new Xe(e.startTime, this.monotonic, n + i);
    }, t.prototype.diff = function(e, r) {
      var n = e.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new Xe(r.startTime, this.monotonic, i, !0) : new Xe(r.startTime, this.monotonic, i - n);
    }, t.prototype.toMetricData = function(e, r, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: r,
        dataPointType: te.SUM,
        dataPoints: n.map(function(o) {
          var a = Dp(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, t;
  }()
), Re = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ue = (
  /** @class */
  function() {
    function t() {
    }
    return t.Drop = function() {
      return Da;
    }, t.Sum = function() {
      return Ua;
    }, t.LastValue = function() {
      return Ba;
    }, t.Histogram = function() {
      return Ha;
    }, t.ExponentialHistogram = function() {
      return $p;
    }, t.Default = function() {
      return zp;
    }, t;
  }()
), Up = (
  /** @class */
  function(t) {
    Re(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(r) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new hp(), e;
  }(ue)
), Bp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(r) {
      switch (r.type) {
        case w.COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.HISTOGRAM:
          return e.MONOTONIC_INSTANCE;
        default:
          return e.NON_MONOTONIC_INSTANCE;
      }
    }, e.MONOTONIC_INSTANCE = new xi(!0), e.NON_MONOTONIC_INSTANCE = new xi(!1), e;
  }(ue)
), Hp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(r) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new kp(), e;
  }(ue)
), Fp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(r) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new Ia([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), e;
  }(ue)
), Gp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e(r, n) {
      n === void 0 && (n = !0);
      var i = t.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return e.prototype.createAggregator = function(r) {
      return new Ia(this._boundaries, this._recordMinMax);
    }, e;
  }(ue)
), jp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = t.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return e.prototype.createAggregator = function(r) {
      return new xp(this._maxSize, this._recordMinMax);
    }, e;
  }(ue)
), Vp = (
  /** @class */
  function(t) {
    Re(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype._resolve = function(r) {
      switch (r.type) {
        case w.COUNTER:
        case w.UP_DOWN_COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.OBSERVABLE_UP_DOWN_COUNTER:
          return Ua;
        case w.GAUGE:
        case w.OBSERVABLE_GAUGE:
          return Ba;
        case w.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new Gp(r.advice.explicitBucketBoundaries) : Ha;
      }
      return m.warn("Unable to recognize instrument type: " + r.type), Da;
    }, e.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, e;
  }(ue)
), Da = new Up(), Ua = new Bp(), Ba = new Hp(), Ha = new Fp(), $p = new jp(), zp = new Vp(), Xp = function(t) {
  return ue.Default();
}, qp = function(t) {
  return Q.CUMULATIVE;
}, xr = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Mr = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Mi = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Wp = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Yp = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = e == null ? void 0 : e.aggregationSelector) !== null && r !== void 0 ? r : Xp, this._aggregationTemporalitySelector = (n = e == null ? void 0 : e.aggregationTemporalitySelector) !== null && n !== void 0 ? n : qp, this._metricProducers = (i = e == null ? void 0 : e.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = e == null ? void 0 : e.cardinalitySelector;
    }
    return t.prototype.setMetricProducer = function(e) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = e, this.onInitialized();
    }, t.prototype.selectAggregation = function(e) {
      return this._aggregationSelector(e);
    }, t.prototype.selectAggregationTemporality = function(e) {
      return this._aggregationTemporalitySelector(e);
    }, t.prototype.selectCardinalityLimit = function(e) {
      return this._cardinalitySelector ? this._cardinalitySelector(e) : 2e3;
    }, t.prototype.onInitialized = function() {
    }, t.prototype.collect = function(e) {
      return xr(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return Mr(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(Wp([
                this._sdkMetricProducer.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                })
              ], Mi(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = Mi.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(Ni(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(Ni(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, t.prototype.shutdown = function(e) {
      return xr(this, void 0, void 0, function() {
        return Mr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, st(this.onShutdown(), e.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.forceFlush = function(e) {
      return xr(this, void 0, void 0, function() {
        return Mr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, st(this.onForceFlush(), e.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), Kp = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), At = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Rt = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Jp = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Qp = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Zp = (
  /** @class */
  function(t) {
    Kp(e, t);
    function e(r) {
      var n, i, o, a, u = t.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return e.prototype._runOnce = function() {
      return At(this, void 0, void 0, function() {
        var r;
        return Rt(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, st(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof La ? (m.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (he(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._doRun = function() {
      var r, n;
      return At(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Rt(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = m).error.apply(s, Qp(["PeriodicExportingMetricReader: metrics collection errors"], Jp(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), m.debug("Error while resolving async portion of resource: ", u), he(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Yc._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== $.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, e.prototype.onForceFlush = function() {
      return At(this, void 0, void 0, function() {
        return Rt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onShutdown = function() {
      return At(this, void 0, void 0, function() {
        return Rt(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(Yp)
), e_ = (
  /** @class */
  function() {
    function t() {
      this._registeredViews = [];
    }
    return t.prototype.addView = function(e) {
      this._registeredViews.push(e);
    }, t.prototype.findViews = function(e, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, e) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, t.prototype._matchInstrument = function(e, r) {
      return (e.getType() === void 0 || r.type === e.getType()) && e.getNameFilter().match(r.name) && e.getUnitFilter().match(r.unit);
    }, t.prototype._matchMeter = function(e, r) {
      return e.getNameFilter().match(r.name) && (r.version === void 0 || e.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || e.getSchemaUrlFilter().match(r.schemaUrl));
    }, t;
  }()
), Ne = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Zt = (
  /** @class */
  function() {
    function t(e, r) {
      this._writableMetricStorage = e, this._descriptor = r;
    }
    return t.prototype._record = function(e, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = A.active()), typeof e != "number") {
        m.warn("non-number value provided to metric " + this._descriptor.name + ": " + e);
        return;
      }
      this._descriptor.valueType === de.INT && !Number.isInteger(e) && (m.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._writableMetricStorage.record(e, r, n, q(Date.now()));
    }, t;
  }()
), t_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, e;
  }(Zt)
), r_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(r, n, i) {
      if (r < 0) {
        m.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, e;
  }(Zt)
), n_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, e;
  }(Zt)
), i_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(r, n, i) {
      if (r < 0) {
        m.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, e;
  }(Zt)
), er = (
  /** @class */
  function() {
    function t(e, r, n) {
      this._observableRegistry = n, this._descriptor = e, this._metricStorages = r;
    }
    return t.prototype.addCallback = function(e) {
      this._observableRegistry.addCallback(e, this);
    }, t.prototype.removeCallback = function(e) {
      this._observableRegistry.removeCallback(e, this);
    }, t;
  }()
), o_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(er)
), a_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(er)
), s_ = (
  /** @class */
  function(t) {
    Ne(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(er)
);
function sn(t) {
  return t instanceof er;
}
var u_ = (
  /** @class */
  function() {
    function t(e) {
      this._meterSharedState = e;
    }
    return t.prototype.createGauge = function(e, r) {
      var n = ce(e, w.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new n_(i, n);
    }, t.prototype.createHistogram = function(e, r) {
      var n = ce(e, w.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new i_(i, n);
    }, t.prototype.createCounter = function(e, r) {
      var n = ce(e, w.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new r_(i, n);
    }, t.prototype.createUpDownCounter = function(e, r) {
      var n = ce(e, w.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new t_(i, n);
    }, t.prototype.createObservableGauge = function(e, r) {
      var n = ce(e, w.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new a_(n, i, this._meterSharedState.observableRegistry);
    }, t.prototype.createObservableCounter = function(e, r) {
      var n = ce(e, w.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new o_(n, i, this._meterSharedState.observableRegistry);
    }, t.prototype.createObservableUpDownCounter = function(e, r) {
      var n = ce(e, w.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new s_(n, i, this._meterSharedState.observableRegistry);
    }, t.prototype.addBatchObservableCallback = function(e, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(e, r);
    }, t.prototype.removeBatchObservableCallback = function(e, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(e, r);
    }, t;
  }()
), Fa = (
  /** @class */
  function() {
    function t(e) {
      this._instrumentDescriptor = e;
    }
    return t.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, t.prototype.updateDescription = function(e) {
      this._instrumentDescriptor = ce(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: e,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, t;
  }()
), c_ = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ki = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, l_ = (
  /** @class */
  function() {
    function t(e) {
      this._hash = e, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return t.prototype.get = function(e, r) {
      return r != null || (r = this._hash(e)), this._valueMap.get(r);
    }, t.prototype.getOrDefault = function(e, r) {
      var n = this._hash(e);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, i), i;
    }, t.prototype.set = function(e, r, n) {
      n != null || (n = this._hash(e)), this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, r);
    }, t.prototype.has = function(e, r) {
      return r != null || (r = this._hash(e)), this._valueMap.has(r);
    }, t.prototype.keys = function() {
      var e, r;
      return ki(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._keyMap.entries(), r = e.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, t.prototype.entries = function() {
      var e, r;
      return ki(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._valueMap.entries(), r = e.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(t.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
), me = (
  /** @class */
  function(t) {
    c_(e, t);
    function e() {
      return t.call(this, Na) || this;
    }
    return e;
  }(l_)
), f_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ga = (
  /** @class */
  function() {
    function t(e, r) {
      this._aggregator = e, this._activeCollectionStorage = new me(), this._cumulativeMemoStorage = new me(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = Na(this._overflowAttributes);
    }
    return t.prototype.record = function(e, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(e);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(e);
    }, t.prototype.batchCumulate = function(e, r) {
      var n = this;
      Array.from(e.entries()).forEach(function(i) {
        var o = f_(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, t.prototype.collect = function() {
      var e = this._activeCollectionStorage;
      return this._activeCollectionStorage = new me(), e;
    }, t;
  }()
), kr = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Di = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ja = (
  /** @class */
  function() {
    function t(e, r) {
      var n = this;
      this._aggregator = e, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return t.prototype.buildMetrics = function(e, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(e), a = o, u;
      if (this._reportHistory.has(e)) {
        var c = this._reportHistory.get(e), s = c.collectionTime;
        u = c.aggregationTemporality, u === Q.CUMULATIVE ? a = t.merge(c.accumulations, o, this._aggregator) : a = t.calibrateStartTime(c.accumulations, o, s);
      } else
        u = e.selectAggregationTemporality(r.type);
      this._reportHistory.set(e, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = d_(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, t.prototype._stashAccumulations = function(e) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = kr(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(e);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype._getMergedUnreportedAccumulations = function(e) {
      var r, n, i = new me(), o = this._unreportedAccumulations.get(e);
      if (this._unreportedAccumulations.set(e, []), o === void 0)
        return i;
      try {
        for (var a = kr(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = t.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, t.merge = function(e, r, n) {
      for (var i = e, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = Di(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (e.has(c, l)) {
          var f = e.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, t.calibrateStartTime = function(e, r, n) {
      var i, o;
      try {
        for (var a = kr(e.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = Di(u.value, 2), s = c[0], l = c[1], f = r.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, t;
  }()
);
function d_(t) {
  return Array.from(t.entries());
}
var h_ = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), p_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, __ = (
  /** @class */
  function(t) {
    h_(e, t);
    function e(r, n, i, o, a) {
      var u = t.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Ga(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ja(n, o), u;
    }
    return e.prototype.record = function(r, n) {
      var i = this, o = new me();
      Array.from(r.entries()).forEach(function(a) {
        var u = p_(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, e.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, e;
  }(Fa)
);
function Ui(t, e) {
  var r = "";
  return t.unit !== e.unit && (r += "	- Unit '" + t.unit + "' does not match '" + e.unit + `'
`), t.type !== e.type && (r += "	- Type '" + t.type + "' does not match '" + e.type + `'
`), t.valueType !== e.valueType && (r += "	- Value Type '" + t.valueType + "' does not match '" + e.valueType + `'
`), t.description !== e.description && (r += "	- Description '" + t.description + "' does not match '" + e.description + `'
`), r;
}
function v_(t, e) {
  return "	- use valueType '" + t.valueType + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function g_(t, e) {
  return "	- use unit '" + t.unit + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function y_(t, e) {
  var r = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + t.name + "' and InstrumentSelector '" + n + "'";
}
function m_(t, e) {
  var r = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + t.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + t.name + " and description '" + t.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + e.name + " and description '" + t.description + "' and InstrumentSelector " + n;
}
function Bi(t, e) {
  return t.valueType !== e.valueType ? v_(t, e) : t.unit !== e.unit ? g_(t, e) : t.type !== e.type ? y_(t, e) : t.description !== e.description ? m_(t, e) : "";
}
var Dr = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, E_ = (
  /** @class */
  function() {
    function t() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return t.create = function() {
      return new t();
    }, t.prototype.getStorages = function(e) {
      var r, n, i, o, a = [];
      try {
        for (var u = Dr(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(e);
      if (l != null)
        try {
          for (var f = Dr(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, t.prototype.register = function(e) {
      this._registerStorage(e, this._sharedRegistry);
    }, t.prototype.registerForCollector = function(e, r) {
      var n = this._perCollectorRegistry.get(e);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(e, n)), this._registerStorage(r, n);
    }, t.prototype.findOrUpdateCompatibleStorage = function(e) {
      var r = this._sharedRegistry.get(e.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(e, r);
    }, t.prototype.findOrUpdateCompatibleCollectorStorage = function(e, r) {
      var n = this._perCollectorRegistry.get(e);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, t.prototype._registerStorage = function(e, r) {
      var n = e.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [e]);
        return;
      }
      i.push(e);
    }, t.prototype._findOrUpdateCompatibleStorage = function(e, r) {
      var n, i, o = null;
      try {
        for (var a = Dr(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          _p(s, e) ? (s.description !== e.description && (e.description.length > s.description.length && c.updateDescription(e.description), m.warn("A view or instrument with the name ", e.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Ui(s, e), `The longer description will be used.
To resolve the conflict:`, Bi(s, e))), o = c) : m.warn("A view or instrument with the name ", e.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Ui(s, e), `To resolve the conflict:
`, Bi(s, e));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, t;
  }()
), T_ = (
  /** @class */
  function() {
    function t(e) {
      this._backingStorages = e;
    }
    return t.prototype.record = function(e, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(e, r, n, i);
      });
    }, t;
  }()
), S_ = (
  /** @class */
  function() {
    function t(e, r) {
      this._instrumentName = e, this._valueType = r, this._buffer = new me();
    }
    return t.prototype.observe = function(e, r) {
      if (r === void 0 && (r = {}), typeof e != "number") {
        m.warn("non-number value provided to metric " + this._instrumentName + ": " + e);
        return;
      }
      this._valueType === de.INT && !Number.isInteger(e) && (m.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._buffer.set(r, e);
    }, t;
  }()
), w_ = (
  /** @class */
  function() {
    function t() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return t.prototype.observe = function(e, r, n) {
      if (n === void 0 && (n = {}), !!sn(e)) {
        var i = this._buffer.get(e);
        if (i == null && (i = new me(), this._buffer.set(e, i)), typeof r != "number") {
          m.warn("non-number value provided to metric " + e._descriptor.name + ": " + r);
          return;
        }
        e._descriptor.valueType === de.INT && !Number.isInteger(r) && (m.warn("INT value type cannot accept a floating-point value for " + e._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, t;
  }()
), Ur = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Br = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Hi = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fi = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, b_ = (
  /** @class */
  function() {
    function t() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return t.prototype.addCallback = function(e, r) {
      var n = this._findCallback(e, r);
      n >= 0 || this._callbacks.push({ callback: e, instrument: r });
    }, t.prototype.removeCallback = function(e, r) {
      var n = this._findCallback(e, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, t.prototype.addBatchCallback = function(e, r) {
      var n = new Set(r.filter(sn));
      if (n.size === 0) {
        m.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(e, n);
      i >= 0 || this._batchCallbacks.push({ callback: e, instruments: n });
    }, t.prototype.removeBatchCallback = function(e, r) {
      var n = new Set(r.filter(sn)), i = this._findBatchCallback(e, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, t.prototype.observe = function(e, r) {
      return Ur(this, void 0, void 0, function() {
        var n, i, o, a;
        return Br(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(e, r), i = this._observeBatchCallbacks(e, r), [4, up(Fi(Fi([], Hi(n), !1), Hi(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(cp).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, t.prototype._observeCallbacks = function(e, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return Ur(n, void 0, void 0, function() {
          var u, c;
          return Br(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new S_(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = st(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, e);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, t.prototype._observeBatchCallbacks = function(e, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return Ur(n, void 0, void 0, function() {
          var u, c;
          return Br(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new w_(), c = Promise.resolve(o(u)), r != null && (c = st(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, e);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, t.prototype._findCallback = function(e, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === e && n.instrument === r;
      });
    }, t.prototype._findBatchCallback = function(e, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === e && lp(n.instruments, r);
      });
    }, t;
  }()
), O_ = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), A_ = (
  /** @class */
  function(t) {
    O_(e, t);
    function e(r, n, i, o, a) {
      var u = t.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Ga(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new ja(n, o), u;
    }
    return e.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, e.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, e;
  }(Fa)
), Va = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ln = (
  /** @class */
  function() {
    function t() {
    }
    return t.Noop = function() {
      return N_;
    }, t;
  }()
), R_ = (
  /** @class */
  function(t) {
    Va(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.process = function(r, n) {
      return r;
    }, e;
  }(Ln)
);
(function(t) {
  Va(e, t);
  function e(r) {
    var n = t.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return e.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, e;
})(Ln);
var N_ = new R_(), L_ = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, I_ = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, P_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, C_ = (
  /** @class */
  function() {
    function t(e, r) {
      this._meterProviderSharedState = e, this._instrumentationScope = r, this.metricStorageRegistry = new E_(), this.observableRegistry = new b_(), this.meter = new u_(this);
    }
    return t.prototype.registerMetricStorage = function(e) {
      var r = this._registerMetricStorage(e, A_);
      return r.length === 1 ? r[0] : new T_(r);
    }, t.prototype.registerAsyncMetricStorage = function(e) {
      var r = this._registerMetricStorage(e, __);
      return r;
    }, t.prototype.collect = function(e, r, n) {
      return L_(this, void 0, void 0, function() {
        var i, o, a;
        return I_(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(e), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(e, r);
              }).filter(ap), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, t.prototype._registerMetricStorage = function(e, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(e, this._instrumentationScope), o = i.map(function(c) {
        var s = pp(c, e), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new r(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(e.type), u = a.map(function(c) {
          var s = P_(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, e);
          if (d != null)
            return d;
          var h = f.createAggregator(e), v = l.selectCardinalityLimit(e.type), p = new r(e, h, Ln.Noop(), [l], v);
          return n.metricStorageRegistry.registerForCollector(l, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, t;
  }()
), x_ = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, M_ = (
  /** @class */
  function() {
    function t(e) {
      this.resource = e, this.viewRegistry = new e_(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return t.prototype.getMeterSharedState = function(e) {
      var r = sp(e), n = this.meterSharedStates.get(r);
      return n == null && (n = new C_(this, e), this.meterSharedStates.set(r, n)), n;
    }, t.prototype.selectAggregations = function(e) {
      var r, n, i = [];
      try {
        for (var o = x_(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(e)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, t;
  }()
), Nt = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, Lt = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, k_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, D_ = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, o; n < i; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, U_ = (
  /** @class */
  function() {
    function t(e, r) {
      this._sharedState = e, this._metricReader = r;
    }
    return t.prototype.collect = function(e) {
      return Nt(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Lt(this, function(u) {
          switch (u.label) {
            case 0:
              return r = q(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Nt(a, void 0, void 0, function() {
                  var s;
                  return Lt(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, e)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, D_([], k_(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, t.prototype.forceFlush = function(e) {
      return Nt(this, void 0, void 0, function() {
        return Lt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(e)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.shutdown = function(e) {
      return Nt(this, void 0, void 0, function() {
        return Lt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(e)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.selectAggregationTemporality = function(e) {
      return this._metricReader.selectAggregationTemporality(e);
    }, t.prototype.selectAggregation = function(e) {
      return this._metricReader.selectAggregation(e);
    }, t.prototype.selectCardinalityLimit = function(e) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, e)) !== null && i !== void 0 ? i : 2e3;
    }, t;
  }()
), Gi = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, ji = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Vi = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function B_(t, e) {
  var r = e != null ? e : ot.empty();
  return t ? ot.default().merge(r) : r;
}
var H_ = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new M_(B_((a = e == null ? void 0 : e.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, e == null ? void 0 : e.resource)), (e == null ? void 0 : e.views) != null && e.views.length > 0)
        try {
          for (var u = Vi(e.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((e == null ? void 0 : e.readers) != null && e.readers.length > 0)
        try {
          for (var l = Vi(e.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return t.prototype.getMeter = function(e, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (m.warn("A shutdown MeterProvider cannot provide a Meter"), $s()) : this._sharedState.getMeterSharedState({
        name: e,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, t.prototype.addMetricReader = function(e) {
      var r = new U_(this._sharedState, e);
      e.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, t.prototype.shutdown = function(e) {
      return Gi(this, void 0, void 0, function() {
        return ji(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(e);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.forceFlush = function(e) {
      return Gi(this, void 0, void 0, function() {
        return ji(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(e);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
function F_(t, e) {
  var r = wa(e);
  return {
    resource: ba(t.resource),
    schemaUrl: void 0,
    scopeMetrics: G_(t.scopeMetrics, r)
  };
}
function G_(t, e) {
  return Array.from(t.map(function(r) {
    return {
      scope: Oa(r.scope),
      metrics: r.metrics.map(function(n) {
        return j_(n, e);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function j_(t, e) {
  var r = {
    name: t.descriptor.name,
    description: t.descriptor.description,
    unit: t.descriptor.unit
  }, n = X_(t.aggregationTemporality);
  switch (t.dataPointType) {
    case te.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: t.isMonotonic,
        dataPoints: $i(t, e)
      };
      break;
    case te.GAUGE:
      r.gauge = {
        dataPoints: $i(t, e)
      };
      break;
    case te.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: $_(t, e)
      };
      break;
    case te.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: z_(t, e)
      };
      break;
  }
  return r;
}
function V_(t, e, r) {
  var n = {
    attributes: Ae(t.attributes),
    startTimeUnixNano: r.encodeHrTime(t.startTime),
    timeUnixNano: r.encodeHrTime(t.endTime)
  };
  switch (e) {
    case de.INT:
      n.asInt = t.value;
      break;
    case de.DOUBLE:
      n.asDouble = t.value;
      break;
  }
  return n;
}
function $i(t, e) {
  return t.dataPoints.map(function(r) {
    return V_(r, t.descriptor.valueType, e);
  });
}
function $_(t, e) {
  return t.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ae(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: e.encodeHrTime(r.startTime),
      timeUnixNano: e.encodeHrTime(r.endTime)
    };
  });
}
function z_(t, e) {
  return t.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ae(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: e.encodeHrTime(r.startTime),
      timeUnixNano: e.encodeHrTime(r.endTime)
    };
  });
}
function X_(t) {
  switch (t) {
    case Q.DELTA:
      return 1;
    case Q.CUMULATIVE:
      return 2;
  }
}
function q_(t, e) {
  return {
    resourceMetrics: t.map(function(r) {
      return F_(r, e);
    })
  };
}
var W_ = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Y_ = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function K_(t, e) {
  var r, n = t.spanContext(), i = t.status;
  return {
    traceId: e.encodeSpanContext(n.traceId),
    spanId: e.encodeSpanContext(n.spanId),
    parentSpanId: e.encodeOptionalSpanContext(t.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: t.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: t.kind == null ? 0 : t.kind + 1,
    startTimeUnixNano: e.encodeHrTime(t.startTime),
    endTimeUnixNano: e.encodeHrTime(t.endTime),
    attributes: Ae(t.attributes),
    droppedAttributesCount: t.droppedAttributesCount,
    events: t.events.map(function(o) {
      return Q_(o, e);
    }),
    droppedEventsCount: t.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: t.links.map(function(o) {
      return J_(o, e);
    }),
    droppedLinksCount: t.droppedLinksCount
  };
}
function J_(t, e) {
  var r;
  return {
    attributes: t.attributes ? Ae(t.attributes) : [],
    spanId: e.encodeSpanContext(t.context.spanId),
    traceId: e.encodeSpanContext(t.context.traceId),
    traceState: (r = t.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: t.droppedAttributesCount || 0
  };
}
function Q_(t, e) {
  return {
    attributes: t.attributes ? Ae(t.attributes) : [],
    name: t.name,
    timeUnixNano: e.encodeHrTime(t.time),
    droppedAttributesCount: t.droppedAttributesCount || 0
  };
}
function Z_(t, e) {
  var r = wa(e);
  return {
    resourceSpans: tv(t, r)
  };
}
function ev(t) {
  var e, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = W_(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    e = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function tv(t, e) {
  for (var r = ev(t), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = Y_(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return K_(p, e);
        });
        s.push({
          scope: Oa(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var v = {
      resource: ba(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(v), o = i.next();
  }
  return n;
}
var rv = {
  serializeRequest: function(t) {
    var e = q_([t], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(e));
  },
  deserializeResponse: function(t) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(t));
  }
}, nv = {
  serializeRequest: function(t) {
    var e = Z_(t, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(e));
  },
  deserializeResponse: function(t) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(t));
  }
}, iv = function(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, ov = function(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, av = 5, sv = 1e3, uv = 5e3, cv = 1.5, zi = 0.2;
function lv() {
  return Math.random() * (2 * zi) - zi;
}
var fv = (
  /** @class */
  function() {
    function t(e) {
      this._transport = e;
    }
    return t.prototype.retry = function(e, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(e, r).then(o, a);
        }, n);
      });
    }, t.prototype.send = function(e, r) {
      var n;
      return iv(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return ov(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(e, r)];
            case 1:
              o = f.sent(), a = av, u = sv, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, uv) + lv(), 0), u = u * cv, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(e, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, t.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, t;
  }()
);
function $a(t) {
  return new fv(t.transport);
}
function dv(t) {
  var e = [429, 502, 503, 504];
  return e.includes(t);
}
function hv(t) {
  if (t != null) {
    var e = Number.parseInt(t, 10);
    if (Number.isInteger(e))
      return e > 0 ? e * 1e3 : -1;
    var r = new Date(t).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var pv = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _v = (
  /** @class */
  function() {
    function t(e) {
      this._parameters = e;
    }
    return t.prototype.send = function(e, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = pv(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (m.debug("XHR success"), i({
            status: "success"
          })) : o.status && dv(o.status) ? i({
            status: "retryable",
            retryInMillis: hv(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(e);
      });
    }, t.prototype.shutdown = function() {
    }, t;
  }()
);
function vv(t) {
  return new _v(t);
}
var gv = (
  /** @class */
  function() {
    function t(e) {
      this._params = e;
    }
    return t.prototype.send = function(e) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([e], { type: r._params.blobType })) ? (m.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, t.prototype.shutdown = function() {
    }, t;
  }()
);
function yv(t) {
  return new gv(t);
}
function mv(t, e) {
  return ma(t, e, $a({
    transport: vv(t)
  }));
}
function Ev(t, e) {
  return ma(t, e, $a({
    transport: yv({
      url: t.url,
      blobType: t.headers()["Content-Type"]
    })
  }));
}
var Tv = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Sv(t) {
  return function() {
    var e, r = {};
    return Object.entries((e = t == null ? void 0 : t()) !== null && e !== void 0 ? e : {}).forEach(function(n) {
      var i = Tv(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : m.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var be = function() {
  return be = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, be.apply(this, arguments);
};
function wv(t, e, r) {
  var n = be({}, r()), i = {};
  return function() {
    return e != null && Object.assign(i, e()), t != null && Object.assign(i, t()), Object.assign(i, n);
  };
}
function bv(t) {
  if (t != null)
    try {
      return new URL(t), t;
    } catch (e) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + t + "'");
    }
}
function Ov(t, e, r) {
  var n, i, o, a;
  return be(be({}, Hh(t, e, r)), { headers: wv(Sv(t.headers), e.headers, r.headers), url: (i = (n = bv(t.url)) !== null && n !== void 0 ? n : e.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = t.agentOptions) !== null && o !== void 0 ? o : e.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function Av(t, e) {
  return be(be({}, Fh()), { headers: function() {
    return t;
  }, url: "http://localhost:4318/" + e, agentOptions: { keepAlive: !0 } });
}
function Rv(t, e, r) {
  return Ov(
    {
      url: t.url,
      timeoutMillis: t.timeoutMillis,
      headers: Bh(t.headers),
      concurrencyLimit: t.concurrencyLimit
    },
    {},
    // no fallback for browser case
    Av(r, e)
  );
}
function za(t, e, r, n) {
  var i = !!t.headers || typeof navigator.sendBeacon != "function", o = Rv(t, r, n);
  return i ? mv(o, e) : Ev(o, e);
}
var Nv = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Xi = (
  /** @class */
  function(t) {
    Nv(e, t);
    function e(r) {
      return r === void 0 && (r = {}), t.call(this, za(r, nv, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return e;
  }(ya)
), $t;
(function(t) {
  t[t.DELTA = 0] = "DELTA", t[t.CUMULATIVE = 1] = "CUMULATIVE", t[t.LOWMEMORY = 2] = "LOWMEMORY";
})($t || ($t = {}));
var Lv = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), un = function() {
  return Q.CUMULATIVE;
}, Xa = function(t) {
  switch (t) {
    case w.COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.GAUGE:
    case w.HISTOGRAM:
    case w.OBSERVABLE_GAUGE:
      return Q.DELTA;
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
      return Q.CUMULATIVE;
  }
}, qa = function(t) {
  switch (t) {
    case w.COUNTER:
    case w.HISTOGRAM:
      return Q.DELTA;
    case w.GAUGE:
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.OBSERVABLE_GAUGE:
      return Q.CUMULATIVE;
  }
};
function Iv() {
  var t = xe(), e = t.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return e === "cumulative" ? un : e === "delta" ? Xa : e === "lowmemory" ? qa : (m.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + t.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), un);
}
function Pv(t) {
  return t != null ? t === $t.DELTA ? Xa : t === $t.LOWMEMORY ? qa : un : Iv();
}
function Cv(t) {
  return t != null && t.aggregationPreference ? t.aggregationPreference : function(e) {
    return ue.Default();
  };
}
var xv = (
  /** @class */
  function(t) {
    Lv(e, t);
    function e(r, n) {
      var i = t.call(this, r) || this;
      return i._aggregationSelector = Cv(n), i._aggregationTemporalitySelector = Pv(n == null ? void 0 : n.temporalityPreference), i;
    }
    return e.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, e.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, e;
  }(ya)
), Mv = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qi = (
  /** @class */
  function(t) {
    Mv(e, t);
    function e(r) {
      return t.call(this, za(r != null ? r : {}, rv, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return e;
  }(xv)
);
class tt extends Error {
  constructor(e, r) {
    const n = `${tt.extractMessage(e)}: ${JSON.stringify({
      response: e,
      request: r
    })}`;
    super(n), Object.setPrototypeOf(this, tt.prototype), this.response = e, this.request = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, tt);
  }
  static extractMessage(e) {
    var r, n, i;
    return (i = (n = (r = e.errors) == null ? void 0 : r[0]) == null ? void 0 : n.message) != null ? i : `GraphQL Error (Code: ${e.status})`;
  }
}
var Wa = /* @__PURE__ */ ((t) => (t.BillingQuotaExceeded = "BillingQuotaExceeded", t))(Wa || {});
const In = 10, kv = 1e3, Dv = 500, Uv = [Wa.BillingQuotaExceeded.toString()], Bv = (t) => {
  var r;
  return ((r = t.response.errors) == null ? void 0 : r.find(
    (n) => Uv.includes(n.message)
  )) === void 0;
}, Ig = (t) => {
  const e = (r, n, i, o, a = 0) => z(void 0, null, function* () {
    try {
      return yield r();
    } catch (u) {
      if (u instanceof tt && !Bv(u))
        throw u;
      if (a < In)
        return yield new Promise(
          (c) => setTimeout(
            c,
            kv + Dv * Math.pow(2, a)
          )
        ), yield e(
          r,
          n,
          i,
          o,
          a + 1
        );
      throw console.error(
        `highlight.io: [${t || t}] data request failed after ${a} retries`
      ), u;
    }
  });
  return e;
};
class Hv extends Xi {
  constructor(r) {
    super(r);
    S(this, "xhrTraceExporter");
    this.xhrTraceExporter = new Xi(U(I({}, r != null ? r : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(r, n) {
    let i = 0;
    const o = (a) => {
      var u;
      i++, i > In ? (console.error(
        `[highlight.io] failed to export OTeL traces: ${(u = a.error) == null ? void 0 : u.message}`,
        a.error
      ), n({
        code: $.FAILED,
        error: a.error
      })) : this.xhrTraceExporter.export(r, n);
    };
    super.export(r, o);
  }
}
class Fv extends qi {
  constructor(r) {
    super(r);
    S(this, "xhrMeterExporter");
    this.xhrMeterExporter = new qi(U(I({}, r != null ? r : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(r, n) {
    let i = 0;
    const o = (a) => {
      var u;
      i++, i > In ? (console.error(
        `[highlight.io] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`,
        a.error
      ), n({
        code: $.FAILED,
        error: a.error
      })) : this.xhrMeterExporter.export(r, n);
    };
    super.export(r, o);
  }
}
const Gv = "OT_ZONE_CONTEXT", jv = "Navigation:";
function Vv() {
  return !1;
}
const Z = class Z extends Ho {
  constructor(r = {}) {
    super(
      Z.moduleName,
      Z.version,
      r
    );
    S(this, "_spansData", /* @__PURE__ */ new WeakMap());
    S(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    S(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    S(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    S(this, "_shouldPreventSpanCreation");
    this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : Vv;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Te() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return !0;
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Xo(i, !0);
    try {
      const c = this.tracer.startSpan(
        o,
        {
          attributes: {
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? R.setSpan(A.active(), n) : void 0
      );
      return r instanceof MouseEvent && (c.setAttribute("event.x", r.clientX), c.setAttribute("event.y", r.clientY), c.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), c.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (c.setAttribute("event.scrollX", window.scrollX), c.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, c) === !0 ? void 0 : (this._spansData.set(c, {
        taskCount: 0
      }), c);
    } catch (c) {
      this._diag.error(
        "failed to start create new user interaction span",
        c
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(Gv);
    return n && R.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var p;
        let d;
        const h = f[0];
        if (!(h != null && h.type))
          return r._invokeListener(u, this, f);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return r._invokeListener(u, this, f);
        n.set(h.type, Date.now()), h && (d = r._eventsSpanMap.get(h)), s && r.removePatchedListener(this, a, u);
        const v = r._createSpan(h, d);
        return v ? (h && r._eventsSpanMap.set(h, v), A.with(
          R.setSpan(A.active(), v),
          () => {
            const y = r._invokeListener(
              u,
              this,
              f
            );
            return v.end(), y;
          }
        )) : r._invokeListener(u, this, f);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    H(history.replaceState) && this._unwrap(history, "replaceState"), H(history.pushState) && this._unwrap(history, "pushState"), H(history.back) && this._unwrap(history, "back"), H(history.forward) && this._unwrap(history, "forward"), H(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = R.getSpan(
      A.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${jv} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = r._createSpan(c), l)
          return r._incrementTask(l), f.run(() => {
            try {
              return A.with(
                R.setSpan(
                  A.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(l);
            }
          });
      } else
        l = r._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && r._shouldCountTask(o, f) && r._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      Z.moduleName,
      Z.version,
      "zone:",
      !!r
    ), r ? (H(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), H(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), H(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      H(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), H(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      Z.moduleName,
      Z.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (H(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), H(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), H(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      H(i.addEventListener) && this._unwrap(i, "addEventListener"), H(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
S(Z, "version", "0.1.0"), S(Z, "moduleName", "user-interaction");
let cn = Z, V = {};
const zt = "highlight.record", Pg = (t) => {
  var v, p, y, g, b, L, C, B, G;
  if (V.tracerProvider !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  const e = t.backendUrl || "https://pub.highlight.io", r = [
    ...(p = (v = t.networkRecordingOptions) == null ? void 0 : v.urlBlocklist) != null ? p : [],
    ...pa
  ], n = (y = t.environment) != null ? y : "production", i = {
    url: t.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 100,
    timeoutMillis: 5e3,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 5e3,
      keepAlive: !0
    }
  }, o = new Hv(i), a = new $v(o, {
    maxExportBatchSize: 100,
    maxQueueSize: 1e3,
    exportTimeoutMillis: i.timeoutMillis,
    scheduledDelayMillis: i.timeoutMillis
  }), u = new ot({
    [sf]: (g = t.serviceName) != null ? g : "highlight-browser",
    [af]: n,
    "highlight.project_id": t.projectId,
    "highlight.session_id": t.sessionSecureId
  });
  V.tracerProvider = new jl({
    resource: u,
    spanProcessors: [a]
  }), R.setGlobalTracerProvider(V.tracerProvider);
  const c = new Fv(U(I({}, i), {
    url: t.otlpEndpoint + "/v1/metrics"
  })), s = new Zp({
    exporter: c,
    exportIntervalMillis: i.timeoutMillis,
    exportTimeoutMillis: i.timeoutMillis
  });
  V.meterProvider = new H_({ resource: u, readers: [s] }), ft.setGlobalMeterProvider(V.meterProvider);
  let l = [];
  ((b = t.instrumentations) == null ? void 0 : b["@opentelemetry/instrumentation-document-load"]) !== !1 && l.push(
    new pf({
      applyCustomAttributesOnSpan: {
        documentLoad: Ki,
        documentFetch: Ki,
        resourceFetch: Kv
      }
    })
  ), ((L = t.instrumentations) == null ? void 0 : L["@opentelemetry/instrumentation-user-interaction"]) !== !1 && l.push(new cn()), (C = t.networkRecordingOptions) != null && C.enabled && (((B = t.instrumentations) == null ? void 0 : B["@opentelemetry/instrumentation-fetch"]) !== !1 && l.push(
    new ed({
      propagateTraceHeaderCorsUrls: Ji(
        t.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (M, ne, K) => z(void 0, null, function* () {
        var He, Cn, xn;
        if (!M.attributes)
          return;
        const tr = M;
        if (tr.attributes[zt] === !1)
          return;
        const rr = tr.attributes["http.url"], nr = (He = ne.method) != null ? He : "GET";
        if (M.updateName(Wi(rr, nr, ne.body)), !(K instanceof Response)) {
          M.setAttributes({
            "http.response.error": K.message,
            "http.response.status": K.status
          });
          return;
        }
        Yi(
          M,
          ne.body,
          ne.headers,
          t.networkRecordingOptions
        );
        const _t = yield ga(
          K,
          (Cn = t.networkRecordingOptions) == null ? void 0 : Cn.bodyKeysToRecord,
          (xn = t.networkRecordingOptions) == null ? void 0 : xn.networkBodyKeysToRedact
        );
        M.setAttribute("http.response.body", _t);
      })
    })
  ), ((G = t.instrumentations) == null ? void 0 : G["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && l.push(
    new Md({
      propagateTraceHeaderCorsUrls: Ji(
        t.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (M, ne) => {
        var _t, He;
        const K = ne;
        if (!M.attributes || M.attributes[zt] === !1)
          return;
        const rr = Wi(
          K._url,
          K._method,
          ne.responseText
        );
        M.updateName(rr), Yi(
          M,
          K._body,
          K._requestHeaders,
          t.networkRecordingOptions
        );
        const nr = fe(
          K._body,
          (_t = t.networkRecordingOptions) == null ? void 0 : _t.networkBodyKeysToRedact,
          (He = t.networkRecordingOptions) == null ? void 0 : He.bodyKeysToRecord,
          K._requestHeaders
        );
        M.setAttribute("http.request.body", nr);
      }
    })
  )), il({ instrumentations: l });
  const h = new Vo();
  h.enable(), V.tracerProvider.register({
    contextManager: h,
    propagator: new bo({
      propagators: [
        new go(),
        new zv({
          backendUrl: e,
          otlpEndpoint: t.otlpEndpoint,
          tracingOrigins: t.tracingOrigins,
          urlBlocklist: r
        })
      ]
    })
  });
};
class $v extends jo {
  onEnd(e) {
    e.attributes[zt] !== !1 && super.onEnd(e);
  }
}
class zv extends Oo {
  constructor(r) {
    super();
    S(this, "highlightEndpoints");
    S(this, "tracingOrigins");
    S(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = R.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = o.attributes["http.url"];
    typeof a == "string" && (Yv(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(zt, !1), !Rn(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const Ya = "highlight-browser", Xv = Ya, Cg = () => {
  var t;
  return (t = V.tracerProvider) == null ? void 0 : t.getTracer(Ya);
}, xg = () => {
  var t;
  return (t = V.meterProvider) == null ? void 0 : t.getMeter(Xv);
}, qv = () => R.getActiveSpan(), Wv = () => z(void 0, null, function* () {
  V.tracerProvider ? (yield V.tracerProvider.forceFlush(), yield V.tracerProvider.shutdown()) : console.warn("OTEL shutdown called without initialized tracerProvider."), V.meterProvider ? (yield V.meterProvider.forceFlush(), yield V.meterProvider.shutdown()) : console.warn("OTEL shutdown called without initialized meterProvider.");
}), Wi = (t, e, r) => {
  var u, c, s;
  let n;
  const i = new URL(t), o = i.pathname;
  let a = `${e.toUpperCase()} - ${o}`;
  try {
    if (n = typeof r == "string" ? JSON.parse(r) : r, n && n.query) {
      const l = fh(n.query), f = ((u = l.definitions[0]) == null ? void 0 : u.kind) === "OperationDefinition" ? (s = (c = l.definitions[0]) == null ? void 0 : c.name) == null ? void 0 : s.value : void 0;
      f && (a = `${f} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (l) {
  }
  return a;
}, Yi = (t, e, r, n) => {
  var l;
  const i = typeof e == "string" ? e : String(e);
  if (!t.attributes)
    return;
  const a = t.attributes["http.url"], u = new URL(a);
  let c;
  try {
    c = e ? JSON.parse(i) : void 0, c.operationName && t.setAttribute(
      "graphql.operation.name",
      c.operationName
    );
  } catch (f) {
  }
  const s = ha(
    (l = n == null ? void 0 : n.networkHeadersToRedact) != null ? l : [],
    r,
    n == null ? void 0 : n.headerKeysToRecord
  );
  t.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(s),
    "http.request.body": i,
    [uf]: a,
    [cf]: u.pathname,
    [lf]: u.search
  }), u.searchParams.size > 0 && t.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(
      Object.fromEntries(u.searchParams)
    )
  });
}, Yv = (t, e, r, n) => n != null && n.some(
  (o) => t.toLowerCase().includes(o)
) ? !1 : Qt(
  t,
  e
), Ki = (t) => {
  if (!t.events)
    return;
  const r = t.events, n = {
    unload: J("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: J(
      "domInteractive",
      "fetchStart",
      r
    ),
    dom_content_loaded: J(
      "domContentLoadedEventEnd",
      "domContentLoadedEventStart",
      r
    ),
    dom_complete: J("fetchStart", "domComplete", r),
    load_event: J("loadEventStart", "loadEventEnd", r),
    first_paint: J("fetchStart", "firstPaint", r),
    first_contentful_paint: J(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: J(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: J("connectStart", "connectEnd", r),
    request: J("requestStart", "requestEnd", r),
    response: J("responseStart", "responseEnd", r)
  };
  Object.entries(n).forEach(([i, o]) => {
    o > 0 && (t.setAttribute(`timings.${i}.ns`, o), t.setAttribute(
      `timings.${i}.readable`,
      Ka(o)
    ));
  });
};
function J(t, e, r) {
  const n = r.find((u) => u.name === t), i = r.find((u) => u.name === e);
  if (!n || !i)
    return 0;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const Kv = (t, e) => {
  const r = {
    domain_lookup: (e.domainLookupEnd - e.domainLookupStart) * 1e6,
    connect: (e.connectEnd - e.connectStart) * 1e6,
    request: (e.responseEnd - e.requestStart) * 1e6,
    response: (e.responseEnd - e.responseStart) * 1e6
  };
  Object.entries(r).forEach(([n, i]) => {
    i > 0 && (t.setAttribute(`timings.${n}.ns`, i), t.setAttribute(
      `timings.${n}.readable`,
      Ka(i)
    ));
  });
}, Ka = (t) => {
  if (t >= 36e11) {
    const a = t / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (t >= 6e10) {
    const a = t / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (t >= 1e9) {
    const a = t / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (t >= 1e6) {
    const a = t / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (t >= 1e3) {
    const a = t / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(t.toFixed(1))}ns`;
}, Ji = (t) => t === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(t) ? t.map(
  (e) => typeof e == "string" ? new RegExp(e) : e
) : /^$/, Jv = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var Qv = /* @__PURE__ */ ((t) => (t.DeviceMemory = "DeviceMemory", t.ViewportHeight = "ViewportHeight", t.ViewportWidth = "ViewportWidth", t.ScreenHeight = "ScreenHeight", t.ScreenWidth = "ScreenWidth", t.ViewportArea = "ViewportArea", t))(Qv || {}), Ja = /* @__PURE__ */ ((t) => (t.Device = "Device", t.WebVital = "WebVital", t.Performance = "Performance", t.Frontend = "Frontend", t.Backend = "Backend", t))(Ja || {});
const Zv = (t, e, r) => {
  const n = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = t;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const f = o, { message: a, size: u } = f, c = or(f, ["message", "size"]), l = r.some(
      (d) => o.name.toLowerCase().includes(d)
    ) ? c : o;
    e(l);
  }, () => {
    window._highlightWebSocketRequestCallback = n, window._highlightWebSocketEventCallback = i;
  };
}, eg = ({
  xhrCallback: t,
  fetchCallback: e,
  webSocketRequestCallback: r,
  webSocketEventCallback: n,
  disableWebSocketRecording: i,
  bodyKeysToRedact: o,
  highlightEndpoints: a,
  tracingOrigins: u,
  urlBlocklist: c,
  bodyKeysToRecord: s
}) => {
  const l = Ph(
    t,
    a,
    u,
    c,
    o,
    s
  ), f = xh(
    e,
    a,
    u,
    c,
    o,
    s
  ), d = i ? () => {
  } : Zv(
    r,
    n,
    c
  );
  return () => {
    l(), f(), d();
  };
};
class Pn {
  constructor(e) {
    S(this, "disableConsoleRecording");
    S(this, "reportConsoleErrors");
    S(this, "enablePromisePatch");
    S(this, "consoleMethodsToRecord");
    S(this, "listeners");
    S(this, "errors");
    S(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    S(this, "options");
    S(this, "hasNetworkRecording", !0);
    S(this, "disableNetworkRecording");
    S(this, "enableRecordingNetworkContents");
    S(this, "xhrNetworkContents");
    S(this, "fetchNetworkContents");
    S(this, "disableRecordingWebSocketContents");
    S(this, "webSocketNetworkContents");
    S(this, "webSocketEventContents");
    S(this, "tracingOrigins");
    S(this, "networkHeadersToRedact");
    S(this, "networkBodyKeysToRedact");
    S(this, "networkBodyKeysToRecord");
    S(this, "networkHeaderKeysToRecord");
    S(this, "lastNetworkRequestTimestamp");
    S(this, "urlBlocklist");
    S(this, "highlightEndpoints");
    S(this, "requestResponseSanitizer");
    var r, n;
    this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (r = e.reportConsoleErrors) != null ? r : !1, this.enablePromisePatch = (n = e.enablePromisePatch) != null ? n : !1, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [
      ...Jv
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening()) return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(
      as(
        (r) => {
          var n, i, o;
          if (this.reportConsoleErrors && (r.type === "Error" || r.type === "error") && r.value && r.trace) {
            const a = Dt(r.value);
            if (Bn.includes(a) || Hn.some(
              (u) => a.includes(u)
            ))
              return;
            e.errors.push({
              event: a,
              type: "console.error",
              url: window.location.href,
              source: (n = r.trace[0]) != null && n.fileName ? r.trace[0].fileName : "",
              lineNumber: (i = r.trace[0]) != null && i.lineNumber ? r.trace[0].lineNumber : 0,
              columnNumber: (o = r.trace[0]) != null && o.columnNumber ? r.trace[0].columnNumber : 0,
              stackTrace: r.trace,
              timestamp: (/* @__PURE__ */ new Date()).toISOString()
            });
          }
          e.messages.push(r);
        },
        {
          level: this.consoleMethodsToRecord,
          logger: "console",
          stringifyOptions: {
            depthOfLimit: 10,
            numOfKeysLimit: 100,
            stringLengthLimit: 1e3
          }
        }
      )
    ), this.listeners.push(
      us(
        (r) => {
          Bn.includes(r.event) || Hn.some(
            (n) => r.event.includes(n)
          ) || e.errors.push(r);
        },
        { enablePromisePatch: this.enablePromisePatch }
      )
    ), this.listeners.push(Wv), Pn.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(e, r) {
    var o, a, u, c, s, l, f, d, h, v, p, y;
    const n = (r == null ? void 0 : r.backendUrl) || "https://pub.highlight.io", i = r.otlpEndpoint || "https://otel.highlight.io";
    e.highlightEndpoints = [
      n,
      `${i}/v1/traces`,
      `${i}/v1/logs`,
      `${i}/v1/metrics`
    ], e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = r.tracingOrigins || [], (r == null ? void 0 : r.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = r == null ? void 0 : r.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = []) : typeof (r == null ? void 0 : r.networkRecording) == "boolean" ? (e.disableNetworkRecording = !r.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((o = r.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? e.disableNetworkRecording = !r.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((a = r.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((u = r.networkRecording) == null ? void 0 : u.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((s = (c = r.networkRecording) == null ? void 0 : c.networkHeadersToRedact) == null ? void 0 : s.map(
      (g) => g.toLowerCase()
    )) || [], e.networkBodyKeysToRedact = ((f = (l = r.networkRecording) == null ? void 0 : l.networkBodyKeysToRedact) == null ? void 0 : f.map(
      (g) => g.toLowerCase()
    )) || [], e.urlBlocklist = ((h = (d = r.networkRecording) == null ? void 0 : d.urlBlocklist) == null ? void 0 : h.map(
      (g) => g.toLowerCase()
    )) || [], e.urlBlocklist = [
      ...e.urlBlocklist,
      ...pa
    ], e.requestResponseSanitizer = (v = r.networkRecording) == null ? void 0 : v.requestResponseSanitizer, e.networkHeaderKeysToRecord = (p = r.networkRecording) == null ? void 0 : p.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map(
      (g) => g.toLocaleLowerCase()
    )), e.networkBodyKeysToRecord = (y = r.networkRecording) == null ? void 0 : y.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map(
      (g) => g.toLocaleLowerCase()
    ))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(
      eg({
        xhrCallback: (g) => {
          e.xhrNetworkContents.push(g);
        },
        fetchCallback: (g) => {
          e.fetchNetworkContents.push(g);
        },
        webSocketRequestCallback: (g) => {
          e.webSocketNetworkContents && e.webSocketNetworkContents.push(g);
        },
        webSocketEventCallback: (g) => {
          e.webSocketEventContents.push(g);
        },
        disableWebSocketRecording: e.disableRecordingWebSocketContents,
        bodyKeysToRedact: e.networkBodyKeysToRedact,
        highlightEndpoints: e.highlightEndpoints,
        tracingOrigins: e.tracingOrigins,
        urlBlocklist: e.urlBlocklist,
        bodyKeysToRecord: e.networkBodyKeysToRecord
      })
    );
  }
  static getRecordedNetworkResources(e, r) {
    var o, a;
    let n = [], i = [];
    if (!e.disableNetworkRecording) {
      const u = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      n = performance.getEntriesByType(
        "resource"
      );
      const c = (r - u) * 2;
      if (n = n.filter((s) => s.responseEnd < e.lastNetworkRequestTimestamp ? !1 : Qt(
        s.name,
        e.highlightEndpoints
      )).map((s) => U(I({}, s.toJSON()), {
        offsetStartTime: s.startTime - c,
        offsetResponseEnd: s.responseEnd - c,
        offsetFetchStart: s.fetchStart - c
      })), e.lastNetworkRequestTimestamp = ((a = n.at(-1)) == null ? void 0 : a.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
        const s = {
          headersToRedact: e.networkHeadersToRedact,
          headersToRecord: e.networkHeaderKeysToRecord,
          requestResponseSanitizer: e.requestResponseSanitizer
        };
        n = Ti(
          n,
          e.xhrNetworkContents,
          "xmlhttprequest",
          s
        ), n = Ti(
          n,
          e.fetchNetworkContents,
          "fetch",
          s
        );
      }
    }
    return e.disableRecordingWebSocketContents || (i = e.webSocketNetworkContents || []), [...n, ...i];
  }
  static getRecordedWebSocketEvents(e) {
    let r = [];
    return !e.disableNetworkRecording && !e.disableRecordingWebSocketContents && (r = e.webSocketEventContents), r;
  }
  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const tg = () => {
  var o;
  const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var r = "";
  const n = typeof window != "undefined" && ((o = window.crypto) == null ? void 0 : o.getRandomValues), i = new Uint32Array(28);
  n && window.crypto.getRandomValues(i);
  for (let a = 0; a < 28; a++)
    n ? r += e.charAt(
      i[a] % e.length
    ) : r += e.charAt(
      Math.floor(Math.random() * e.length)
    );
  return r;
}, rg = ({
  apiKey: t
}) => {
  (function(e, r) {
    var n = e.amplitude || { _q: [], _iq: {} }, i = r.createElement("script");
    i.type = "text/javascript", i.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", i.crossOrigin = "anonymous", i.async = !0, i.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", i.onload = function() {
      e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(t);
    };
    var o = r.getElementsByTagName("script")[0];
    o.parentNode.insertBefore(i, o);
    function a(p, y) {
      p.prototype[y] = function() {
        return this._q.push(
          [y].concat(Array.prototype.slice.call(arguments, 0))
        ), this;
      };
    }
    for (var u = function() {
      return this._q = [], this;
    }, c = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], s = 0; s < c.length; s++)
      a(u, c[s]);
    n.Identify = u;
    for (var l = function() {
      return this._q = [], this;
    }, f = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], d = 0; d < f.length; d++)
      a(l, f[d]);
    n.Revenue = l;
    var h = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function v(p) {
      function y(b) {
        p[b] = function() {
          p._q.push(
            [b].concat(Array.prototype.slice.call(arguments, 0))
          );
        };
      }
      for (var g = 0; g < h.length; g++)
        y(h[g]);
    }
    v(n), n.getInstance = function(p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(n._iq, p) || (n._iq[p] = { _q: [] }, v(n._iq[p])), n._iq[p];
    }, e.amplitude = n;
  })(window, document);
}, ng = ({
  projectToken: t
}) => {
  if (window.mixpanel)
    return;
  (function(r, n) {
    if (!n.__SV) {
      var i, o;
      window.mixpanel = n, n._i = [], n.init = function(a, u, c) {
        function s(d, h) {
          var v = h.split(".");
          v.length == 2 && (d = d[v[0]], h = v[1]), d[h] = function() {
            d.push(
              [h].concat(
                Array.prototype.slice.call(arguments, 0)
              )
            );
          };
        }
        var l = n;
        for (typeof c != "undefined" ? l = n[c] = [] : c = "mixpanel", l.people = l.people || [], l.toString = function(d) {
          var h = "mixpanel";
          return c !== "mixpanel" && (h += "." + c), d || (h += " (stub)"), h;
        }, l.people.toString = function() {
          return l.toString(1) + ".people (stub)";
        }, i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(
          " "
        ), o = 0; o < i.length; o++) s(l, i[o]);
        var f = "set set_once union unset remove delete".split(" ");
        l.get_group = function() {
          function d(y) {
            h[y] = function() {
              call2_args = arguments, call2 = [y].concat(
                Array.prototype.slice.call(call2_args, 0)
              ), l.push([v, call2]);
            };
          }
          for (var h = {}, v = ["get_group"].concat(
            Array.prototype.slice.call(arguments, 0)
          ), p = 0; p < f.length; p++)
            d(f[p]);
          return h;
        }, n._i.push([a, u, c]);
      }, n.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const e = document.createElement("script");
  e.src = ig, document.head.appendChild(e), e.addEventListener("load", () => {
    var r;
    (r = window.mixpanel) == null || r.init(t);
  });
}, ig = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", og = "9.16.0", ag = () => {
  var t, e;
  typeof chrome != "undefined" && ((t = chrome == null ? void 0 : chrome.runtime) != null && t.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener(
    (r, n, i) => {
      const o = r.action;
      switch (console.log(
        `[highlight] received '${o}' event from extension.`
      ), o) {
        case "init": {
          N.init(1, {
            debug: !0
          }), N.getSessionURL().then((a) => {
            i({ url: a });
          });
          break;
        }
        case "stop": {
          N.stop(), i({ success: !0 });
          break;
        }
      }
      return !0;
    }
  ));
};
function Mg(t) {
  var e;
  t.on && ((e = t.webContents) != null && e.send) && (t.on("focus", () => {
    t.webContents.send("highlight.run", { visible: !0 });
  }), t.on("blur", () => {
    t.webContents.send("highlight.run", { visible: !1 });
  }), t.on("close", () => {
    t.webContents.send("highlight.run", { visible: !1 });
  }));
}
const kg = ({
  next: t,
  payload: e
}) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const r = e.obj.event, n = e.obj.properties;
      window.H.track(r, n);
    } else if (e.obj.type === "identify") {
      const r = e.obj.userId;
      if (r != null && r.length) {
        const n = e.obj.traits;
        window.H.identify(r, n);
      }
    }
  }
  t(e);
}, ln = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (t, e) => window._originalFetch(t, e), window._highlightFetchPatch = (t, e) => window._fetchProxy.call(window || global, t, e), window.fetch = window._highlightFetchPatch;
  }
}, Qi = () => null, fn = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = Qi, window._highlightWebSocketEventCallback = Qi;
    const t = new Proxy(window.WebSocket, {
      construct(e, r) {
        const [, n] = Nn(), i = new e(...r), o = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + l.timeStamp
          });
        }, a = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + l.timeStamp
          }), i.removeEventListener("open", o), i.removeEventListener("error", c), i.removeEventListener("message", u), i.removeEventListener("close", a);
        }, u = (l) => {
          const { data: f } = l, d = typeof f == "string" ? l.data : void 0;
          let h;
          typeof f == "string" ? h = f.length : f instanceof Blob ? h = f.size : h = f.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: n,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: h,
            message: d
          });
        }, c = (l) => {
          window._highlightWebSocketEventCallback({
            socketId: n,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", o), i.addEventListener("error", c), i.addEventListener("message", u), i.addEventListener("close", a);
        const s = new Proxy(i.send, {
          apply: function(l, f, d) {
            const h = d[0], v = typeof h == "string" ? h : void 0;
            let p;
            typeof h == "string" ? p = h.length : h instanceof Blob ? p = h.size : p = h.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: n,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: p,
              message: v
            }), l.apply(f, d);
          }
        });
        return i.send = s, i;
      }
    });
    window.WebSocket = t;
  }
}, Zi = () => {
  const t = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (e, r) => t,
    setAttributes: (e) => t,
    addEvent: (e, r, n) => t,
    addLinks: (e) => t,
    setStatus: (e) => t,
    recordException: () => {
    },
    addLink: () => t,
    updateName: () => t,
    isRecording: () => !1
  };
  return t;
}, De = "feature_flag", sg = `${De}.key`, ug = `${De}.provider.name`, cg = `${De}.context.key`, lg = `${De}.result.variant`, dn = "evaluation", fg = "$ld:telemetry:initialize", dg = "$ld:telemetry:error", eo = "$ld:telemetry:track", hg = "$ld:telemetry:metric";
function pg(t) {
  return t.includes("%") || t.includes(":") ? t.replace(/%/g, "%25").replace(/:/g, "%3A") : t;
}
function _g(t) {
  return t.kind === "multi";
}
function to(t) {
  return _g(t) ? Object.keys(t).sort().filter((e) => e !== "kind").map((e) => `${e}:${pg(t[e].key)}`).join(":") : t.key;
}
function vg(t, e) {
  e.addHook({
    getMetadata: () => ({
      name: "HighlightHook"
    }),
    afterIdentify: (r, n, i) => (t.identify(
      to(r.context),
      r.context,
      "LaunchDarkly"
    ), n),
    afterEvaluation: (r, n, i) => {
      const o = {
        [sg]: r.flagKey,
        [ug]: "LaunchDarkly",
        [lg]: JSON.stringify(i.value)
      };
      r.context && (o[cg] = to(r.context));
      let a = R.getActiveSpan();
      return a ? a.addEvent(De, o) : t.startSpan(dn, (u) => {
        u && u.addEvent(De, o);
      }), t.track(dn, o), n;
    }
  });
}
class Dg {
  constructor(e) {
    S(this, "client");
    this.client = e;
  }
  init(e) {
    this.client.track(fg, {
      sessionSecureID: e
    });
  }
  recordMetric(e, r) {
    r.category === Ja.WebVital && r.name !== "Jank" && this.client.track(
      `${hg}:${r.name.toLowerCase()}`,
      U(I({}, r), {
        sessionSecureID: e
      }),
      r.value
    );
  }
  identify(e, r, n = {}, i) {
  }
  error(e, r) {
    this.client.track(dg, U(I({}, r), {
      sessionSecureID: e
    }));
  }
  track(e, r) {
    const n = r.event;
    n !== dn && this.client.track(
      n ? `${eo}:${n}` : eo,
      U(I({}, r), {
        sessionSecureID: e
      })
    );
  }
}
const j = (t, e) => {
  console.warn(`highlight.run warning: (${t}): `, e);
}, gg = 200;
let Ye = [], kt, O, Ke, hn = !1, qe;
const N = {
  options: void 0,
  init: (t, e) => {
    var r, n, i, o, a, u, c, s;
    try {
      if (N.options = e, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!t) {
        console.info(
          "Highlight is not initializing because projectID was passed undefined."
        );
        return;
      }
      e != null && e.sessionCookie ? Ah() : yh(!1);
      let l = Rr(), f = tg();
      if (l != null && l.sessionSecureID && (f = l.sessionSecureID), hn)
        return { sessionSecureID: f };
      hn = !0, ln(), fn(), import("./index-B1BKjo9D.js").then(
        (y) => z(void 0, [y], function* ({
          Highlight: h,
          setupBrowserTracing: v,
          getTracer: p
        }) {
          var g, b, L, C, B;
          v({
            backendUrl: (g = e == null ? void 0 : e.backendUrl) != null ? g : "https://pub.highlight.io",
            otlpEndpoint: (b = e == null ? void 0 : e.otlpEndpoint) != null ? b : "https://otel.highlight.io",
            projectId: t,
            sessionSecureId: f,
            environment: (L = e == null ? void 0 : e.environment) != null ? L : "production",
            networkRecordingOptions: typeof (e == null ? void 0 : e.networkRecording) == "object" ? e.networkRecording : void 0,
            tracingOrigins: e == null ? void 0 : e.tracingOrigins,
            serviceName: (C = e == null ? void 0 : e.serviceName) != null ? C : "highlight-browser",
            instrumentations: (B = e == null ? void 0 : e.otel) == null ? void 0 : B.instrumentations
          }), qe = p, O = new h(
            d,
            Ke
          ), ln(), fn(), e != null && e.manualStart || (yield O.initialize());
        })
      );
      const d = U(I({}, e), {
        organizationID: t,
        firstloadVersion: og,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        sessionSecureID: f
      });
      return Ke = new Pn(d), e != null && e.manualStart || Ke.startListening(), !((n = (r = e == null ? void 0 : e.integrations) == null ? void 0 : r.mixpanel) != null && n.disabled) && ((o = (i = e == null ? void 0 : e.integrations) == null ? void 0 : i.mixpanel) != null && o.projectToken) && ng(e.integrations.mixpanel), !((u = (a = e == null ? void 0 : e.integrations) == null ? void 0 : a.amplitude) != null && u.disabled) && ((s = (c = e == null ? void 0 : e.integrations) == null ? void 0 : c.amplitude) != null && s.apiKey) && rg(e.integrations.amplitude), { sessionSecureID: f };
    } catch (l) {
      j("init", l);
    }
  },
  snapshot: (t) => z(void 0, null, function* () {
    try {
      if (O && O.ready)
        return yield O.snapshot(t);
    } catch (e) {
      j("snapshot", e);
    }
  }),
  addSessionFeedback: ({
    verbatim: t,
    userName: e,
    userEmail: r,
    timestampOverride: n
  }) => {
    try {
      N.onHighlightReady(
        () => O.addSessionFeedback({
          verbatim: t,
          timestamp: n || (/* @__PURE__ */ new Date()).toISOString(),
          user_email: r,
          user_name: e
        })
      );
    } catch (i) {
      j("error", i);
    }
  },
  consumeError: (t, e, r) => {
    try {
      N.onHighlightReady(
        () => O.consumeCustomError(
          t,
          e,
          JSON.stringify(r)
        )
      );
    } catch (n) {
      j("error", n);
    }
  },
  consume: (t, e) => {
    try {
      N.onHighlightReady(() => O.consumeError(t, e));
    } catch (r) {
      j("error", r);
    }
  },
  error: (t, e) => {
    try {
      N.onHighlightReady(
        () => O.pushCustomError(t, JSON.stringify(e))
      );
    } catch (r) {
      j("error", r);
    }
  },
  track: (t, e = {}) => {
    var r, n, i, o, a, u, c, s, l, f, d;
    try {
      N.onHighlightReady(
        () => O.addProperties(U(I({}, e), { event: t }))
      );
      const h = O == null ? void 0 : O.getCurrentSessionURL();
      (i = (n = (r = N.options) == null ? void 0 : r.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(t, U(I({}, e), {
        highlightSessionURL: h
      })), (c = (u = (a = N.options) == null ? void 0 : a.integrations) == null ? void 0 : u.amplitude) != null && c.disabled || (s = window.amplitude) != null && s.getInstance && window.amplitude.getInstance().logEvent(t, U(I({}, e), {
        highlightSessionURL: h
      })), (d = (f = (l = N.options) == null ? void 0 : l.integrations) == null ? void 0 : f.intercom) != null && d.disabled || window.Intercom && window.Intercom("trackEvent", t, e);
    } catch (h) {
      j("track", h);
    }
  },
  start: (t) => {
    (O == null ? void 0 : O.state) === "Recording" && !(t != null && t.forceNew) ? t != null && t.silent || console.warn(
      "Highlight is already recording. Please `H.stop()` the current session before starting a new one."
    ) : (Ke.startListening(), N.onHighlightReady(
      () => z(void 0, null, function* () {
        yield O.initialize(t);
      }),
      { waitForReady: !1 }
    ));
  },
  stop: (t) => {
    (O == null ? void 0 : O.state) !== "Recording" ? t != null && t.silent || console.warn(
      "Highlight is already stopped. Please call `H.start()`."
    ) : N.onHighlightReady(() => O.stopRecording(!0));
  },
  identify: (t, e = {}, r) => {
    var n, i, o, a, u, c, s, l;
    try {
      N.onHighlightReady(
        () => O.identify(t, e, r)
      );
    } catch (f) {
      j("identify", f);
    }
    if ((o = (i = (n = N.options) == null ? void 0 : n.integrations) == null ? void 0 : i.mixpanel) != null && o.disabled || (a = window.mixpanel) != null && a.identify && (window.mixpanel.identify(
      typeof (e == null ? void 0 : e.email) == "string" ? e == null ? void 0 : e.email : t
    ), e && (window.mixpanel.track("identify", e), window.mixpanel.people.set(e))), !((s = (c = (u = N.options) == null ? void 0 : u.integrations) == null ? void 0 : c.amplitude) != null && s.disabled) && (l = window.amplitude) != null && l.getInstance && (window.amplitude.getInstance().setUserId(t), Object.keys(e).length > 0)) {
      const f = Object.keys(
        e
      ).reduce((d, h) => (d.set(h, e[h]), d), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(f);
    }
  },
  metrics: (t) => {
    try {
      for (const e of t)
        N.recordMetric(e);
    } catch (e) {
      j("metrics", e);
    }
  },
  recordMetric: (t) => {
    try {
      N.onHighlightReady(() => {
        var e;
        O.recordGauge(U(I({}, t), {
          tags: (e = t.tags) != null ? e : [],
          group: window.location.href,
          category: "Frontend"
          /* Frontend */
        }));
      });
    } catch (e) {
      j("recordMetric", e);
    }
  },
  recordCount: (t) => {
    try {
      N.onHighlightReady(() => {
        O.recordCount(t);
      });
    } catch (e) {
      j("recordCount", e);
    }
  },
  recordIncr: (t) => {
    try {
      N.onHighlightReady(() => {
        O.recordIncr(t);
      });
    } catch (e) {
      j("recordIncr", e);
    }
  },
  recordHistogram: (t) => {
    try {
      N.onHighlightReady(() => {
        O.recordHistogram(t);
      });
    } catch (e) {
      j("recordHistogram", e);
    }
  },
  recordUpDownCounter: (t) => {
    try {
      N.onHighlightReady(() => {
        O.recordUpDownCounter(t);
      });
    } catch (e) {
      j("recordUpDownCounter", e);
    }
  },
  startSpan: (t, e, r, n) => {
    const i = typeof qe == "function" ? qe() : void 0;
    if (!i) {
      const a = Zi();
      return n === void 0 && r === void 0 ? e(a) : n === void 0 ? r(a) : n(a);
    }
    const o = (a, u) => {
      const c = u(a);
      return c instanceof Promise ? c.finally(() => a.end()) : (a.end(), c);
    };
    return n === void 0 && r === void 0 ? i.startActiveSpan(
      t,
      (a) => o(a, e)
    ) : n === void 0 ? i.startActiveSpan(
      t,
      e,
      (a) => o(a, r)
    ) : i.startActiveSpan(
      t,
      e,
      r,
      (a) => o(a, n)
    );
  },
  startManualSpan: (t, e, r, n) => {
    const i = typeof qe == "function" ? qe() : void 0;
    if (!i) {
      const o = Zi();
      return n === void 0 && r === void 0 ? e(o) : n === void 0 ? r(o) : n(o);
    }
    return n === void 0 && r === void 0 ? i.startActiveSpan(t, e) : n === void 0 ? i.startActiveSpan(
      t,
      e,
      r
    ) : i.startActiveSpan(
      t,
      e,
      r,
      n
    );
  },
  getSessionURL: () => new Promise((t, e) => {
    N.onHighlightReady(() => {
      const r = O.sessionData.sessionSecureID, n = Rr(r);
      n ? t(
        `https://${hh}/${n.projectID}/sessions/${r}`
      ) : e(new Error(`Unable to get session URL: ${r}`));
    });
  }),
  getSessionDetails: () => new Promise((t, e) => {
    N.onHighlightReady(() => z(void 0, null, function* () {
      try {
        const r = yield N.getSessionURL();
        if (!r)
          throw new Error("Could not get session URL");
        const n = O.sessionData.sessionSecureID, i = Rr(n), o = i == null ? void 0 : i.sessionStartTime;
        if (!o)
          throw new Error("Could not get session start timestamp");
        const a = (/* @__PURE__ */ new Date()).getTime(), u = new URL(r), c = new URL(r);
        c.searchParams.set(
          "ts",
          ((a - o) / 1e3).toString()
        ), t({
          url: u.toString(),
          urlWithTimestamp: c.toString(),
          sessionSecureID: n
        });
      } catch (r) {
        e(r);
      }
    }));
  }),
  getRecordingState: () => {
    var t;
    return (t = O == null ? void 0 : O.state) != null ? t : "NotRecording";
  },
  onHighlightReady: (t, e) => {
    if (O && O.ready) {
      t();
      return;
    }
    if (Ye.push({ options: e, func: t }), kt !== void 0)
      return;
    const r = () => {
      Ye = Ye.filter((i) => {
        var o;
        return !O || ((o = i.options) == null ? void 0 : o.waitForReady) !== !1 && !O.ready ? !0 : (i.func(), !1);
      }), kt = void 0, Ye.length > 0 && (kt = setTimeout(
        r,
        gg
      ));
    };
    r();
  },
  registerLD(t) {
    N.onHighlightReady(() => {
      O.registerLD(t);
    }), vg(this, t);
  }
};
typeof window != "undefined" && (window.H = N);
ag();
ln();
fn();
const Ug = {
  reset: () => {
    hn = !1, O = void 0, Ye = [], kt = void 0, Ke = void 0;
  },
  setHighlightObj: (t) => {
    O = t;
  }
};
export {
  Cg as A,
  Pg as B,
  tt as C,
  Mg as D,
  N as E,
  Pn as F,
  tg as G,
  hh as H,
  kg as I,
  E as K,
  Dg as L,
  Ja as M,
  Gd as Q,
  ht as S,
  Rg as V,
  Ug as _,
  aa as a,
  fh as b,
  no as c,
  br as d,
  la as e,
  Rr as f,
  io as g,
  mg as h,
  Tg as i,
  Fr as j,
  wh as k,
  Oh as l,
  Lg as m,
  wg as n,
  Qv as o,
  Sg as p,
  xg as q,
  mh as r,
  fa as s,
  Og as t,
  bg as u,
  Dt as v,
  yh as w,
  Ag as x,
  Ng as y,
  Ig as z
};
//# sourceMappingURL=index-Dr0UbBka.js.map
